/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.7.0 (NJsonSchema v10.6.7.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAuditHeaderByFilter(body: GetAllAuditHeaderByFilterModel | undefined): Promise<GetAllAuditHeaderByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAuditById(body: GetAuditByIdModel | undefined): Promise<GetAuditByIdQueryResponse>;
    /**
     * @return Success
     */
    getBanner(): Promise<GetBannerImageCommandResponse>;
    /**
     * @param projectId (optional) 
     * @param amount (optional) 
     * @return Success
     */
    addToCart(projectId: string | undefined, amount: number | undefined): Promise<AddToCartResponse>;
    /**
     * @return Success
     */
    getNumberOfCartItems(): Promise<GetNumberOfCartItemsResponse>;
    /**
     * @return Success
     */
    getBasicCart(): Promise<GetBasicCartQueryResponse>;
    /**
     * @return Success
     */
    getFullCart(): Promise<GetFullCartQueryResponse>;
    /**
     * @param projectId (optional) 
     * @return Success
     */
    removeFromCart(projectId: string | undefined): Promise<RemoveFromCartResponse>;
    /**
     * @return Success
     */
    getCompanyByIdForEntrepreneur(id: string): Promise<GetCompanyByIdForEntrepreneurResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editCompany(body: EditCompanyModel | undefined): Promise<Unit>;
    /**
     * @return Success
     */
    getMyCompanyProfile(): Promise<GetMyCompanyProfileQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    reachOut(body: ContactUsCommandRequest | undefined): Promise<void>;
    /**
     * @return Success
     */
    file(id: string, name: string): Promise<GetFileByIdQueryResponse>;
    /**
     * @return Success
     */
    exportPledge(): Promise<ExportPledgesResponse>;
    /**
     * @return Success
     */
    receiptAdmin(id: string): Promise<GetFileByIdQueryResponse>;
    /**
     * @return Success
     */
    receiptInvestor(id: string): Promise<GetFileByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllNewsByFilter(body: GetAllNewsByFilterQueryRequest | undefined): Promise<GetAllNewsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getNewsById(body: GetNewsByIdQueryRequest | undefined): Promise<GetNewsByIdQueryResponse>;
    /**
     * @param userId (optional) 
     * @param items (optional) 
     * @return Success
     */
    finalizeCart(userId: string | undefined, items: PaymentDetailModel[] | undefined): Promise<FinalizeCartResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changePledgeStatus(body: ChangePledgeModel | undefined): Promise<UpdatePledgeStatusQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    makeCardPayment(body: CardPaymentModel | undefined): Promise<TestPaymentResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    pledge(body: PledgeModel | undefined): Promise<TestPaymentResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    makeUnverifiedCardPayment(body: CardPaymentModel | undefined): Promise<MakeUnverifiedCreditCardPaymentCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    beginCreditCardPayment(body: CardPaymentModel | undefined): Promise<BeginCreditCardPaymentCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    beginPaypalPayment(body: BeginPayPalPaymentModel | undefined): Promise<BeginPaypalPaymentCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    executePaypalPayment(body: ExcutePaypalPaymentModel | undefined): Promise<ExecutePaypalResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    beginFygaroPayment(body: BeginFygarolPaymentModel | undefined): Promise<BeginFygaroPaymentCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    beginGuestFygaroPayment(body: BeginGuestFygarolPaymentModel | undefined): Promise<BeginGuestFygaroPaymentCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requireAdditionalDetailsForPayment(body: string | undefined): Promise<RequireAdditionalDetailsForPaymentResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fygaroPaymentAPI(body: FygaroPaymentAPIModel | undefined): Promise<BeginFygaroPaymentCommandResponse>;
    /**
     * @return Success
     */
    getPaymentConfiguration(): Promise<GetPaymentConfigurationQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerCard(body: CardRegistrationModel | undefined): Promise<RegisterCardResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    verifyCard(body: CardRegistrationModel | undefined): Promise<VerifyCardResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    isCardRegistered(body: CardRegistrationModel | undefined): Promise<IsCardRegisteredResponse>;
    /**
     * @param merID (optional) 
     * @param acqID (optional) 
     * @param orderID (optional) 
     * @param responseCode (optional) 
     * @param reasonCode (optional) 
     * @param reasonCodeDesc (optional) 
     * @param referenceNo (optional) 
     * @param paddedCardNo (optional) 
     * @param authCode (optional) 
     * @param cVV2Result (optional) 
     * @param shipToFirstName (optional) 
     * @param shipToLastName (optional) 
     * @param shipToAddress1 (optional) 
     * @param shipToAddress2 (optional) 
     * @param shipToCity (optional) 
     * @param shipToState (optional) 
     * @param shipToCountry (optional) 
     * @param shipToTelephone (optional) 
     * @param shipToEMail (optional) 
     * @param billToFirstName (optional) 
     * @param billToLastName (optional) 
     * @param billToAddress1 (optional) 
     * @param billToAddress2 (optional) 
     * @param billToCity (optional) 
     * @param billToState (optional) 
     * @param billToCountry (optional) 
     * @param billToTelephone (optional) 
     * @param billToEMail (optional) 
     * @param originalResponseCode (optional) 
     * @param signature (optional) 
     * @param signatureMethod (optional) 
     * @return Success
     */
    verify3d(merID: string | undefined, acqID: string | undefined, orderID: string | undefined, responseCode: string | undefined, reasonCode: string | undefined, reasonCodeDesc: string | undefined, referenceNo: string | undefined, paddedCardNo: string | undefined, authCode: string | undefined, cVV2Result: string | undefined, shipToFirstName: string | undefined, shipToLastName: string | undefined, shipToAddress1: string | undefined, shipToAddress2: string | undefined, shipToCity: string | undefined, shipToState: string | undefined, shipToCountry: string | undefined, shipToTelephone: string | undefined, shipToEMail: string | undefined, billToFirstName: string | undefined, billToLastName: string | undefined, billToAddress1: string | undefined, billToAddress2: string | undefined, billToCity: string | undefined, billToState: string | undefined, billToCountry: string | undefined, billToTelephone: string | undefined, billToEMail: string | undefined, originalResponseCode: string | undefined, signature: string | undefined, signatureMethod: string | undefined): Promise<CardinalSecureAuthenticateResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentsListByFilter(body: GetPaymentsByFilterQueryRequest | undefined): Promise<GetPaymentsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentsListByFilterForInvestor(body: GetPaymentsByFilterForInvestorQueryRequest | undefined): Promise<GetPaymentsByFilterForInvestorQueryResponse>;
    /**
     * @return Success
     */
    getPaymentDetails(id: string): Promise<GetPaymentDetailsQueryResponse>;
    /**
     * @param id (optional) 
     * @return Success
     */
    checkPaymentStatus(id: string | undefined): Promise<CheckPaymentStatusQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getDonationsListByFilter(body: GetDonationsByFilterQueryRequest | undefined): Promise<GetDonationsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPledgesListByFilter(body: GetPledgesByFilterQueryRequest | undefined): Promise<GetPledgesByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getDonationsListByFilterForCompany(id: string, body: GetDonationsByFilterForCompanyQueryRequest | undefined): Promise<GetDonationsByFilterForCompanyQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getDonationsListByFilterForInvestor(id: string, body: GetDonationsByFilterForInvestorQueryRequest | undefined): Promise<GetDonationsByFilterForInvestorQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getOrderReceiptForInvestor(body: GetOrderReceiptForInvestorQueryRequest | undefined): Promise<ReceiptModel>;
    /**
     * @return Success
     */
    getPaymentConfigs(): Promise<PaymentConfigRequest>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPublicProjectListByFilter(body: GetProjectListByFilterForPublicRequest | undefined): Promise<GetProjectListByFilterForPublicResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectHistoryListByFilter(body: GetProjectHistoryListByFilterQueryRequest | undefined): Promise<GetProjectHistoryListByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectsByFilterForAdmin(body: GetProjectsByFilterForAdminQueryRequest | undefined): Promise<GetProjectsByFilterForAdminQueryResponse>;
    /**
     * @return Success
     */
    getProjectByIdForAdmin(id: string): Promise<GetProjectByIdForAdminQueryResponse>;
    /**
     * @return Success
     */
    getProjectByIdForEntrepreneur(id: string): Promise<GetProjectByIdForEntrepreneurQueryResponse>;
    /**
     * @return Success
     */
    getProjectByIdForPublic(id: string): Promise<GetProjectByIdForPublicQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectDetailById(id: string, body: GetProjectDetailByIdQueryRequest | undefined): Promise<GetProjectDetailByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectsForCompany(body: GetProjectsForCompanyQueryRequest | undefined): Promise<GetProjectsForCompanyQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getMyProjectsByFilter(body: GetMyProjectsByFilterQueryRequest | undefined): Promise<GetMyProjectsByFilterQueryResponse>;
    /**
     * @return Success
     */
    getProjectsForInvestor(id: string): Promise<GetProjectsForInvestorQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    existsForUser(body: ProjectExistsForUserDTO | undefined): Promise<ProjectExistForUserQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectStatus(body: UpdateProjectStatusCommandRequest | undefined): Promise<UpdateProjectStatusCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    submitProjectForApproval(body: SubmitProjectForApprovalCommandRequest | undefined): Promise<SubmitProjectForApprovalCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createProject(body: CreateProjectModel | undefined): Promise<CreateProjectCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editProject(body: EditProjectModel | undefined): Promise<EditProjectCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    submitProjectUpdateForApproval(body: SubmitProjectUpdateForApprovalCommandRequest | undefined): Promise<SubmitProjectUpdateForApprovalCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    upsertProjectUpdate(body: UpsertProjectUpdateModel | undefined): Promise<UpsertProjectUpdateCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectUpdateDetailsByProjectId(body: GetProjectUpdateDetailsByProjectIdQueryRequest | undefined): Promise<GetProjectUpdateDetailsByProjectIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approveProject(body: ApproveProjectCommandRequest | undefined): Promise<ApproveProjectCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectTrackerInfo(body: GetProjectTrackerInfoQueryRequest | undefined): Promise<GetProjectTrackerInfoQueryResponse>;
    /**
     * @return Success
     */
    refreshIdle(): Promise<GetProjectTrackerInfoQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    references(body: GetReferenceListQueryRequest | undefined): Promise<GetReferenceListQueryResponse>;
    /**
     * @return Success
     */
    getUserAccountTypes(): Promise<{ [key: string]: string; }>;
    /**
     * @return Success
     */
    getIdTypes(): Promise<{ [key: string]: string; }>;
    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInvestorOrEntrepreneurWebModel | undefined): Promise<RegisterInvestorOrEntrepreneurCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerInvestor(body: RegisterInvestorModel | undefined): Promise<RegisterInvestorCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerCompany(body: Body | undefined): Promise<RegisterCompanyCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    confirmRegistration(body: ConfirmRegistrationModel | undefined): Promise<ConfirmRegistrationCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addRole(body: AddRoleModel | undefined): Promise<AddRoleCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editRole(body: EditRoleModel | undefined): Promise<EditRoleCommandResponse>;
    /**
     * @return Success
     */
    getOperations(): Promise<GetOperationsListCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllRolesByFilter(body: GetAllRolesByFilterModel | undefined): Promise<GetAllRolesByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getRoleById(body: GetRoleByIdModel | undefined): Promise<GetRoleByIdQueryResponse>;
    /**
     * @return Success
     */
    weatherForecasts(): Promise<WeatherForecast[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    register2(body: RegistrationModel | undefined): Promise<RegisterUserCommandResponse>;
    /**
     * @return Success
     */
    logout(): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined): Promise<LoginCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    refresh(body: RefreshTokenDto | undefined): Promise<RefreshTokenCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    validateRecaptcha(body: RecaptchaModel | undefined): Promise<ValidateRecaptchaCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getRoles(body: GetRolesModel | undefined): Promise<GetRolesCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editUser(body: EditUserModel | undefined): Promise<EditUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addUser(body: AddUserModel | undefined): Promise<AddUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUsersByFilter(body: GetAllUsersByFilterModel | undefined): Promise<GetAllUsersByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestPasswordReset(body: RequestPasswordResetCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUserById(body: GetUserByIdModel | undefined): Promise<GetUserByIdQueryResponse>;
    /**
     * @return Success
     */
    getUserProfileById(id: string): Promise<GetUserProfileByIdQueryResponse>;
    /**
     * @return Success
     */
    getMyUserProfile(): Promise<GetUserProfileByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserStatus(body: ChangeUserStatusCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editUserProfile(body: SimpleUserProfile | undefined): Promise<Unit>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resendMyActivationEmail(body: ResendMyActivationEmailCommandRequest | undefined): Promise<ResendMyActivationEmailCommandResponse>;
}

export class Client implements IClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAuditHeaderByFilter(body: GetAllAuditHeaderByFilterModel | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllAuditHeaderByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/AuditManagement/GetAllAuditHeaderByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAuditHeaderByFilter(_response);
        });
    }

    protected processGetAllAuditHeaderByFilter(response: AxiosResponse): Promise<GetAllAuditHeaderByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllAuditHeaderByFilterQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetAllAuditHeaderByFilterQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllAuditHeaderByFilterQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuditById(body: GetAuditByIdModel | undefined , cancelToken?: CancelToken | undefined): Promise<GetAuditByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/AuditManagement/GetAuditById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditById(_response);
        });
    }

    protected processGetAuditById(response: AxiosResponse): Promise<GetAuditByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAuditByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetAuditByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuditByIdQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBanner(  cancelToken?: CancelToken | undefined): Promise<GetBannerImageCommandResponse> {
        let url_ = this.baseUrl + "/api/Banner/GetBanner";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBanner(_response);
        });
    }

    protected processGetBanner(response: AxiosResponse): Promise<GetBannerImageCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBannerImageCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetBannerImageCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBannerImageCommandResponse>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param amount (optional) 
     * @return Success
     */
    addToCart(projectId: string | undefined, amount: number | undefined , cancelToken?: CancelToken | undefined): Promise<AddToCartResponse> {
        let url_ = this.baseUrl + "/api/Cart/AddToCart?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToCart(_response);
        });
    }

    protected processAddToCart(response: AxiosResponse): Promise<AddToCartResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddToCartResponse.fromJS(resultData200);
            return Promise.resolve<AddToCartResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddToCartResponse>(null as any);
    }

    /**
     * @return Success
     */
    getNumberOfCartItems(  cancelToken?: CancelToken | undefined): Promise<GetNumberOfCartItemsResponse> {
        let url_ = this.baseUrl + "/api/Cart/GetNumberOfCartItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNumberOfCartItems(_response);
        });
    }

    protected processGetNumberOfCartItems(response: AxiosResponse): Promise<GetNumberOfCartItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNumberOfCartItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetNumberOfCartItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNumberOfCartItemsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBasicCart(  cancelToken?: CancelToken | undefined): Promise<GetBasicCartQueryResponse> {
        let url_ = this.baseUrl + "/api/Cart/GetBasicCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicCart(_response);
        });
    }

    protected processGetBasicCart(response: AxiosResponse): Promise<GetBasicCartQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBasicCartQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetBasicCartQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBasicCartQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFullCart(  cancelToken?: CancelToken | undefined): Promise<GetFullCartQueryResponse> {
        let url_ = this.baseUrl + "/api/Cart/GetFullCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFullCart(_response);
        });
    }

    protected processGetFullCart(response: AxiosResponse): Promise<GetFullCartQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFullCartQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetFullCartQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFullCartQueryResponse>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    removeFromCart(projectId: string | undefined , cancelToken?: CancelToken | undefined): Promise<RemoveFromCartResponse> {
        let url_ = this.baseUrl + "/api/Cart/RemoveFromCart?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromCart(_response);
        });
    }

    protected processRemoveFromCart(response: AxiosResponse): Promise<RemoveFromCartResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveFromCartResponse.fromJS(resultData200);
            return Promise.resolve<RemoveFromCartResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveFromCartResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCompanyByIdForEntrepreneur(id: string , cancelToken?: CancelToken | undefined): Promise<GetCompanyByIdForEntrepreneurResponse> {
        let url_ = this.baseUrl + "/api/Company/GetCompanyByIdForEntrepreneur/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyByIdForEntrepreneur(_response);
        });
    }

    protected processGetCompanyByIdForEntrepreneur(response: AxiosResponse): Promise<GetCompanyByIdForEntrepreneurResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCompanyByIdForEntrepreneurResponse.fromJS(resultData200);
            return Promise.resolve<GetCompanyByIdForEntrepreneurResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCompanyByIdForEntrepreneurResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCompany(body: EditCompanyModel | undefined , cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/Company/EditCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditCompany(_response);
        });
    }

    protected processEditCompany(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    /**
     * @return Success
     */
    getMyCompanyProfile(  cancelToken?: CancelToken | undefined): Promise<GetMyCompanyProfileQueryResponse> {
        let url_ = this.baseUrl + "/api/Company/GetMyCompanyProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyCompanyProfile(_response);
        });
    }

    protected processGetMyCompanyProfile(response: AxiosResponse): Promise<GetMyCompanyProfileQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyCompanyProfileQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetMyCompanyProfileQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyCompanyProfileQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reachOut(body: ContactUsCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ContactUs/ReachOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReachOut(_response);
        });
    }

    protected processReachOut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    file(id: string, name: string , cancelToken?: CancelToken | undefined): Promise<GetFileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/File/{id}/{name}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFile(_response);
        });
    }

    protected processFile(response: AxiosResponse): Promise<GetFileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetFileByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileByIdQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    exportPledge(  cancelToken?: CancelToken | undefined): Promise<ExportPledgesResponse> {
        let url_ = this.baseUrl + "/api/File/export-pledge";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPledge(_response);
        });
    }

    protected processExportPledge(response: AxiosResponse): Promise<ExportPledgesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportPledgesResponse.fromJS(resultData200);
            return Promise.resolve<ExportPledgesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportPledgesResponse>(null as any);
    }

    /**
     * @return Success
     */
    receiptAdmin(id: string , cancelToken?: CancelToken | undefined): Promise<GetFileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/File/receipt-admin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReceiptAdmin(_response);
        });
    }

    protected processReceiptAdmin(response: AxiosResponse): Promise<GetFileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetFileByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileByIdQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    receiptInvestor(id: string , cancelToken?: CancelToken | undefined): Promise<GetFileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/File/receipt-investor/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReceiptInvestor(_response);
        });
    }

    protected processReceiptInvestor(response: AxiosResponse): Promise<GetFileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetFileByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileByIdQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllNewsByFilter(body: GetAllNewsByFilterQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllNewsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/NewsManagement/GetAllNewsByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllNewsByFilter(_response);
        });
    }

    protected processGetAllNewsByFilter(response: AxiosResponse): Promise<GetAllNewsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllNewsByFilterQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetAllNewsByFilterQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllNewsByFilterQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getNewsById(body: GetNewsByIdQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetNewsByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/NewsManagement/GetNewsById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsById(_response);
        });
    }

    protected processGetNewsById(response: AxiosResponse): Promise<GetNewsByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNewsByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetNewsByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNewsByIdQueryResponse>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param items (optional) 
     * @return Success
     */
    finalizeCart(userId: string | undefined, items: PaymentDetailModel[] | undefined , cancelToken?: CancelToken | undefined): Promise<FinalizeCartResponse> {
        let url_ = this.baseUrl + "/api/Payment/FinalizeCart?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (items === null || items === undefined)
            throw new Error("The parameter 'items' cannot be null.");
        else
            items.forEach(item_ => content_.append("items", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinalizeCart(_response);
        });
    }

    protected processFinalizeCart(response: AxiosResponse): Promise<FinalizeCartResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FinalizeCartResponse.fromJS(resultData200);
            return Promise.resolve<FinalizeCartResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinalizeCartResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePledgeStatus(body: ChangePledgeModel | undefined , cancelToken?: CancelToken | undefined): Promise<UpdatePledgeStatusQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/ChangePledgeStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePledgeStatus(_response);
        });
    }

    protected processChangePledgeStatus(response: AxiosResponse): Promise<UpdatePledgeStatusQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdatePledgeStatusQueryResponse.fromJS(resultData200);
            return Promise.resolve<UpdatePledgeStatusQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdatePledgeStatusQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    makeCardPayment(body: CardPaymentModel | undefined , cancelToken?: CancelToken | undefined): Promise<TestPaymentResponse> {
        let url_ = this.baseUrl + "/api/Payment/MakeCardPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMakeCardPayment(_response);
        });
    }

    protected processMakeCardPayment(response: AxiosResponse): Promise<TestPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TestPaymentResponse.fromJS(resultData200);
            return Promise.resolve<TestPaymentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestPaymentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pledge(body: PledgeModel | undefined , cancelToken?: CancelToken | undefined): Promise<TestPaymentResponse> {
        let url_ = this.baseUrl + "/api/Payment/Pledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPledge(_response);
        });
    }

    protected processPledge(response: AxiosResponse): Promise<TestPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TestPaymentResponse.fromJS(resultData200);
            return Promise.resolve<TestPaymentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestPaymentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    makeUnverifiedCardPayment(body: CardPaymentModel | undefined , cancelToken?: CancelToken | undefined): Promise<MakeUnverifiedCreditCardPaymentCommandResponse> {
        let url_ = this.baseUrl + "/api/Payment/MakeUnverifiedCardPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMakeUnverifiedCardPayment(_response);
        });
    }

    protected processMakeUnverifiedCardPayment(response: AxiosResponse): Promise<MakeUnverifiedCreditCardPaymentCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MakeUnverifiedCreditCardPaymentCommandResponse.fromJS(resultData200);
            return Promise.resolve<MakeUnverifiedCreditCardPaymentCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MakeUnverifiedCreditCardPaymentCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    beginCreditCardPayment(body: CardPaymentModel | undefined , cancelToken?: CancelToken | undefined): Promise<BeginCreditCardPaymentCommandResponse> {
        let url_ = this.baseUrl + "/api/Payment/BeginCreditCardPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBeginCreditCardPayment(_response);
        });
    }

    protected processBeginCreditCardPayment(response: AxiosResponse): Promise<BeginCreditCardPaymentCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BeginCreditCardPaymentCommandResponse.fromJS(resultData200);
            return Promise.resolve<BeginCreditCardPaymentCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BeginCreditCardPaymentCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    beginPaypalPayment(body: BeginPayPalPaymentModel | undefined , cancelToken?: CancelToken | undefined): Promise<BeginPaypalPaymentCommandResponse> {
        let url_ = this.baseUrl + "/api/Payment/BeginPaypalPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBeginPaypalPayment(_response);
        });
    }

    protected processBeginPaypalPayment(response: AxiosResponse): Promise<BeginPaypalPaymentCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BeginPaypalPaymentCommandResponse.fromJS(resultData200);
            return Promise.resolve<BeginPaypalPaymentCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BeginPaypalPaymentCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    executePaypalPayment(body: ExcutePaypalPaymentModel | undefined , cancelToken?: CancelToken | undefined): Promise<ExecutePaypalResponse> {
        let url_ = this.baseUrl + "/api/Payment/ExecutePaypalPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecutePaypalPayment(_response);
        });
    }

    protected processExecutePaypalPayment(response: AxiosResponse): Promise<ExecutePaypalResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExecutePaypalResponse.fromJS(resultData200);
            return Promise.resolve<ExecutePaypalResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExecutePaypalResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    beginFygaroPayment(body: BeginFygarolPaymentModel | undefined , cancelToken?: CancelToken | undefined): Promise<BeginFygaroPaymentCommandResponse> {
        let url_ = this.baseUrl + "/api/Payment/BeginFygaroPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBeginFygaroPayment(_response);
        });
    }

    protected processBeginFygaroPayment(response: AxiosResponse): Promise<BeginFygaroPaymentCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BeginFygaroPaymentCommandResponse.fromJS(resultData200);
            return Promise.resolve<BeginFygaroPaymentCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BeginFygaroPaymentCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    beginGuestFygaroPayment(body: BeginGuestFygarolPaymentModel | undefined , cancelToken?: CancelToken | undefined): Promise<BeginGuestFygaroPaymentCommandResponse> {
        let url_ = this.baseUrl + "/api/Payment/BeginGuestFygaroPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBeginGuestFygaroPayment(_response);
        });
    }

    protected processBeginGuestFygaroPayment(response: AxiosResponse): Promise<BeginGuestFygaroPaymentCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BeginGuestFygaroPaymentCommandResponse.fromJS(resultData200);
            return Promise.resolve<BeginGuestFygaroPaymentCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BeginGuestFygaroPaymentCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requireAdditionalDetailsForPayment(body: string | undefined , cancelToken?: CancelToken | undefined): Promise<RequireAdditionalDetailsForPaymentResponse> {
        let url_ = this.baseUrl + "/api/Payment/RequireAdditionalDetailsForPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequireAdditionalDetailsForPayment(_response);
        });
    }

    protected processRequireAdditionalDetailsForPayment(response: AxiosResponse): Promise<RequireAdditionalDetailsForPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequireAdditionalDetailsForPaymentResponse.fromJS(resultData200);
            return Promise.resolve<RequireAdditionalDetailsForPaymentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequireAdditionalDetailsForPaymentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fygaroPaymentAPI(body: FygaroPaymentAPIModel | undefined , cancelToken?: CancelToken | undefined): Promise<BeginFygaroPaymentCommandResponse> {
        let url_ = this.baseUrl + "/api/Payment/FygaroPaymentAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFygaroPaymentAPI(_response);
        });
    }

    protected processFygaroPaymentAPI(response: AxiosResponse): Promise<BeginFygaroPaymentCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BeginFygaroPaymentCommandResponse.fromJS(resultData200);
            return Promise.resolve<BeginFygaroPaymentCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BeginFygaroPaymentCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPaymentConfiguration(  cancelToken?: CancelToken | undefined): Promise<GetPaymentConfigurationQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/GetPaymentConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentConfiguration(_response);
        });
    }

    protected processGetPaymentConfiguration(response: AxiosResponse): Promise<GetPaymentConfigurationQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPaymentConfigurationQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetPaymentConfigurationQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPaymentConfigurationQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerCard(body: CardRegistrationModel | undefined , cancelToken?: CancelToken | undefined): Promise<RegisterCardResponse> {
        let url_ = this.baseUrl + "/api/Payment/RegisterCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterCard(_response);
        });
    }

    protected processRegisterCard(response: AxiosResponse): Promise<RegisterCardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterCardResponse.fromJS(resultData200);
            return Promise.resolve<RegisterCardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterCardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyCard(body: CardRegistrationModel | undefined , cancelToken?: CancelToken | undefined): Promise<VerifyCardResponse> {
        let url_ = this.baseUrl + "/api/Payment/VerifyCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyCard(_response);
        });
    }

    protected processVerifyCard(response: AxiosResponse): Promise<VerifyCardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerifyCardResponse.fromJS(resultData200);
            return Promise.resolve<VerifyCardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerifyCardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isCardRegistered(body: CardRegistrationModel | undefined , cancelToken?: CancelToken | undefined): Promise<IsCardRegisteredResponse> {
        let url_ = this.baseUrl + "/api/Payment/IsCardRegistered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsCardRegistered(_response);
        });
    }

    protected processIsCardRegistered(response: AxiosResponse): Promise<IsCardRegisteredResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsCardRegisteredResponse.fromJS(resultData200);
            return Promise.resolve<IsCardRegisteredResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsCardRegisteredResponse>(null as any);
    }

    /**
     * @param merID (optional) 
     * @param acqID (optional) 
     * @param orderID (optional) 
     * @param responseCode (optional) 
     * @param reasonCode (optional) 
     * @param reasonCodeDesc (optional) 
     * @param referenceNo (optional) 
     * @param paddedCardNo (optional) 
     * @param authCode (optional) 
     * @param cVV2Result (optional) 
     * @param shipToFirstName (optional) 
     * @param shipToLastName (optional) 
     * @param shipToAddress1 (optional) 
     * @param shipToAddress2 (optional) 
     * @param shipToCity (optional) 
     * @param shipToState (optional) 
     * @param shipToCountry (optional) 
     * @param shipToTelephone (optional) 
     * @param shipToEMail (optional) 
     * @param billToFirstName (optional) 
     * @param billToLastName (optional) 
     * @param billToAddress1 (optional) 
     * @param billToAddress2 (optional) 
     * @param billToCity (optional) 
     * @param billToState (optional) 
     * @param billToCountry (optional) 
     * @param billToTelephone (optional) 
     * @param billToEMail (optional) 
     * @param originalResponseCode (optional) 
     * @param signature (optional) 
     * @param signatureMethod (optional) 
     * @return Success
     */
    verify3d(merID: string | undefined, acqID: string | undefined, orderID: string | undefined, responseCode: string | undefined, reasonCode: string | undefined, reasonCodeDesc: string | undefined, referenceNo: string | undefined, paddedCardNo: string | undefined, authCode: string | undefined, cVV2Result: string | undefined, shipToFirstName: string | undefined, shipToLastName: string | undefined, shipToAddress1: string | undefined, shipToAddress2: string | undefined, shipToCity: string | undefined, shipToState: string | undefined, shipToCountry: string | undefined, shipToTelephone: string | undefined, shipToEMail: string | undefined, billToFirstName: string | undefined, billToLastName: string | undefined, billToAddress1: string | undefined, billToAddress2: string | undefined, billToCity: string | undefined, billToState: string | undefined, billToCountry: string | undefined, billToTelephone: string | undefined, billToEMail: string | undefined, originalResponseCode: string | undefined, signature: string | undefined, signatureMethod: string | undefined , cancelToken?: CancelToken | undefined): Promise<CardinalSecureAuthenticateResponse> {
        let url_ = this.baseUrl + "/api/Payment/Verify3d";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (merID === null || merID === undefined)
            throw new Error("The parameter 'merID' cannot be null.");
        else
            content_.append("MerID", merID.toString());
        if (acqID === null || acqID === undefined)
            throw new Error("The parameter 'acqID' cannot be null.");
        else
            content_.append("AcqID", acqID.toString());
        if (orderID === null || orderID === undefined)
            throw new Error("The parameter 'orderID' cannot be null.");
        else
            content_.append("OrderID", orderID.toString());
        if (responseCode === null || responseCode === undefined)
            throw new Error("The parameter 'responseCode' cannot be null.");
        else
            content_.append("ResponseCode", responseCode.toString());
        if (reasonCode === null || reasonCode === undefined)
            throw new Error("The parameter 'reasonCode' cannot be null.");
        else
            content_.append("ReasonCode", reasonCode.toString());
        if (reasonCodeDesc === null || reasonCodeDesc === undefined)
            throw new Error("The parameter 'reasonCodeDesc' cannot be null.");
        else
            content_.append("ReasonCodeDesc", reasonCodeDesc.toString());
        if (referenceNo === null || referenceNo === undefined)
            throw new Error("The parameter 'referenceNo' cannot be null.");
        else
            content_.append("ReferenceNo", referenceNo.toString());
        if (paddedCardNo === null || paddedCardNo === undefined)
            throw new Error("The parameter 'paddedCardNo' cannot be null.");
        else
            content_.append("PaddedCardNo", paddedCardNo.toString());
        if (authCode === null || authCode === undefined)
            throw new Error("The parameter 'authCode' cannot be null.");
        else
            content_.append("AuthCode", authCode.toString());
        if (cVV2Result === null || cVV2Result === undefined)
            throw new Error("The parameter 'cVV2Result' cannot be null.");
        else
            content_.append("CVV2Result", cVV2Result.toString());
        if (shipToFirstName === null || shipToFirstName === undefined)
            throw new Error("The parameter 'shipToFirstName' cannot be null.");
        else
            content_.append("ShipToFirstName", shipToFirstName.toString());
        if (shipToLastName === null || shipToLastName === undefined)
            throw new Error("The parameter 'shipToLastName' cannot be null.");
        else
            content_.append("ShipToLastName", shipToLastName.toString());
        if (shipToAddress1 === null || shipToAddress1 === undefined)
            throw new Error("The parameter 'shipToAddress1' cannot be null.");
        else
            content_.append("ShipToAddress1", shipToAddress1.toString());
        if (shipToAddress2 === null || shipToAddress2 === undefined)
            throw new Error("The parameter 'shipToAddress2' cannot be null.");
        else
            content_.append("ShipToAddress2", shipToAddress2.toString());
        if (shipToCity === null || shipToCity === undefined)
            throw new Error("The parameter 'shipToCity' cannot be null.");
        else
            content_.append("ShipToCity", shipToCity.toString());
        if (shipToState === null || shipToState === undefined)
            throw new Error("The parameter 'shipToState' cannot be null.");
        else
            content_.append("ShipToState", shipToState.toString());
        if (shipToCountry === null || shipToCountry === undefined)
            throw new Error("The parameter 'shipToCountry' cannot be null.");
        else
            content_.append("ShipToCountry", shipToCountry.toString());
        if (shipToTelephone === null || shipToTelephone === undefined)
            throw new Error("The parameter 'shipToTelephone' cannot be null.");
        else
            content_.append("ShipToTelephone", shipToTelephone.toString());
        if (shipToEMail === null || shipToEMail === undefined)
            throw new Error("The parameter 'shipToEMail' cannot be null.");
        else
            content_.append("ShipToEMail", shipToEMail.toString());
        if (billToFirstName === null || billToFirstName === undefined)
            throw new Error("The parameter 'billToFirstName' cannot be null.");
        else
            content_.append("BillToFirstName", billToFirstName.toString());
        if (billToLastName === null || billToLastName === undefined)
            throw new Error("The parameter 'billToLastName' cannot be null.");
        else
            content_.append("BillToLastName", billToLastName.toString());
        if (billToAddress1 === null || billToAddress1 === undefined)
            throw new Error("The parameter 'billToAddress1' cannot be null.");
        else
            content_.append("BillToAddress1", billToAddress1.toString());
        if (billToAddress2 === null || billToAddress2 === undefined)
            throw new Error("The parameter 'billToAddress2' cannot be null.");
        else
            content_.append("BillToAddress2", billToAddress2.toString());
        if (billToCity === null || billToCity === undefined)
            throw new Error("The parameter 'billToCity' cannot be null.");
        else
            content_.append("BillToCity", billToCity.toString());
        if (billToState === null || billToState === undefined)
            throw new Error("The parameter 'billToState' cannot be null.");
        else
            content_.append("BillToState", billToState.toString());
        if (billToCountry === null || billToCountry === undefined)
            throw new Error("The parameter 'billToCountry' cannot be null.");
        else
            content_.append("BillToCountry", billToCountry.toString());
        if (billToTelephone === null || billToTelephone === undefined)
            throw new Error("The parameter 'billToTelephone' cannot be null.");
        else
            content_.append("BillToTelephone", billToTelephone.toString());
        if (billToEMail === null || billToEMail === undefined)
            throw new Error("The parameter 'billToEMail' cannot be null.");
        else
            content_.append("BillToEMail", billToEMail.toString());
        if (originalResponseCode === null || originalResponseCode === undefined)
            throw new Error("The parameter 'originalResponseCode' cannot be null.");
        else
            content_.append("OriginalResponseCode", originalResponseCode.toString());
        if (signature === null || signature === undefined)
            throw new Error("The parameter 'signature' cannot be null.");
        else
            content_.append("Signature", signature.toString());
        if (signatureMethod === null || signatureMethod === undefined)
            throw new Error("The parameter 'signatureMethod' cannot be null.");
        else
            content_.append("SignatureMethod", signatureMethod.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerify3d(_response);
        });
    }

    protected processVerify3d(response: AxiosResponse): Promise<CardinalSecureAuthenticateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CardinalSecureAuthenticateResponse.fromJS(resultData200);
            return Promise.resolve<CardinalSecureAuthenticateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CardinalSecureAuthenticateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentsListByFilter(body: GetPaymentsByFilterQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetPaymentsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/GetPaymentsListByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentsListByFilter(_response);
        });
    }

    protected processGetPaymentsListByFilter(response: AxiosResponse): Promise<GetPaymentsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPaymentsByFilterQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetPaymentsByFilterQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPaymentsByFilterQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentsListByFilterForInvestor(body: GetPaymentsByFilterForInvestorQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetPaymentsByFilterForInvestorQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/GetPaymentsListByFilterForInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentsListByFilterForInvestor(_response);
        });
    }

    protected processGetPaymentsListByFilterForInvestor(response: AxiosResponse): Promise<GetPaymentsByFilterForInvestorQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPaymentsByFilterForInvestorQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetPaymentsByFilterForInvestorQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPaymentsByFilterForInvestorQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPaymentDetails(id: string , cancelToken?: CancelToken | undefined): Promise<GetPaymentDetailsQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/GetPaymentDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentDetails(_response);
        });
    }

    protected processGetPaymentDetails(response: AxiosResponse): Promise<GetPaymentDetailsQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPaymentDetailsQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetPaymentDetailsQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPaymentDetailsQueryResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    checkPaymentStatus(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<CheckPaymentStatusQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/CheckPaymentStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckPaymentStatus(_response);
        });
    }

    protected processCheckPaymentStatus(response: AxiosResponse): Promise<CheckPaymentStatusQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckPaymentStatusQueryResponse.fromJS(resultData200);
            return Promise.resolve<CheckPaymentStatusQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckPaymentStatusQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDonationsListByFilter(body: GetDonationsByFilterQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetDonationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/GetDonationsListByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDonationsListByFilter(_response);
        });
    }

    protected processGetDonationsListByFilter(response: AxiosResponse): Promise<GetDonationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDonationsByFilterQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetDonationsByFilterQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDonationsByFilterQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPledgesListByFilter(body: GetPledgesByFilterQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetPledgesByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/GetPledgesListByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPledgesListByFilter(_response);
        });
    }

    protected processGetPledgesListByFilter(response: AxiosResponse): Promise<GetPledgesByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPledgesByFilterQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetPledgesByFilterQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPledgesByFilterQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDonationsListByFilterForCompany(id: string, body: GetDonationsByFilterForCompanyQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetDonationsByFilterForCompanyQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/GetDonationsListByFilterForCompany/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDonationsListByFilterForCompany(_response);
        });
    }

    protected processGetDonationsListByFilterForCompany(response: AxiosResponse): Promise<GetDonationsByFilterForCompanyQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDonationsByFilterForCompanyQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetDonationsByFilterForCompanyQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDonationsByFilterForCompanyQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDonationsListByFilterForInvestor(id: string, body: GetDonationsByFilterForInvestorQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetDonationsByFilterForInvestorQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/GetDonationsListByFilterForInvestor/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDonationsListByFilterForInvestor(_response);
        });
    }

    protected processGetDonationsListByFilterForInvestor(response: AxiosResponse): Promise<GetDonationsByFilterForInvestorQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDonationsByFilterForInvestorQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetDonationsByFilterForInvestorQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDonationsByFilterForInvestorQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOrderReceiptForInvestor(body: GetOrderReceiptForInvestorQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ReceiptModel> {
        let url_ = this.baseUrl + "/api/Payment/GetOrderReceiptForInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderReceiptForInvestor(_response);
        });
    }

    protected processGetOrderReceiptForInvestor(response: AxiosResponse): Promise<ReceiptModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReceiptModel.fromJS(resultData200);
            return Promise.resolve<ReceiptModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReceiptModel>(null as any);
    }

    /**
     * @return Success
     */
    getPaymentConfigs(  cancelToken?: CancelToken | undefined): Promise<PaymentConfigRequest> {
        let url_ = this.baseUrl + "/api/Payment/GetPaymentConfigs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentConfigs(_response);
        });
    }

    protected processGetPaymentConfigs(response: AxiosResponse): Promise<PaymentConfigRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentConfigRequest.fromJS(resultData200);
            return Promise.resolve<PaymentConfigRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentConfigRequest>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPublicProjectListByFilter(body: GetProjectListByFilterForPublicRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetProjectListByFilterForPublicResponse> {
        let url_ = this.baseUrl + "/api/Project/GetPublicProjectListByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicProjectListByFilter(_response);
        });
    }

    protected processGetPublicProjectListByFilter(response: AxiosResponse): Promise<GetProjectListByFilterForPublicResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectListByFilterForPublicResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectListByFilterForPublicResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectListByFilterForPublicResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectHistoryListByFilter(body: GetProjectHistoryListByFilterQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetProjectHistoryListByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectHistoryListByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectHistoryListByFilter(_response);
        });
    }

    protected processGetProjectHistoryListByFilter(response: AxiosResponse): Promise<GetProjectHistoryListByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectHistoryListByFilterQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectHistoryListByFilterQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectHistoryListByFilterQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectsByFilterForAdmin(body: GetProjectsByFilterForAdminQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetProjectsByFilterForAdminQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectsByFilterForAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsByFilterForAdmin(_response);
        });
    }

    protected processGetProjectsByFilterForAdmin(response: AxiosResponse): Promise<GetProjectsByFilterForAdminQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectsByFilterForAdminQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectsByFilterForAdminQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsByFilterForAdminQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectByIdForAdmin(id: string , cancelToken?: CancelToken | undefined): Promise<GetProjectByIdForAdminQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectByIdForAdmin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectByIdForAdmin(_response);
        });
    }

    protected processGetProjectByIdForAdmin(response: AxiosResponse): Promise<GetProjectByIdForAdminQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectByIdForAdminQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectByIdForAdminQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectByIdForAdminQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectByIdForEntrepreneur(id: string , cancelToken?: CancelToken | undefined): Promise<GetProjectByIdForEntrepreneurQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectByIdForEntrepreneur/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectByIdForEntrepreneur(_response);
        });
    }

    protected processGetProjectByIdForEntrepreneur(response: AxiosResponse): Promise<GetProjectByIdForEntrepreneurQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectByIdForEntrepreneurQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectByIdForEntrepreneurQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectByIdForEntrepreneurQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectByIdForPublic(id: string , cancelToken?: CancelToken | undefined): Promise<GetProjectByIdForPublicQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectByIdForPublic/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectByIdForPublic(_response);
        });
    }

    protected processGetProjectByIdForPublic(response: AxiosResponse): Promise<GetProjectByIdForPublicQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectByIdForPublicQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectByIdForPublicQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectByIdForPublicQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectDetailById(id: string, body: GetProjectDetailByIdQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetProjectDetailByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectDetailById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectDetailById(_response);
        });
    }

    protected processGetProjectDetailById(response: AxiosResponse): Promise<GetProjectDetailByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectDetailByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectDetailByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectDetailByIdQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectsForCompany(body: GetProjectsForCompanyQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetProjectsForCompanyQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectsForCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsForCompany(_response);
        });
    }

    protected processGetProjectsForCompany(response: AxiosResponse): Promise<GetProjectsForCompanyQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectsForCompanyQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectsForCompanyQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsForCompanyQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMyProjectsByFilter(body: GetMyProjectsByFilterQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetMyProjectsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetMyProjectsByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyProjectsByFilter(_response);
        });
    }

    protected processGetMyProjectsByFilter(response: AxiosResponse): Promise<GetMyProjectsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyProjectsByFilterQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetMyProjectsByFilterQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyProjectsByFilterQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectsForInvestor(id: string , cancelToken?: CancelToken | undefined): Promise<GetProjectsForInvestorQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectsForInvestor/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsForInvestor(_response);
        });
    }

    protected processGetProjectsForInvestor(response: AxiosResponse): Promise<GetProjectsForInvestorQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectsForInvestorQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectsForInvestorQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsForInvestorQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    existsForUser(body: ProjectExistsForUserDTO | undefined , cancelToken?: CancelToken | undefined): Promise<ProjectExistForUserQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/ExistsForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExistsForUser(_response);
        });
    }

    protected processExistsForUser(response: AxiosResponse): Promise<ProjectExistForUserQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectExistForUserQueryResponse.fromJS(resultData200);
            return Promise.resolve<ProjectExistForUserQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectExistForUserQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectStatus(body: UpdateProjectStatusCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateProjectStatusCommandResponse> {
        let url_ = this.baseUrl + "/api/Project/UpdateProjectStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProjectStatus(_response);
        });
    }

    protected processUpdateProjectStatus(response: AxiosResponse): Promise<UpdateProjectStatusCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateProjectStatusCommandResponse.fromJS(resultData200);
            return Promise.resolve<UpdateProjectStatusCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateProjectStatusCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitProjectForApproval(body: SubmitProjectForApprovalCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SubmitProjectForApprovalCommandResponse> {
        let url_ = this.baseUrl + "/api/Project/SubmitProjectForApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitProjectForApproval(_response);
        });
    }

    protected processSubmitProjectForApproval(response: AxiosResponse): Promise<SubmitProjectForApprovalCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitProjectForApprovalCommandResponse.fromJS(resultData200);
            return Promise.resolve<SubmitProjectForApprovalCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitProjectForApprovalCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProject(body: CreateProjectModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateProjectCommandResponse> {
        let url_ = this.baseUrl + "/api/Project/CreateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: AxiosResponse): Promise<CreateProjectCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateProjectCommandResponse.fromJS(resultData200);
            return Promise.resolve<CreateProjectCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateProjectCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editProject(body: EditProjectModel | undefined , cancelToken?: CancelToken | undefined): Promise<EditProjectCommandResponse> {
        let url_ = this.baseUrl + "/api/Project/EditProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditProject(_response);
        });
    }

    protected processEditProject(response: AxiosResponse): Promise<EditProjectCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditProjectCommandResponse.fromJS(resultData200);
            return Promise.resolve<EditProjectCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditProjectCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitProjectUpdateForApproval(body: SubmitProjectUpdateForApprovalCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SubmitProjectUpdateForApprovalCommandResponse> {
        let url_ = this.baseUrl + "/api/Project/SubmitProjectUpdateForApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitProjectUpdateForApproval(_response);
        });
    }

    protected processSubmitProjectUpdateForApproval(response: AxiosResponse): Promise<SubmitProjectUpdateForApprovalCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitProjectUpdateForApprovalCommandResponse.fromJS(resultData200);
            return Promise.resolve<SubmitProjectUpdateForApprovalCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitProjectUpdateForApprovalCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertProjectUpdate(body: UpsertProjectUpdateModel | undefined , cancelToken?: CancelToken | undefined): Promise<UpsertProjectUpdateCommandResponse> {
        let url_ = this.baseUrl + "/api/Project/UpsertProjectUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertProjectUpdate(_response);
        });
    }

    protected processUpsertProjectUpdate(response: AxiosResponse): Promise<UpsertProjectUpdateCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpsertProjectUpdateCommandResponse.fromJS(resultData200);
            return Promise.resolve<UpsertProjectUpdateCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpsertProjectUpdateCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectUpdateDetailsByProjectId(body: GetProjectUpdateDetailsByProjectIdQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetProjectUpdateDetailsByProjectIdQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectUpdateDetailsByProjectId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectUpdateDetailsByProjectId(_response);
        });
    }

    protected processGetProjectUpdateDetailsByProjectId(response: AxiosResponse): Promise<GetProjectUpdateDetailsByProjectIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectUpdateDetailsByProjectIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectUpdateDetailsByProjectIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectUpdateDetailsByProjectIdQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveProject(body: ApproveProjectCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ApproveProjectCommandResponse> {
        let url_ = this.baseUrl + "/api/Project/ApproveProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveProject(_response);
        });
    }

    protected processApproveProject(response: AxiosResponse): Promise<ApproveProjectCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApproveProjectCommandResponse.fromJS(resultData200);
            return Promise.resolve<ApproveProjectCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApproveProjectCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectTrackerInfo(body: GetProjectTrackerInfoQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetProjectTrackerInfoQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/GetProjectTrackerInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectTrackerInfo(_response);
        });
    }

    protected processGetProjectTrackerInfo(response: AxiosResponse): Promise<GetProjectTrackerInfoQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectTrackerInfoQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectTrackerInfoQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectTrackerInfoQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    refreshIdle(  cancelToken?: CancelToken | undefined): Promise<GetProjectTrackerInfoQueryResponse> {
        let url_ = this.baseUrl + "/api/Project/RefreshIdle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshIdle(_response);
        });
    }

    protected processRefreshIdle(response: AxiosResponse): Promise<GetProjectTrackerInfoQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectTrackerInfoQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectTrackerInfoQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectTrackerInfoQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    references(body: GetReferenceListQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetReferenceListQueryResponse> {
        let url_ = this.baseUrl + "/api/Reference/References";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReferences(_response);
        });
    }

    protected processReferences(response: AxiosResponse): Promise<GetReferenceListQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetReferenceListQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetReferenceListQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReferenceListQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserAccountTypes(  cancelToken?: CancelToken | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/Registration/GetUserAccountTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAccountTypes(_response);
        });
    }

    protected processGetUserAccountTypes(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @return Success
     */
    getIdTypes(  cancelToken?: CancelToken | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/Registration/GetIdTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIdTypes(_response);
        });
    }

    protected processGetIdTypes(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInvestorOrEntrepreneurWebModel | undefined , cancelToken?: CancelToken | undefined): Promise<RegisterInvestorOrEntrepreneurCommandResponse> {
        let url_ = this.baseUrl + "/api/Registration/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<RegisterInvestorOrEntrepreneurCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterInvestorOrEntrepreneurCommandResponse.fromJS(resultData200);
            return Promise.resolve<RegisterInvestorOrEntrepreneurCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterInvestorOrEntrepreneurCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerInvestor(body: RegisterInvestorModel | undefined , cancelToken?: CancelToken | undefined): Promise<RegisterInvestorCommandResponse> {
        let url_ = this.baseUrl + "/api/Registration/RegisterInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterInvestor(_response);
        });
    }

    protected processRegisterInvestor(response: AxiosResponse): Promise<RegisterInvestorCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterInvestorCommandResponse.fromJS(resultData200);
            return Promise.resolve<RegisterInvestorCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterInvestorCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerCompany(body: Body | undefined , cancelToken?: CancelToken | undefined): Promise<RegisterCompanyCommandResponse> {
        let url_ = this.baseUrl + "/api/Registration/RegisterCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = Object.keys(body as any).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent((body as any)[key]);
        }).join('&')

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterCompany(_response);
        });
    }

    protected processRegisterCompany(response: AxiosResponse): Promise<RegisterCompanyCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterCompanyCommandResponse.fromJS(resultData200);
            return Promise.resolve<RegisterCompanyCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterCompanyCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmRegistration(body: ConfirmRegistrationModel | undefined , cancelToken?: CancelToken | undefined): Promise<ConfirmRegistrationCommandResponse> {
        let url_ = this.baseUrl + "/api/Registration/ConfirmRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmRegistration(_response);
        });
    }

    protected processConfirmRegistration(response: AxiosResponse): Promise<ConfirmRegistrationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfirmRegistrationCommandResponse.fromJS(resultData200);
            return Promise.resolve<ConfirmRegistrationCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfirmRegistrationCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRole(body: AddRoleModel | undefined , cancelToken?: CancelToken | undefined): Promise<AddRoleCommandResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/AddRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRole(_response);
        });
    }

    protected processAddRole(response: AxiosResponse): Promise<AddRoleCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddRoleCommandResponse.fromJS(resultData200);
            return Promise.resolve<AddRoleCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddRoleCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editRole(body: EditRoleModel | undefined , cancelToken?: CancelToken | undefined): Promise<EditRoleCommandResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/EditRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditRole(_response);
        });
    }

    protected processEditRole(response: AxiosResponse): Promise<EditRoleCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditRoleCommandResponse.fromJS(resultData200);
            return Promise.resolve<EditRoleCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditRoleCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getOperations(  cancelToken?: CancelToken | undefined): Promise<GetOperationsListCommandResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/GetOperations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOperations(_response);
        });
    }

    protected processGetOperations(response: AxiosResponse): Promise<GetOperationsListCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOperationsListCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetOperationsListCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOperationsListCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllRolesByFilter(body: GetAllRolesByFilterModel | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllRolesByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/GetAllRolesByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllRolesByFilter(_response);
        });
    }

    protected processGetAllRolesByFilter(response: AxiosResponse): Promise<GetAllRolesByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllRolesByFilterQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetAllRolesByFilterQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllRolesByFilterQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRoleById(body: GetRoleByIdModel | undefined , cancelToken?: CancelToken | undefined): Promise<GetRoleByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/GetRoleById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleById(_response);
        });
    }

    protected processGetRoleById(response: AxiosResponse): Promise<GetRoleByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoleByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetRoleByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleByIdQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    weatherForecasts(  cancelToken?: CancelToken | undefined): Promise<WeatherForecast[]> {
        let url_ = this.baseUrl + "/api/SampleData/WeatherForecasts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWeatherForecasts(_response);
        });
    }

    protected processWeatherForecasts(response: AxiosResponse): Promise<WeatherForecast[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WeatherForecast[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeatherForecast[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register2(body: RegistrationModel | undefined , cancelToken?: CancelToken | undefined): Promise<RegisterUserCommandResponse> {
        let url_ = this.baseUrl + "/api/Token/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister2(_response);
        });
    }

    protected processRegister2(response: AxiosResponse): Promise<RegisterUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterUserCommandResponse.fromJS(resultData200);
            return Promise.resolve<RegisterUserCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterUserCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    logout(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Token/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<LoginCommandResponse> {
        let url_ = this.baseUrl + "/api/Token/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<LoginCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginCommandResponse.fromJS(resultData200);
            return Promise.resolve<LoginCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refresh(body: RefreshTokenDto | undefined , cancelToken?: CancelToken | undefined): Promise<RefreshTokenCommandResponse> {
        let url_ = this.baseUrl + "/api/Token/Refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<RefreshTokenCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshTokenCommandResponse.fromJS(resultData200);
            return Promise.resolve<RefreshTokenCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshTokenCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateRecaptcha(body: RecaptchaModel | undefined , cancelToken?: CancelToken | undefined): Promise<ValidateRecaptchaCommandResponse> {
        let url_ = this.baseUrl + "/api/Token/ValidateRecaptcha";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateRecaptcha(_response);
        });
    }

    protected processValidateRecaptcha(response: AxiosResponse): Promise<ValidateRecaptchaCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateRecaptchaCommandResponse.fromJS(resultData200);
            return Promise.resolve<ValidateRecaptchaCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateRecaptchaCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRoles(body: GetRolesModel | undefined , cancelToken?: CancelToken | undefined): Promise<GetRolesCommandResponse> {
        let url_ = this.baseUrl + "/api/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<GetRolesCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRolesCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetRolesCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRolesCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUser(body: EditUserModel | undefined , cancelToken?: CancelToken | undefined): Promise<EditUserCommandResponse> {
        let url_ = this.baseUrl + "/api/User/EditUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditUser(_response);
        });
    }

    protected processEditUser(response: AxiosResponse): Promise<EditUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditUserCommandResponse.fromJS(resultData200);
            return Promise.resolve<EditUserCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditUserCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUser(body: AddUserModel | undefined , cancelToken?: CancelToken | undefined): Promise<AddUserCommandResponse> {
        let url_ = this.baseUrl + "/api/User/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUser(_response);
        });
    }

    protected processAddUser(response: AxiosResponse): Promise<AddUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddUserCommandResponse.fromJS(resultData200);
            return Promise.resolve<AddUserCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddUserCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUsersByFilter(body: GetAllUsersByFilterModel | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllUsersByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetAllUsersByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUsersByFilter(_response);
        });
    }

    protected processGetAllUsersByFilter(response: AxiosResponse): Promise<GetAllUsersByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllUsersByFilterQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetAllUsersByFilterQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllUsersByFilterQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestPasswordReset(body: RequestPasswordResetCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserManagement/RequestPasswordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestPasswordReset(_response);
        });
    }

    protected processRequestPasswordReset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserManagement/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserManagement/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserById(body: GetUserByIdModel | undefined , cancelToken?: CancelToken | undefined): Promise<GetUserByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetUserById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<GetUserByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetUserByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserByIdQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserProfileById(id: string , cancelToken?: CancelToken | undefined): Promise<GetUserProfileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetUserProfileById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfileById(_response);
        });
    }

    protected processGetUserProfileById(response: AxiosResponse): Promise<GetUserProfileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserProfileByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetUserProfileByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserProfileByIdQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMyUserProfile(  cancelToken?: CancelToken | undefined): Promise<GetUserProfileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetMyUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyUserProfile(_response);
        });
    }

    protected processGetMyUserProfile(response: AxiosResponse): Promise<GetUserProfileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserProfileByIdQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetUserProfileByIdQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserProfileByIdQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserStatus(body: ChangeUserStatusCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserManagement/ChangeUserStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserStatus(_response);
        });
    }

    protected processChangeUserStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUserProfile(body: SimpleUserProfile | undefined , cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/UserManagement/EditUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditUserProfile(_response);
        });
    }

    protected processEditUserProfile(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendMyActivationEmail(body: ResendMyActivationEmailCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ResendMyActivationEmailCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/ResendMyActivationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendMyActivationEmail(_response);
        });
    }

    protected processResendMyActivationEmail(response: AxiosResponse): Promise<ResendMyActivationEmailCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResendMyActivationEmailCommandResponse.fromJS(resultData200);
            return Promise.resolve<ResendMyActivationEmailCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResendMyActivationEmailCommandResponse>(null as any);
    }
}

export class AddRoleCommandResponse implements IAddRoleCommandResponse {
    role?: Role;

    constructor(data?: IAddRoleCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.role = data.role && !(<any>data.role).toJSON ? new Role(data.role) : <Role>this.role;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddRoleCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data;
    }

    clone(): AddRoleCommandResponse {
        const json = this.toJSON();
        let result = new AddRoleCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddRoleCommandResponse {
    role?: IRole;
}

export class AddRoleModel implements IAddRoleModel {
    roleName?: string | undefined;
    description?: string | undefined;
    selectedOperations?: string[] | undefined;

    constructor(data?: IAddRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
            this.description = _data["description"];
            if (Array.isArray(_data["selectedOperations"])) {
                this.selectedOperations = [] as any;
                for (let item of _data["selectedOperations"])
                    this.selectedOperations!.push(item);
            }
        }
    }

    static fromJS(data: any): AddRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        data["description"] = this.description;
        if (Array.isArray(this.selectedOperations)) {
            data["selectedOperations"] = [];
            for (let item of this.selectedOperations)
                data["selectedOperations"].push(item);
        }
        return data;
    }

    clone(): AddRoleModel {
        const json = this.toJSON();
        let result = new AddRoleModel();
        result.init(json);
        return result;
    }
}

export interface IAddRoleModel {
    roleName?: string | undefined;
    description?: string | undefined;
    selectedOperations?: string[] | undefined;
}

export class AddToCartResponse implements IAddToCartResponse {
    cart?: CartModel;

    constructor(data?: IAddToCartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new CartModel(data.cart) : <CartModel>this.cart;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? CartModel.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddToCartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddToCartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data;
    }

    clone(): AddToCartResponse {
        const json = this.toJSON();
        let result = new AddToCartResponse();
        result.init(json);
        return result;
    }
}

export interface IAddToCartResponse {
    cart?: ICartModel;
}

export class AddUserCommandResponse implements IAddUserCommandResponse {
    result?: IdentityResult;
    newUser?: SlimUser;

    constructor(data?: IAddUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result;
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new SlimUser(data.newUser) : <SlimUser>this.newUser;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.newUser = _data["newUser"] ? SlimUser.fromJS(_data["newUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        return data;
    }

    clone(): AddUserCommandResponse {
        const json = this.toJSON();
        let result = new AddUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddUserCommandResponse {
    result?: IIdentityResult;
    newUser?: ISlimUser;
}

export class AddUserModel implements IAddUserModel {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;
    operations?: string[] | undefined;

    constructor(data?: IAddUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.confirmEmailAddress = _data["confirmEmailAddress"];
            this.password = _data["password"];
            this.confirmationPassword = _data["confirmationPassword"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
        }
    }

    static fromJS(data: any): AddUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["confirmEmailAddress"] = this.confirmEmailAddress;
        data["password"] = this.password;
        data["confirmationPassword"] = this.confirmationPassword;
        data["taxIdNumber"] = this.taxIdNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        return data;
    }

    clone(): AddUserModel {
        const json = this.toJSON();
        let result = new AddUserModel();
        result.init(json);
        return result;
    }
}

export interface IAddUserModel {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;
    operations?: string[] | undefined;
}

export class Address implements IAddress {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    addressType?: AddressType;
    line1?: string | undefined;
    line2?: string | undefined;
    city?: string | undefined;
    stateParish?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    companies?: Company[] | undefined;
    userProfiles?: UserProfile[] | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.companies) {
                this.companies = [];
                for (let i = 0; i < data.companies.length; i++) {
                    let item = data.companies[i];
                    this.companies[i] = item && !(<any>item).toJSON ? new Company(item) : <Company>item;
                }
            }
            if (data.userProfiles) {
                this.userProfiles = [];
                for (let i = 0; i < data.userProfiles.length; i++) {
                    let item = data.userProfiles[i];
                    this.userProfiles[i] = item && !(<any>item).toJSON ? new UserProfile(item) : <UserProfile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.addressType = _data["addressType"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.city = _data["city"];
            this.stateParish = _data["stateParish"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["userProfiles"])) {
                this.userProfiles = [] as any;
                for (let item of _data["userProfiles"])
                    this.userProfiles!.push(UserProfile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["addressType"] = this.addressType;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["city"] = this.city;
        data["stateParish"] = this.stateParish;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.userProfiles)) {
            data["userProfiles"] = [];
            for (let item of this.userProfiles)
                data["userProfiles"].push(item.toJSON());
        }
        return data;
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    addressType?: AddressType;
    line1?: string | undefined;
    line2?: string | undefined;
    city?: string | undefined;
    stateParish?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    companies?: ICompany[] | undefined;
    userProfiles?: IUserProfile[] | undefined;
}

export enum AddressType {
    Primary = "Primary",
    Home = "Home",
    Work = "Work",
    Billing = "Billing",
}

export class ApproveProjectCommandRequest implements IApproveProjectCommandRequest {
    projectApprovalStatus?: ProjectApprovalStatus;
    id?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IApproveProjectCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectApprovalStatus = _data["projectApprovalStatus"];
            this.id = _data["id"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ApproveProjectCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveProjectCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectApprovalStatus"] = this.projectApprovalStatus;
        data["id"] = this.id;
        data["reason"] = this.reason;
        return data;
    }

    clone(): ApproveProjectCommandRequest {
        const json = this.toJSON();
        let result = new ApproveProjectCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IApproveProjectCommandRequest {
    projectApprovalStatus?: ProjectApprovalStatus;
    id?: string | undefined;
    reason?: string | undefined;
}

export class ApproveProjectCommandResponse implements IApproveProjectCommandResponse {
    project?: ProjectFullDetailsModel;

    constructor(data?: IApproveProjectCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectFullDetailsModel(data.project) : <ProjectFullDetailsModel>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectFullDetailsModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApproveProjectCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveProjectCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): ApproveProjectCommandResponse {
        const json = this.toJSON();
        let result = new ApproveProjectCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IApproveProjectCommandResponse {
    project?: IProjectFullDetailsModel;
}

export class AuditDetail implements IAuditDetail {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    auditHeaderId?: string;
    auditEvent?: AuditEvent;
    entityName?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    auditHeader?: AuditHeader;

    constructor(data?: IAuditDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.auditHeader = data.auditHeader && !(<any>data.auditHeader).toJSON ? new AuditHeader(data.auditHeader) : <AuditHeader>this.auditHeader;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.auditHeaderId = _data["auditHeaderId"];
            this.auditEvent = _data["auditEvent"];
            this.entityName = _data["entityName"];
            this.fieldName = _data["fieldName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.auditHeader = _data["auditHeader"] ? AuditHeader.fromJS(_data["auditHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AuditDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["auditHeaderId"] = this.auditHeaderId;
        data["auditEvent"] = this.auditEvent;
        data["entityName"] = this.entityName;
        data["fieldName"] = this.fieldName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["auditHeader"] = this.auditHeader ? this.auditHeader.toJSON() : <any>undefined;
        return data;
    }

    clone(): AuditDetail {
        const json = this.toJSON();
        let result = new AuditDetail();
        result.init(json);
        return result;
    }
}

export interface IAuditDetail {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    auditHeaderId?: string;
    auditEvent?: AuditEvent;
    entityName?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    auditHeader?: IAuditHeader;
}

export enum AuditEvent {
    Added = "Added",
    Deleted = "Deleted",
    Modified = "Modified",
    Queried = "Queried",
    Attempted = "Attempted",
}

export class AuditHeader implements IAuditHeader {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    userId?: string | undefined;
    auditUser?: string | undefined;
    operation?: string | undefined;
    auditTime?: string;
    auditStatus?: AuditStatus;
    auditDetails?: AuditDetail[] | undefined;

    constructor(data?: IAuditHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.auditDetails) {
                this.auditDetails = [];
                for (let i = 0; i < data.auditDetails.length; i++) {
                    let item = data.auditDetails[i];
                    this.auditDetails[i] = item && !(<any>item).toJSON ? new AuditDetail(item) : <AuditDetail>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.userId = _data["userId"];
            this.auditUser = _data["auditUser"];
            this.operation = _data["operation"];
            this.auditTime = _data["auditTime"];
            this.auditStatus = _data["auditStatus"];
            if (Array.isArray(_data["auditDetails"])) {
                this.auditDetails = [] as any;
                for (let item of _data["auditDetails"])
                    this.auditDetails!.push(AuditDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditHeader {
        data = typeof data === 'object' ? data : {};
        let result = new AuditHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["userId"] = this.userId;
        data["auditUser"] = this.auditUser;
        data["operation"] = this.operation;
        data["auditTime"] = this.auditTime;
        data["auditStatus"] = this.auditStatus;
        if (Array.isArray(this.auditDetails)) {
            data["auditDetails"] = [];
            for (let item of this.auditDetails)
                data["auditDetails"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditHeader {
        const json = this.toJSON();
        let result = new AuditHeader();
        result.init(json);
        return result;
    }
}

export interface IAuditHeader {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    userId?: string | undefined;
    auditUser?: string | undefined;
    operation?: string | undefined;
    auditTime?: string;
    auditStatus?: AuditStatus;
    auditDetails?: IAuditDetail[] | undefined;
}

export enum AuditStatus {
    Attempt = "Attempt",
    Success = "Success",
    Failure = "Failure",
}

export class BankInfo implements IBankInfo {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: string | undefined;
    currency?: string | undefined;
    companies?: Company[] | undefined;

    constructor(data?: IBankInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.companies) {
                this.companies = [];
                for (let i = 0; i < data.companies.length; i++) {
                    let item = data.companies[i];
                    this.companies[i] = item && !(<any>item).toJSON ? new Company(item) : <Company>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.name = _data["name"];
            this.accountNumber = _data["accountNumber"];
            this.accountType = _data["accountType"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(Company.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BankInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["name"] = this.name;
        data["accountNumber"] = this.accountNumber;
        data["accountType"] = this.accountType;
        data["currency"] = this.currency;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }

    clone(): BankInfo {
        const json = this.toJSON();
        let result = new BankInfo();
        result.init(json);
        return result;
    }
}

export interface IBankInfo {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: string | undefined;
    currency?: string | undefined;
    companies?: ICompany[] | undefined;
}

export class Base64FileModel implements IBase64FileModel {
    id?: string | undefined;
    fileName?: string | undefined;
    content?: string | undefined;
    url?: string | undefined;

    constructor(data?: IBase64FileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.content = _data["content"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Base64FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new Base64FileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["url"] = this.url;
        return data;
    }

    clone(): Base64FileModel {
        const json = this.toJSON();
        let result = new Base64FileModel();
        result.init(json);
        return result;
    }
}

export interface IBase64FileModel {
    id?: string | undefined;
    fileName?: string | undefined;
    content?: string | undefined;
    url?: string | undefined;
}

export class BeginCreditCardPaymentCommandResponse implements IBeginCreditCardPaymentCommandResponse {
    paymentStatus?: PaymentStatus;
    htmlData?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    readonly invoiceNumber?: string | undefined;

    constructor(data?: IBeginCreditCardPaymentCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentStatus = _data["paymentStatus"];
            this.htmlData = _data["htmlData"];
            this.errorMessage = _data["errorMessage"];
            this.orderId = _data["orderId"];
            (<any>this).invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): BeginCreditCardPaymentCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BeginCreditCardPaymentCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentStatus"] = this.paymentStatus;
        data["htmlData"] = this.htmlData;
        data["errorMessage"] = this.errorMessage;
        data["orderId"] = this.orderId;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }

    clone(): BeginCreditCardPaymentCommandResponse {
        const json = this.toJSON();
        let result = new BeginCreditCardPaymentCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IBeginCreditCardPaymentCommandResponse {
    paymentStatus?: PaymentStatus;
    htmlData?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    invoiceNumber?: string | undefined;
}

export class BeginFygaroPaymentCommandResponse implements IBeginFygaroPaymentCommandResponse {
    success?: boolean;
    redirectUrl?: string | undefined;
    paymentUrl?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    transactionId?: string | undefined;

    constructor(data?: IBeginFygaroPaymentCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.redirectUrl = _data["redirectUrl"];
            this.paymentUrl = _data["paymentUrl"];
            this.errorMessage = _data["errorMessage"];
            this.orderId = _data["orderId"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): BeginFygaroPaymentCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BeginFygaroPaymentCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["redirectUrl"] = this.redirectUrl;
        data["paymentUrl"] = this.paymentUrl;
        data["errorMessage"] = this.errorMessage;
        data["orderId"] = this.orderId;
        data["transactionId"] = this.transactionId;
        return data;
    }

    clone(): BeginFygaroPaymentCommandResponse {
        const json = this.toJSON();
        let result = new BeginFygaroPaymentCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IBeginFygaroPaymentCommandResponse {
    success?: boolean;
    redirectUrl?: string | undefined;
    paymentUrl?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    transactionId?: string | undefined;
}

export class BeginFygarolPaymentModel implements IBeginFygarolPaymentModel {
    cartItems?: CartItemModel[] | undefined;
    currency?: string | undefined;
    amount?: number | undefined;

    constructor(data?: IBeginFygarolPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.cartItems) {
                this.cartItems = [];
                for (let i = 0; i < data.cartItems.length; i++) {
                    let item = data.cartItems[i];
                    this.cartItems[i] = item && !(<any>item).toJSON ? new CartItemModel(item) : <CartItemModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cartItems"])) {
                this.cartItems = [] as any;
                for (let item of _data["cartItems"])
                    this.cartItems!.push(CartItemModel.fromJS(item));
            }
            this.currency = _data["currency"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): BeginFygarolPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new BeginFygarolPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cartItems)) {
            data["cartItems"] = [];
            for (let item of this.cartItems)
                data["cartItems"].push(item.toJSON());
        }
        data["currency"] = this.currency;
        data["amount"] = this.amount;
        return data;
    }

    clone(): BeginFygarolPaymentModel {
        const json = this.toJSON();
        let result = new BeginFygarolPaymentModel();
        result.init(json);
        return result;
    }
}

export interface IBeginFygarolPaymentModel {
    cartItems?: ICartItemModel[] | undefined;
    currency?: string | undefined;
    amount?: number | undefined;
}

export class BeginGuestFygaroPaymentCommandResponse implements IBeginGuestFygaroPaymentCommandResponse {
    success?: boolean;
    redirectUrl?: string | undefined;
    paymentUrl?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    transactionId?: string | undefined;

    constructor(data?: IBeginGuestFygaroPaymentCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.redirectUrl = _data["redirectUrl"];
            this.paymentUrl = _data["paymentUrl"];
            this.errorMessage = _data["errorMessage"];
            this.orderId = _data["orderId"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): BeginGuestFygaroPaymentCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BeginGuestFygaroPaymentCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["redirectUrl"] = this.redirectUrl;
        data["paymentUrl"] = this.paymentUrl;
        data["errorMessage"] = this.errorMessage;
        data["orderId"] = this.orderId;
        data["transactionId"] = this.transactionId;
        return data;
    }

    clone(): BeginGuestFygaroPaymentCommandResponse {
        const json = this.toJSON();
        let result = new BeginGuestFygaroPaymentCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IBeginGuestFygaroPaymentCommandResponse {
    success?: boolean;
    redirectUrl?: string | undefined;
    paymentUrl?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    transactionId?: string | undefined;
}

export class BeginGuestFygarolPaymentModel implements IBeginGuestFygarolPaymentModel {
    cartItems?: CartItemModel[] | undefined;
    currency?: string | undefined;
    amount?: number | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IBeginGuestFygarolPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.cartItems) {
                this.cartItems = [];
                for (let i = 0; i < data.cartItems.length; i++) {
                    let item = data.cartItems[i];
                    this.cartItems[i] = item && !(<any>item).toJSON ? new CartItemModel(item) : <CartItemModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cartItems"])) {
                this.cartItems = [] as any;
                for (let item of _data["cartItems"])
                    this.cartItems!.push(CartItemModel.fromJS(item));
            }
            this.currency = _data["currency"];
            this.amount = _data["amount"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): BeginGuestFygarolPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new BeginGuestFygarolPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cartItems)) {
            data["cartItems"] = [];
            for (let item of this.cartItems)
                data["cartItems"].push(item.toJSON());
        }
        data["currency"] = this.currency;
        data["amount"] = this.amount;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): BeginGuestFygarolPaymentModel {
        const json = this.toJSON();
        let result = new BeginGuestFygarolPaymentModel();
        result.init(json);
        return result;
    }
}

export interface IBeginGuestFygarolPaymentModel {
    cartItems?: ICartItemModel[] | undefined;
    currency?: string | undefined;
    amount?: number | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
}

export class BeginPayPalPaymentModel implements IBeginPayPalPaymentModel {
    cartItems?: CartItemModel[] | undefined;

    constructor(data?: IBeginPayPalPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.cartItems) {
                this.cartItems = [];
                for (let i = 0; i < data.cartItems.length; i++) {
                    let item = data.cartItems[i];
                    this.cartItems[i] = item && !(<any>item).toJSON ? new CartItemModel(item) : <CartItemModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cartItems"])) {
                this.cartItems = [] as any;
                for (let item of _data["cartItems"])
                    this.cartItems!.push(CartItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BeginPayPalPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new BeginPayPalPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cartItems)) {
            data["cartItems"] = [];
            for (let item of this.cartItems)
                data["cartItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): BeginPayPalPaymentModel {
        const json = this.toJSON();
        let result = new BeginPayPalPaymentModel();
        result.init(json);
        return result;
    }
}

export interface IBeginPayPalPaymentModel {
    cartItems?: ICartItemModel[] | undefined;
}

export class BeginPaypalPaymentCommandResponse implements IBeginPaypalPaymentCommandResponse {
    success?: boolean;
    redirectUrl?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    transactionId?: string | undefined;

    constructor(data?: IBeginPaypalPaymentCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.redirectUrl = _data["redirectUrl"];
            this.errorMessage = _data["errorMessage"];
            this.orderId = _data["orderId"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): BeginPaypalPaymentCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BeginPaypalPaymentCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["redirectUrl"] = this.redirectUrl;
        data["errorMessage"] = this.errorMessage;
        data["orderId"] = this.orderId;
        data["transactionId"] = this.transactionId;
        return data;
    }

    clone(): BeginPaypalPaymentCommandResponse {
        const json = this.toJSON();
        let result = new BeginPaypalPaymentCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IBeginPaypalPaymentCommandResponse {
    success?: boolean;
    redirectUrl?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    transactionId?: string | undefined;
}

export class BillingInfo implements IBillingInfo {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipcode?: string | undefined;
    orderId?: string;
    order?: Order;

    constructor(data?: IBillingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.order = data.order && !(<any>data.order).toJSON ? new Order(data.order) : <Order>this.order;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.zipcode = _data["zipcode"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BillingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BillingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["zipcode"] = this.zipcode;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }

    clone(): BillingInfo {
        const json = this.toJSON();
        let result = new BillingInfo();
        result.init(json);
        return result;
    }
}

export interface IBillingInfo {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipcode?: string | undefined;
    orderId?: string;
    order?: IOrder;
}

export class CardInfo implements ICardInfo {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    holderName?: string | undefined;
    cardNumber?: string | undefined;
    cardType?: string | undefined;
    currency?: string | undefined;
    verificationDate?: string | undefined;
    cardStatus?: CardStatus;
    expiryDate?: string | undefined;
    verificationAmount?: number;
    verificationHash?: string | undefined;
    attemptCount?: number;
    user?: User;
    userId?: string | undefined;

    constructor(data?: ICardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.holderName = _data["holderName"];
            this.cardNumber = _data["cardNumber"];
            this.cardType = _data["cardType"];
            this.currency = _data["currency"];
            this.verificationDate = _data["verificationDate"];
            this.cardStatus = _data["cardStatus"];
            this.expiryDate = _data["expiryDate"];
            this.verificationAmount = _data["verificationAmount"];
            this.verificationHash = _data["verificationHash"];
            this.attemptCount = _data["attemptCount"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["holderName"] = this.holderName;
        data["cardNumber"] = this.cardNumber;
        data["cardType"] = this.cardType;
        data["currency"] = this.currency;
        data["verificationDate"] = this.verificationDate;
        data["cardStatus"] = this.cardStatus;
        data["expiryDate"] = this.expiryDate;
        data["verificationAmount"] = this.verificationAmount;
        data["verificationHash"] = this.verificationHash;
        data["attemptCount"] = this.attemptCount;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }

    clone(): CardInfo {
        const json = this.toJSON();
        let result = new CardInfo();
        result.init(json);
        return result;
    }
}

export interface ICardInfo {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    holderName?: string | undefined;
    cardNumber?: string | undefined;
    cardType?: string | undefined;
    currency?: string | undefined;
    verificationDate?: string | undefined;
    cardStatus?: CardStatus;
    expiryDate?: string | undefined;
    verificationAmount?: number;
    verificationHash?: string | undefined;
    attemptCount?: number;
    user?: IUser;
    userId?: string | undefined;
}

export class CardPaymentModel implements ICardPaymentModel {
    cartItems?: CartItemModel[] | undefined;
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    currency?: string | undefined;
    expiryDate?: string | undefined;
    cvv?: string | undefined;
    billingFirstName?: string | undefined;
    billingLastName?: string | undefined;
    billingAddress?: Address;
    billingPhone?: string | undefined;
    security?: Transaction3DS;

    constructor(data?: ICardPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.cartItems) {
                this.cartItems = [];
                for (let i = 0; i < data.cartItems.length; i++) {
                    let item = data.cartItems[i];
                    this.cartItems[i] = item && !(<any>item).toJSON ? new CartItemModel(item) : <CartItemModel>item;
                }
            }
            this.billingAddress = data.billingAddress && !(<any>data.billingAddress).toJSON ? new Address(data.billingAddress) : <Address>this.billingAddress;
            this.security = data.security && !(<any>data.security).toJSON ? new Transaction3DS(data.security) : <Transaction3DS>this.security;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cartItems"])) {
                this.cartItems = [] as any;
                for (let item of _data["cartItems"])
                    this.cartItems!.push(CartItemModel.fromJS(item));
            }
            this.cardNumber = _data["cardNumber"];
            this.cardName = _data["cardName"];
            this.cardType = _data["cardType"];
            this.currency = _data["currency"];
            this.expiryDate = _data["expiryDate"];
            this.cvv = _data["cvv"];
            this.billingFirstName = _data["billingFirstName"];
            this.billingLastName = _data["billingLastName"];
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : <any>undefined;
            this.billingPhone = _data["billingPhone"];
            this.security = _data["security"] ? Transaction3DS.fromJS(_data["security"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CardPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cartItems)) {
            data["cartItems"] = [];
            for (let item of this.cartItems)
                data["cartItems"].push(item.toJSON());
        }
        data["cardNumber"] = this.cardNumber;
        data["cardName"] = this.cardName;
        data["cardType"] = this.cardType;
        data["currency"] = this.currency;
        data["expiryDate"] = this.expiryDate;
        data["cvv"] = this.cvv;
        data["billingFirstName"] = this.billingFirstName;
        data["billingLastName"] = this.billingLastName;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["billingPhone"] = this.billingPhone;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        return data;
    }

    clone(): CardPaymentModel {
        const json = this.toJSON();
        let result = new CardPaymentModel();
        result.init(json);
        return result;
    }
}

export interface ICardPaymentModel {
    cartItems?: ICartItemModel[] | undefined;
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    currency?: string | undefined;
    expiryDate?: string | undefined;
    cvv?: string | undefined;
    billingFirstName?: string | undefined;
    billingLastName?: string | undefined;
    billingAddress?: IAddress;
    billingPhone?: string | undefined;
    security?: ITransaction3DS;
}

export class CardRegistrationModel implements ICardRegistrationModel {
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    expiryDate?: string | undefined;
    cvv?: string | undefined;
    cardHash?: string | undefined;
    currency?: string | undefined;
    verificationAmount?: number;

    constructor(data?: ICardRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"];
            this.cardName = _data["cardName"];
            this.cardType = _data["cardType"];
            this.expiryDate = _data["expiryDate"];
            this.cvv = _data["cvv"];
            this.cardHash = _data["cardHash"];
            this.currency = _data["currency"];
            this.verificationAmount = _data["verificationAmount"];
        }
    }

    static fromJS(data: any): CardRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber;
        data["cardName"] = this.cardName;
        data["cardType"] = this.cardType;
        data["expiryDate"] = this.expiryDate;
        data["cvv"] = this.cvv;
        data["cardHash"] = this.cardHash;
        data["currency"] = this.currency;
        data["verificationAmount"] = this.verificationAmount;
        return data;
    }

    clone(): CardRegistrationModel {
        const json = this.toJSON();
        let result = new CardRegistrationModel();
        result.init(json);
        return result;
    }
}

export interface ICardRegistrationModel {
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    expiryDate?: string | undefined;
    cvv?: string | undefined;
    cardHash?: string | undefined;
    currency?: string | undefined;
    verificationAmount?: number;
}

export enum CardStatus {
    VerificationNeeded = "VerificationNeeded",
    Verified = "Verified",
    Disabled = "Disabled",
    Expired = "Expired",
}

export class CardinalSecureAuthenticateResponse implements ICardinalSecureAuthenticateResponse {
    centinelResponseModel?: CentinelResponseModel;

    constructor(data?: ICardinalSecureAuthenticateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.centinelResponseModel = data.centinelResponseModel && !(<any>data.centinelResponseModel).toJSON ? new CentinelResponseModel(data.centinelResponseModel) : <CentinelResponseModel>this.centinelResponseModel;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.centinelResponseModel = _data["centinelResponseModel"] ? CentinelResponseModel.fromJS(_data["centinelResponseModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CardinalSecureAuthenticateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CardinalSecureAuthenticateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["centinelResponseModel"] = this.centinelResponseModel ? this.centinelResponseModel.toJSON() : <any>undefined;
        return data;
    }

    clone(): CardinalSecureAuthenticateResponse {
        const json = this.toJSON();
        let result = new CardinalSecureAuthenticateResponse();
        result.init(json);
        return result;
    }
}

export interface ICardinalSecureAuthenticateResponse {
    centinelResponseModel?: ICentinelResponseModel;
}

export class Cart implements ICart {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    userId?: string | undefined;
    status?: CartStatus;
    user?: User;
    cartItems?: CartItem[] | undefined;
    orders?: Order[] | undefined;

    constructor(data?: ICart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
            if (data.cartItems) {
                this.cartItems = [];
                for (let i = 0; i < data.cartItems.length; i++) {
                    let item = data.cartItems[i];
                    this.cartItems[i] = item && !(<any>item).toJSON ? new CartItem(item) : <CartItem>item;
                }
            }
            if (data.orders) {
                this.orders = [];
                for (let i = 0; i < data.orders.length; i++) {
                    let item = data.orders[i];
                    this.orders[i] = item && !(<any>item).toJSON ? new Order(item) : <Order>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["cartItems"])) {
                this.cartItems = [] as any;
                for (let item of _data["cartItems"])
                    this.cartItems!.push(CartItem.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Cart {
        data = typeof data === 'object' ? data : {};
        let result = new Cart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.cartItems)) {
            data["cartItems"] = [];
            for (let item of this.cartItems)
                data["cartItems"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }

    clone(): Cart {
        const json = this.toJSON();
        let result = new Cart();
        result.init(json);
        return result;
    }
}

export interface ICart {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    userId?: string | undefined;
    status?: CartStatus;
    user?: IUser;
    cartItems?: ICartItem[] | undefined;
    orders?: IOrder[] | undefined;
}

export class CartItem implements ICartItem {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    projectId?: string | undefined;
    cartId?: string | undefined;
    amount?: number | undefined;
    description?: string | undefined;
    cart?: Cart;
    project?: Project;

    constructor(data?: ICartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new Cart(data.cart) : <Cart>this.cart;
            this.project = data.project && !(<any>data.project).toJSON ? new Project(data.project) : <Project>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.projectId = _data["projectId"];
            this.cartId = _data["cartId"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.cart = _data["cart"] ? Cart.fromJS(_data["cart"]) : <any>undefined;
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CartItem {
        data = typeof data === 'object' ? data : {};
        let result = new CartItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["projectId"] = this.projectId;
        data["cartId"] = this.cartId;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): CartItem {
        const json = this.toJSON();
        let result = new CartItem();
        result.init(json);
        return result;
    }
}

export interface ICartItem {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    projectId?: string | undefined;
    cartId?: string | undefined;
    amount?: number | undefined;
    description?: string | undefined;
    cart?: ICart;
    project?: IProject;
}

export class CartItemModel implements ICartItemModel {
    itemId?: string;
    amount?: number;
    quanity?: number;

    constructor(data?: ICartItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.amount = _data["amount"];
            this.quanity = _data["quanity"];
        }
    }

    static fromJS(data: any): CartItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["amount"] = this.amount;
        data["quanity"] = this.quanity;
        return data;
    }

    clone(): CartItemModel {
        const json = this.toJSON();
        let result = new CartItemModel();
        result.init(json);
        return result;
    }
}

export interface ICartItemModel {
    itemId?: string;
    amount?: number;
    quanity?: number;
}

export class CartModel implements ICartModel {
    id?: string;
    specialProject?: Project;
    readonly invalidCartCheckout?: boolean;
    items?: Item[] | undefined;

    constructor(data?: ICartModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.specialProject = data.specialProject && !(<any>data.specialProject).toJSON ? new Project(data.specialProject) : <Project>this.specialProject;
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new Item(item) : <Item>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.specialProject = _data["specialProject"] ? Project.fromJS(_data["specialProject"]) : <any>undefined;
            (<any>this).invalidCartCheckout = _data["invalidCartCheckout"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CartModel {
        data = typeof data === 'object' ? data : {};
        let result = new CartModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["specialProject"] = this.specialProject ? this.specialProject.toJSON() : <any>undefined;
        data["invalidCartCheckout"] = this.invalidCartCheckout;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CartModel {
        const json = this.toJSON();
        let result = new CartModel();
        result.init(json);
        return result;
    }
}

export interface ICartModel {
    id?: string;
    specialProject?: IProject;
    invalidCartCheckout?: boolean;
    items?: IItem[] | undefined;
}

export enum CartStatus {
    Pending = "Pending",
    Finalized = "Finalized",
}

export class CentinelResponseModel implements ICentinelResponseModel {
    acsUrl?: string | undefined;
    payload?: string | undefined;
    termUrl?: string | undefined;
    md?: string | undefined;
    enrolled?: string | undefined;
    paResStatus?: string | undefined;
    errorNo?: string | undefined;
    errorDesc?: string | undefined;
    signatureVerification?: string | undefined;
    eciFlag?: string | undefined;
    xid?: string | undefined;
    cavv?: string | undefined;
    authenticationPath?: string | undefined;
    transactionId?: string | undefined;
    baseUrl?: string | undefined;
    readonly authenticationRequired?: boolean;
    readonly proceedWithPayment?: boolean;

    constructor(data?: ICentinelResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acsUrl = _data["acsUrl"];
            this.payload = _data["payload"];
            this.termUrl = _data["termUrl"];
            this.md = _data["md"];
            this.enrolled = _data["enrolled"];
            this.paResStatus = _data["paResStatus"];
            this.errorNo = _data["errorNo"];
            this.errorDesc = _data["errorDesc"];
            this.signatureVerification = _data["signatureVerification"];
            this.eciFlag = _data["eciFlag"];
            this.xid = _data["xid"];
            this.cavv = _data["cavv"];
            this.authenticationPath = _data["authenticationPath"];
            this.transactionId = _data["transactionId"];
            this.baseUrl = _data["baseUrl"];
            (<any>this).authenticationRequired = _data["authenticationRequired"];
            (<any>this).proceedWithPayment = _data["proceedWithPayment"];
        }
    }

    static fromJS(data: any): CentinelResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CentinelResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acsUrl"] = this.acsUrl;
        data["payload"] = this.payload;
        data["termUrl"] = this.termUrl;
        data["md"] = this.md;
        data["enrolled"] = this.enrolled;
        data["paResStatus"] = this.paResStatus;
        data["errorNo"] = this.errorNo;
        data["errorDesc"] = this.errorDesc;
        data["signatureVerification"] = this.signatureVerification;
        data["eciFlag"] = this.eciFlag;
        data["xid"] = this.xid;
        data["cavv"] = this.cavv;
        data["authenticationPath"] = this.authenticationPath;
        data["transactionId"] = this.transactionId;
        data["baseUrl"] = this.baseUrl;
        data["authenticationRequired"] = this.authenticationRequired;
        data["proceedWithPayment"] = this.proceedWithPayment;
        return data;
    }

    clone(): CentinelResponseModel {
        const json = this.toJSON();
        let result = new CentinelResponseModel();
        result.init(json);
        return result;
    }
}

export interface ICentinelResponseModel {
    acsUrl?: string | undefined;
    payload?: string | undefined;
    termUrl?: string | undefined;
    md?: string | undefined;
    enrolled?: string | undefined;
    paResStatus?: string | undefined;
    errorNo?: string | undefined;
    errorDesc?: string | undefined;
    signatureVerification?: string | undefined;
    eciFlag?: string | undefined;
    xid?: string | undefined;
    cavv?: string | undefined;
    authenticationPath?: string | undefined;
    transactionId?: string | undefined;
    baseUrl?: string | undefined;
    authenticationRequired?: boolean;
    proceedWithPayment?: boolean;
}

export class ChangePasswordCommandRequest implements IChangePasswordCommandRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordCommandRequest {
        const json = this.toJSON();
        let result = new ChangePasswordCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordCommandRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangePledgeModel implements IChangePledgeModel {
    id?: string | undefined;
    status?: PledgeStatus;

    constructor(data?: IChangePledgeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChangePledgeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePledgeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }

    clone(): ChangePledgeModel {
        const json = this.toJSON();
        let result = new ChangePledgeModel();
        result.init(json);
        return result;
    }
}

export interface IChangePledgeModel {
    id?: string | undefined;
    status?: PledgeStatus;
}

export class ChangeUserStatusCommandRequest implements IChangeUserStatusCommandRequest {
    enable?: boolean;
    id?: string | undefined;

    constructor(data?: IChangeUserStatusCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChangeUserStatusCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserStatusCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        data["id"] = this.id;
        return data;
    }

    clone(): ChangeUserStatusCommandRequest {
        const json = this.toJSON();
        let result = new ChangeUserStatusCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IChangeUserStatusCommandRequest {
    enable?: boolean;
    id?: string | undefined;
}

export class CheckPaymentStatusQueryResponse implements ICheckPaymentStatusQueryResponse {
    id?: string;
    currency?: string | undefined;
    total?: number;
    status?: PaymentStatus;

    constructor(data?: ICheckPaymentStatusQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currency = _data["currency"];
            this.total = _data["total"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CheckPaymentStatusQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPaymentStatusQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currency"] = this.currency;
        data["total"] = this.total;
        data["status"] = this.status;
        return data;
    }

    clone(): CheckPaymentStatusQueryResponse {
        const json = this.toJSON();
        let result = new CheckPaymentStatusQueryResponse();
        result.init(json);
        return result;
    }
}

export interface ICheckPaymentStatusQueryResponse {
    id?: string;
    currency?: string | undefined;
    total?: number;
    status?: PaymentStatus;
}

export enum ClientType {
    Individual = "Individual",
    Company = "Company",
}

export class Comment implements IComment {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    message?: string | undefined;
    author?: string | undefined;
    projectId?: string;
    project?: Project;

    constructor(data?: IComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new Project(data.project) : <Project>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.message = _data["message"];
            this.author = _data["author"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Comment {
        data = typeof data === 'object' ? data : {};
        let result = new Comment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["message"] = this.message;
        data["author"] = this.author;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): Comment {
        const json = this.toJSON();
        let result = new Comment();
        result.init(json);
        return result;
    }
}

export interface IComment {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    message?: string | undefined;
    author?: string | undefined;
    projectId?: string;
    project?: IProject;
}

export class Company implements ICompany {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    addressId?: string | undefined;
    phoneNumber?: string | undefined;
    articlesOfIncorporationId?: string | undefined;
    proofOfTaxComplianceId?: string | undefined;
    bankInfoId?: string | undefined;
    primaryUserId?: string;
    taxIdNumber?: string | undefined;
    status?: CompanyStatus;
    address?: Address;
    articlesOfIncorporation?: DataFile;
    bankInfo?: BankInfo;
    primaryUser?: User;
    proofOfTaxCompliance?: DataFile;
    projects?: Project[] | undefined;
    userProfiles?: UserProfile[] | undefined;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.articlesOfIncorporation = data.articlesOfIncorporation && !(<any>data.articlesOfIncorporation).toJSON ? new DataFile(data.articlesOfIncorporation) : <DataFile>this.articlesOfIncorporation;
            this.bankInfo = data.bankInfo && !(<any>data.bankInfo).toJSON ? new BankInfo(data.bankInfo) : <BankInfo>this.bankInfo;
            this.primaryUser = data.primaryUser && !(<any>data.primaryUser).toJSON ? new User(data.primaryUser) : <User>this.primaryUser;
            this.proofOfTaxCompliance = data.proofOfTaxCompliance && !(<any>data.proofOfTaxCompliance).toJSON ? new DataFile(data.proofOfTaxCompliance) : <DataFile>this.proofOfTaxCompliance;
            if (data.projects) {
                this.projects = [];
                for (let i = 0; i < data.projects.length; i++) {
                    let item = data.projects[i];
                    this.projects[i] = item && !(<any>item).toJSON ? new Project(item) : <Project>item;
                }
            }
            if (data.userProfiles) {
                this.userProfiles = [];
                for (let i = 0; i < data.userProfiles.length; i++) {
                    let item = data.userProfiles[i];
                    this.userProfiles[i] = item && !(<any>item).toJSON ? new UserProfile(item) : <UserProfile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.name = _data["name"];
            this.addressId = _data["addressId"];
            this.phoneNumber = _data["phoneNumber"];
            this.articlesOfIncorporationId = _data["articlesOfIncorporationId"];
            this.proofOfTaxComplianceId = _data["proofOfTaxComplianceId"];
            this.bankInfoId = _data["bankInfoId"];
            this.primaryUserId = _data["primaryUserId"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.status = _data["status"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.articlesOfIncorporation = _data["articlesOfIncorporation"] ? DataFile.fromJS(_data["articlesOfIncorporation"]) : <any>undefined;
            this.bankInfo = _data["bankInfo"] ? BankInfo.fromJS(_data["bankInfo"]) : <any>undefined;
            this.primaryUser = _data["primaryUser"] ? User.fromJS(_data["primaryUser"]) : <any>undefined;
            this.proofOfTaxCompliance = _data["proofOfTaxCompliance"] ? DataFile.fromJS(_data["proofOfTaxCompliance"]) : <any>undefined;
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["userProfiles"])) {
                this.userProfiles = [] as any;
                for (let item of _data["userProfiles"])
                    this.userProfiles!.push(UserProfile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["name"] = this.name;
        data["addressId"] = this.addressId;
        data["phoneNumber"] = this.phoneNumber;
        data["articlesOfIncorporationId"] = this.articlesOfIncorporationId;
        data["proofOfTaxComplianceId"] = this.proofOfTaxComplianceId;
        data["bankInfoId"] = this.bankInfoId;
        data["primaryUserId"] = this.primaryUserId;
        data["taxIdNumber"] = this.taxIdNumber;
        data["status"] = this.status;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["articlesOfIncorporation"] = this.articlesOfIncorporation ? this.articlesOfIncorporation.toJSON() : <any>undefined;
        data["bankInfo"] = this.bankInfo ? this.bankInfo.toJSON() : <any>undefined;
        data["primaryUser"] = this.primaryUser ? this.primaryUser.toJSON() : <any>undefined;
        data["proofOfTaxCompliance"] = this.proofOfTaxCompliance ? this.proofOfTaxCompliance.toJSON() : <any>undefined;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.userProfiles)) {
            data["userProfiles"] = [];
            for (let item of this.userProfiles)
                data["userProfiles"].push(item.toJSON());
        }
        return data;
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    addressId?: string | undefined;
    phoneNumber?: string | undefined;
    articlesOfIncorporationId?: string | undefined;
    proofOfTaxComplianceId?: string | undefined;
    bankInfoId?: string | undefined;
    primaryUserId?: string;
    taxIdNumber?: string | undefined;
    status?: CompanyStatus;
    address?: IAddress;
    articlesOfIncorporation?: IDataFile;
    bankInfo?: IBankInfo;
    primaryUser?: IUser;
    proofOfTaxCompliance?: IDataFile;
    projects?: IProject[] | undefined;
    userProfiles?: IUserProfile[] | undefined;
}

export class CompanyDetailsModel implements ICompanyDetailsModel {
    id?: string;
    userId?: string;
    taxIdNumber?: string | undefined;
    name?: string | undefined;
    address?: Address;
    phoneNumber?: string | undefined;
    articlesOfIncorporationUrl?: string | undefined;
    proofOfTaxComplianceUrl?: string | undefined;
    bankInfo?: BankInfo;
    articlesOfIncorporationFileName?: string | undefined;
    proofOfTaxComplianceFileName?: string | undefined;

    constructor(data?: ICompanyDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.bankInfo = data.bankInfo && !(<any>data.bankInfo).toJSON ? new BankInfo(data.bankInfo) : <BankInfo>this.bankInfo;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.articlesOfIncorporationUrl = _data["articlesOfIncorporationUrl"];
            this.proofOfTaxComplianceUrl = _data["proofOfTaxComplianceUrl"];
            this.bankInfo = _data["bankInfo"] ? BankInfo.fromJS(_data["bankInfo"]) : <any>undefined;
            this.articlesOfIncorporationFileName = _data["articlesOfIncorporationFileName"];
            this.proofOfTaxComplianceFileName = _data["proofOfTaxComplianceFileName"];
        }
    }

    static fromJS(data: any): CompanyDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["taxIdNumber"] = this.taxIdNumber;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["articlesOfIncorporationUrl"] = this.articlesOfIncorporationUrl;
        data["proofOfTaxComplianceUrl"] = this.proofOfTaxComplianceUrl;
        data["bankInfo"] = this.bankInfo ? this.bankInfo.toJSON() : <any>undefined;
        data["articlesOfIncorporationFileName"] = this.articlesOfIncorporationFileName;
        data["proofOfTaxComplianceFileName"] = this.proofOfTaxComplianceFileName;
        return data;
    }

    clone(): CompanyDetailsModel {
        const json = this.toJSON();
        let result = new CompanyDetailsModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyDetailsModel {
    id?: string;
    userId?: string;
    taxIdNumber?: string | undefined;
    name?: string | undefined;
    address?: IAddress;
    phoneNumber?: string | undefined;
    articlesOfIncorporationUrl?: string | undefined;
    proofOfTaxComplianceUrl?: string | undefined;
    bankInfo?: IBankInfo;
    articlesOfIncorporationFileName?: string | undefined;
    proofOfTaxComplianceFileName?: string | undefined;
}

export enum CompanyStatus {
    Active = "Active",
    Deactivate = "Deactivate",
}

export class ConfirmRegistrationCommandResponse implements IConfirmRegistrationCommandResponse {
    result?: IdentityResult;
    user?: SlimUser;

    constructor(data?: IConfirmRegistrationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result;
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfirmRegistrationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmRegistrationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): ConfirmRegistrationCommandResponse {
        const json = this.toJSON();
        let result = new ConfirmRegistrationCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IConfirmRegistrationCommandResponse {
    result?: IIdentityResult;
    user?: ISlimUser;
}

export class ConfirmRegistrationModel implements IConfirmRegistrationModel {
    emailAddress?: string | undefined;
    token?: string | undefined;

    constructor(data?: IConfirmRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ConfirmRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["token"] = this.token;
        return data;
    }

    clone(): ConfirmRegistrationModel {
        const json = this.toJSON();
        let result = new ConfirmRegistrationModel();
        result.init(json);
        return result;
    }
}

export interface IConfirmRegistrationModel {
    emailAddress?: string | undefined;
    token?: string | undefined;
}

export class ContactUsCommandRequest implements IContactUsCommandRequest {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    category?: string | undefined;
    message?: string | undefined;

    constructor(data?: IContactUsCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.category = _data["category"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ContactUsCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["category"] = this.category;
        data["message"] = this.message;
        return data;
    }

    clone(): ContactUsCommandRequest {
        const json = this.toJSON();
        let result = new ContactUsCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IContactUsCommandRequest {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    category?: string | undefined;
    message?: string | undefined;
}

export class CreateProjectCommandResponse implements ICreateProjectCommandResponse {
    project?: ProjectFullDetailsModel;

    constructor(data?: ICreateProjectCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectFullDetailsModel(data.project) : <ProjectFullDetailsModel>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectFullDetailsModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateProjectCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateProjectCommandResponse {
        const json = this.toJSON();
        let result = new CreateProjectCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateProjectCommandResponse {
    project?: IProjectFullDetailsModel;
}

export class CreateProjectModel implements ICreateProjectModel {
    name?: string | undefined;
    description?: string | undefined;
    subTitle?: string | undefined;
    amountRequested?: number | undefined;
    fundingPurpose?: FundingPurpose;
    category?: ProjectCategory;
    typeOfFunding?: FundingType;
    levelOfImpact?: string | undefined;
    timeToFunding?: string | undefined;
    videoUrl?: string | undefined;
    thumbnail?: Base64FileModel;
    dashboardPicture?: Base64FileModel;
    businessPlan?: Base64FileModel;
    documents?: DocumentModel[] | undefined;

    constructor(data?: ICreateProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.thumbnail = data.thumbnail && !(<any>data.thumbnail).toJSON ? new Base64FileModel(data.thumbnail) : <Base64FileModel>this.thumbnail;
            this.dashboardPicture = data.dashboardPicture && !(<any>data.dashboardPicture).toJSON ? new Base64FileModel(data.dashboardPicture) : <Base64FileModel>this.dashboardPicture;
            this.businessPlan = data.businessPlan && !(<any>data.businessPlan).toJSON ? new Base64FileModel(data.businessPlan) : <Base64FileModel>this.businessPlan;
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !(<any>item).toJSON ? new DocumentModel(item) : <DocumentModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.subTitle = _data["subTitle"];
            this.amountRequested = _data["amountRequested"];
            this.fundingPurpose = _data["fundingPurpose"];
            this.category = _data["category"];
            this.typeOfFunding = _data["typeOfFunding"];
            this.levelOfImpact = _data["levelOfImpact"];
            this.timeToFunding = _data["timeToFunding"];
            this.videoUrl = _data["videoUrl"];
            this.thumbnail = _data["thumbnail"] ? Base64FileModel.fromJS(_data["thumbnail"]) : <any>undefined;
            this.dashboardPicture = _data["dashboardPicture"] ? Base64FileModel.fromJS(_data["dashboardPicture"]) : <any>undefined;
            this.businessPlan = _data["businessPlan"] ? Base64FileModel.fromJS(_data["businessPlan"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["subTitle"] = this.subTitle;
        data["amountRequested"] = this.amountRequested;
        data["fundingPurpose"] = this.fundingPurpose;
        data["category"] = this.category;
        data["typeOfFunding"] = this.typeOfFunding;
        data["levelOfImpact"] = this.levelOfImpact;
        data["timeToFunding"] = this.timeToFunding;
        data["videoUrl"] = this.videoUrl;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["dashboardPicture"] = this.dashboardPicture ? this.dashboardPicture.toJSON() : <any>undefined;
        data["businessPlan"] = this.businessPlan ? this.businessPlan.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateProjectModel {
        const json = this.toJSON();
        let result = new CreateProjectModel();
        result.init(json);
        return result;
    }
}

export interface ICreateProjectModel {
    name?: string | undefined;
    description?: string | undefined;
    subTitle?: string | undefined;
    amountRequested?: number | undefined;
    fundingPurpose?: FundingPurpose;
    category?: ProjectCategory;
    typeOfFunding?: FundingType;
    levelOfImpact?: string | undefined;
    timeToFunding?: string | undefined;
    videoUrl?: string | undefined;
    thumbnail?: IBase64FileModel;
    dashboardPicture?: IBase64FileModel;
    businessPlan?: IBase64FileModel;
    documents?: IDocumentModel[] | undefined;
}

export class DataFile implements IDataFile {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    fileId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    type?: DataFileType;
    companyArticlesOfIncorporations?: Company[] | undefined;
    companyProofOfTaxCompliances?: Company[] | undefined;
    projectProjectDashboards?: Project[] | undefined;
    projectProjectDocuments?: Project[] | undefined;
    projectThumbnails?: Project[] | undefined;
    projectDocuments?: ProjectDocument[] | undefined;
    readonly url?: string | undefined;

    constructor(data?: IDataFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.companyArticlesOfIncorporations) {
                this.companyArticlesOfIncorporations = [];
                for (let i = 0; i < data.companyArticlesOfIncorporations.length; i++) {
                    let item = data.companyArticlesOfIncorporations[i];
                    this.companyArticlesOfIncorporations[i] = item && !(<any>item).toJSON ? new Company(item) : <Company>item;
                }
            }
            if (data.companyProofOfTaxCompliances) {
                this.companyProofOfTaxCompliances = [];
                for (let i = 0; i < data.companyProofOfTaxCompliances.length; i++) {
                    let item = data.companyProofOfTaxCompliances[i];
                    this.companyProofOfTaxCompliances[i] = item && !(<any>item).toJSON ? new Company(item) : <Company>item;
                }
            }
            if (data.projectProjectDashboards) {
                this.projectProjectDashboards = [];
                for (let i = 0; i < data.projectProjectDashboards.length; i++) {
                    let item = data.projectProjectDashboards[i];
                    this.projectProjectDashboards[i] = item && !(<any>item).toJSON ? new Project(item) : <Project>item;
                }
            }
            if (data.projectProjectDocuments) {
                this.projectProjectDocuments = [];
                for (let i = 0; i < data.projectProjectDocuments.length; i++) {
                    let item = data.projectProjectDocuments[i];
                    this.projectProjectDocuments[i] = item && !(<any>item).toJSON ? new Project(item) : <Project>item;
                }
            }
            if (data.projectThumbnails) {
                this.projectThumbnails = [];
                for (let i = 0; i < data.projectThumbnails.length; i++) {
                    let item = data.projectThumbnails[i];
                    this.projectThumbnails[i] = item && !(<any>item).toJSON ? new Project(item) : <Project>item;
                }
            }
            if (data.projectDocuments) {
                this.projectDocuments = [];
                for (let i = 0; i < data.projectDocuments.length; i++) {
                    let item = data.projectDocuments[i];
                    this.projectDocuments[i] = item && !(<any>item).toJSON ? new ProjectDocument(item) : <ProjectDocument>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.type = _data["type"];
            if (Array.isArray(_data["companyArticlesOfIncorporations"])) {
                this.companyArticlesOfIncorporations = [] as any;
                for (let item of _data["companyArticlesOfIncorporations"])
                    this.companyArticlesOfIncorporations!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["companyProofOfTaxCompliances"])) {
                this.companyProofOfTaxCompliances = [] as any;
                for (let item of _data["companyProofOfTaxCompliances"])
                    this.companyProofOfTaxCompliances!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["projectProjectDashboards"])) {
                this.projectProjectDashboards = [] as any;
                for (let item of _data["projectProjectDashboards"])
                    this.projectProjectDashboards!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["projectProjectDocuments"])) {
                this.projectProjectDocuments = [] as any;
                for (let item of _data["projectProjectDocuments"])
                    this.projectProjectDocuments!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["projectThumbnails"])) {
                this.projectThumbnails = [] as any;
                for (let item of _data["projectThumbnails"])
                    this.projectThumbnails!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["projectDocuments"])) {
                this.projectDocuments = [] as any;
                for (let item of _data["projectDocuments"])
                    this.projectDocuments!.push(ProjectDocument.fromJS(item));
            }
            (<any>this).url = _data["url"];
        }
    }

    static fromJS(data: any): DataFile {
        data = typeof data === 'object' ? data : {};
        let result = new DataFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["type"] = this.type;
        if (Array.isArray(this.companyArticlesOfIncorporations)) {
            data["companyArticlesOfIncorporations"] = [];
            for (let item of this.companyArticlesOfIncorporations)
                data["companyArticlesOfIncorporations"].push(item.toJSON());
        }
        if (Array.isArray(this.companyProofOfTaxCompliances)) {
            data["companyProofOfTaxCompliances"] = [];
            for (let item of this.companyProofOfTaxCompliances)
                data["companyProofOfTaxCompliances"].push(item.toJSON());
        }
        if (Array.isArray(this.projectProjectDashboards)) {
            data["projectProjectDashboards"] = [];
            for (let item of this.projectProjectDashboards)
                data["projectProjectDashboards"].push(item.toJSON());
        }
        if (Array.isArray(this.projectProjectDocuments)) {
            data["projectProjectDocuments"] = [];
            for (let item of this.projectProjectDocuments)
                data["projectProjectDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.projectThumbnails)) {
            data["projectThumbnails"] = [];
            for (let item of this.projectThumbnails)
                data["projectThumbnails"].push(item.toJSON());
        }
        if (Array.isArray(this.projectDocuments)) {
            data["projectDocuments"] = [];
            for (let item of this.projectDocuments)
                data["projectDocuments"].push(item.toJSON());
        }
        data["url"] = this.url;
        return data;
    }

    clone(): DataFile {
        const json = this.toJSON();
        let result = new DataFile();
        result.init(json);
        return result;
    }
}

export interface IDataFile {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    fileId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    type?: DataFileType;
    companyArticlesOfIncorporations?: ICompany[] | undefined;
    companyProofOfTaxCompliances?: ICompany[] | undefined;
    projectProjectDashboards?: IProject[] | undefined;
    projectProjectDocuments?: IProject[] | undefined;
    projectThumbnails?: IProject[] | undefined;
    projectDocuments?: IProjectDocument[] | undefined;
    url?: string | undefined;
}

export enum DataFileType {
    ArticlesOfIncorporation = "ArticlesOfIncorporation",
    ProofOfTaxCompliance = "ProofOfTaxCompliance",
    ProjectThumbnail = "ProjectThumbnail",
    ProjectDashboard = "ProjectDashboard",
    ProjectDocument = "ProjectDocument",
    GalleryDocument = "GalleryDocument",
    ProjectCloseOut = "ProjectCloseOut",
    HomePageImage = "HomePageImage",
    NewsArticleImage = "NewsArticleImage",
}

export class DocumentModel implements IDocumentModel {
    id?: string | undefined;
    documentId?: string | undefined;
    fileId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    mimeType?: string | undefined;
    content?: Base64FileModel;
    fileType?: DataFileType;
    url?: string | undefined;
    removed?: boolean;

    constructor(data?: IDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.content = data.content && !(<any>data.content).toJSON ? new Base64FileModel(data.content) : <Base64FileModel>this.content;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.mimeType = _data["mimeType"];
            this.content = _data["content"] ? Base64FileModel.fromJS(_data["content"]) : <any>undefined;
            this.fileType = _data["fileType"];
            this.url = _data["url"];
            this.removed = _data["removed"];
        }
    }

    static fromJS(data: any): DocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["mimeType"] = this.mimeType;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["fileType"] = this.fileType;
        data["url"] = this.url;
        data["removed"] = this.removed;
        return data;
    }

    clone(): DocumentModel {
        const json = this.toJSON();
        let result = new DocumentModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentModel {
    id?: string | undefined;
    documentId?: string | undefined;
    fileId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    mimeType?: string | undefined;
    content?: IBase64FileModel;
    fileType?: DataFileType;
    url?: string | undefined;
    removed?: boolean;
}

export class EditCompanyModel implements IEditCompanyModel {
    id?: string;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    primaryUserId?: string;
    taxIdNumber?: string | undefined;
    articlesOfIncorporation?: any | undefined;
    proofOfTaxCompliance?: any | undefined;
    address?: Address;
    bankInfo?: BankInfo;
    proofOfIncorporationFileBase64?: Base64FileModel;
    proofOfTaxComplianceFileBase64?: Base64FileModel;

    constructor(data?: IEditCompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.bankInfo = data.bankInfo && !(<any>data.bankInfo).toJSON ? new BankInfo(data.bankInfo) : <BankInfo>this.bankInfo;
            this.proofOfIncorporationFileBase64 = data.proofOfIncorporationFileBase64 && !(<any>data.proofOfIncorporationFileBase64).toJSON ? new Base64FileModel(data.proofOfIncorporationFileBase64) : <Base64FileModel>this.proofOfIncorporationFileBase64;
            this.proofOfTaxComplianceFileBase64 = data.proofOfTaxComplianceFileBase64 && !(<any>data.proofOfTaxComplianceFileBase64).toJSON ? new Base64FileModel(data.proofOfTaxComplianceFileBase64) : <Base64FileModel>this.proofOfTaxComplianceFileBase64;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.primaryUserId = _data["primaryUserId"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.articlesOfIncorporation = _data["articlesOfIncorporation"];
            this.proofOfTaxCompliance = _data["proofOfTaxCompliance"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.bankInfo = _data["bankInfo"] ? BankInfo.fromJS(_data["bankInfo"]) : <any>undefined;
            this.proofOfIncorporationFileBase64 = _data["proofOfIncorporationFileBase64"] ? Base64FileModel.fromJS(_data["proofOfIncorporationFileBase64"]) : <any>undefined;
            this.proofOfTaxComplianceFileBase64 = _data["proofOfTaxComplianceFileBase64"] ? Base64FileModel.fromJS(_data["proofOfTaxComplianceFileBase64"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditCompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["primaryUserId"] = this.primaryUserId;
        data["taxIdNumber"] = this.taxIdNumber;
        data["articlesOfIncorporation"] = this.articlesOfIncorporation;
        data["proofOfTaxCompliance"] = this.proofOfTaxCompliance;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["bankInfo"] = this.bankInfo ? this.bankInfo.toJSON() : <any>undefined;
        data["proofOfIncorporationFileBase64"] = this.proofOfIncorporationFileBase64 ? this.proofOfIncorporationFileBase64.toJSON() : <any>undefined;
        data["proofOfTaxComplianceFileBase64"] = this.proofOfTaxComplianceFileBase64 ? this.proofOfTaxComplianceFileBase64.toJSON() : <any>undefined;
        return data;
    }

    clone(): EditCompanyModel {
        const json = this.toJSON();
        let result = new EditCompanyModel();
        result.init(json);
        return result;
    }
}

export interface IEditCompanyModel {
    id?: string;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    primaryUserId?: string;
    taxIdNumber?: string | undefined;
    articlesOfIncorporation?: any | undefined;
    proofOfTaxCompliance?: any | undefined;
    address?: IAddress;
    bankInfo?: IBankInfo;
    proofOfIncorporationFileBase64?: IBase64FileModel;
    proofOfTaxComplianceFileBase64?: IBase64FileModel;
}

export class EditProjectCommandResponse implements IEditProjectCommandResponse {
    project?: ProjectFullDetailsModel;

    constructor(data?: IEditProjectCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectFullDetailsModel(data.project) : <ProjectFullDetailsModel>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectFullDetailsModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditProjectCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditProjectCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): EditProjectCommandResponse {
        const json = this.toJSON();
        let result = new EditProjectCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEditProjectCommandResponse {
    project?: IProjectFullDetailsModel;
}

export class EditProjectModel implements IEditProjectModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    subTitle?: string | undefined;
    amountRequested?: number | undefined;
    fundingPurpose?: FundingPurpose;
    category?: ProjectCategory;
    reason?: string | undefined;
    typeOfFunding?: FundingType;
    levelOfImpact?: string | undefined;
    timeToFunding?: string | undefined;
    videoUrl?: string | undefined;
    thumbnail?: Base64FileModel;
    dashboardPicture?: Base64FileModel;
    businessPlan?: Base64FileModel;
    documents?: DocumentModel[] | undefined;

    constructor(data?: IEditProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.thumbnail = data.thumbnail && !(<any>data.thumbnail).toJSON ? new Base64FileModel(data.thumbnail) : <Base64FileModel>this.thumbnail;
            this.dashboardPicture = data.dashboardPicture && !(<any>data.dashboardPicture).toJSON ? new Base64FileModel(data.dashboardPicture) : <Base64FileModel>this.dashboardPicture;
            this.businessPlan = data.businessPlan && !(<any>data.businessPlan).toJSON ? new Base64FileModel(data.businessPlan) : <Base64FileModel>this.businessPlan;
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !(<any>item).toJSON ? new DocumentModel(item) : <DocumentModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.subTitle = _data["subTitle"];
            this.amountRequested = _data["amountRequested"];
            this.fundingPurpose = _data["fundingPurpose"];
            this.category = _data["category"];
            this.reason = _data["reason"];
            this.typeOfFunding = _data["typeOfFunding"];
            this.levelOfImpact = _data["levelOfImpact"];
            this.timeToFunding = _data["timeToFunding"];
            this.videoUrl = _data["videoUrl"];
            this.thumbnail = _data["thumbnail"] ? Base64FileModel.fromJS(_data["thumbnail"]) : <any>undefined;
            this.dashboardPicture = _data["dashboardPicture"] ? Base64FileModel.fromJS(_data["dashboardPicture"]) : <any>undefined;
            this.businessPlan = _data["businessPlan"] ? Base64FileModel.fromJS(_data["businessPlan"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["subTitle"] = this.subTitle;
        data["amountRequested"] = this.amountRequested;
        data["fundingPurpose"] = this.fundingPurpose;
        data["category"] = this.category;
        data["reason"] = this.reason;
        data["typeOfFunding"] = this.typeOfFunding;
        data["levelOfImpact"] = this.levelOfImpact;
        data["timeToFunding"] = this.timeToFunding;
        data["videoUrl"] = this.videoUrl;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["dashboardPicture"] = this.dashboardPicture ? this.dashboardPicture.toJSON() : <any>undefined;
        data["businessPlan"] = this.businessPlan ? this.businessPlan.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }

    clone(): EditProjectModel {
        const json = this.toJSON();
        let result = new EditProjectModel();
        result.init(json);
        return result;
    }
}

export interface IEditProjectModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    subTitle?: string | undefined;
    amountRequested?: number | undefined;
    fundingPurpose?: FundingPurpose;
    category?: ProjectCategory;
    reason?: string | undefined;
    typeOfFunding?: FundingType;
    levelOfImpact?: string | undefined;
    timeToFunding?: string | undefined;
    videoUrl?: string | undefined;
    thumbnail?: IBase64FileModel;
    dashboardPicture?: IBase64FileModel;
    businessPlan?: IBase64FileModel;
    documents?: IDocumentModel[] | undefined;
}

export class EditRoleCommandResponse implements IEditRoleCommandResponse {
    role?: Role;

    constructor(data?: IEditRoleCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.role = data.role && !(<any>data.role).toJSON ? new Role(data.role) : <Role>this.role;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditRoleCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditRoleCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data;
    }

    clone(): EditRoleCommandResponse {
        const json = this.toJSON();
        let result = new EditRoleCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEditRoleCommandResponse {
    role?: IRole;
}

export class EditRoleModel implements IEditRoleModel {
    roleId?: string;
    roleName?: string | undefined;
    description?: string | undefined;
    selectedOperations?: string[] | undefined;

    constructor(data?: IEditRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.description = _data["description"];
            if (Array.isArray(_data["selectedOperations"])) {
                this.selectedOperations = [] as any;
                for (let item of _data["selectedOperations"])
                    this.selectedOperations!.push(item);
            }
        }
    }

    static fromJS(data: any): EditRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["description"] = this.description;
        if (Array.isArray(this.selectedOperations)) {
            data["selectedOperations"] = [];
            for (let item of this.selectedOperations)
                data["selectedOperations"].push(item);
        }
        return data;
    }

    clone(): EditRoleModel {
        const json = this.toJSON();
        let result = new EditRoleModel();
        result.init(json);
        return result;
    }
}

export interface IEditRoleModel {
    roleId?: string;
    roleName?: string | undefined;
    description?: string | undefined;
    selectedOperations?: string[] | undefined;
}

export class EditUserCommandResponse implements IEditUserCommandResponse {
    user?: SlimUser;

    constructor(data?: IEditUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): EditUserCommandResponse {
        const json = this.toJSON();
        let result = new EditUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEditUserCommandResponse {
    user?: ISlimUser;
}

export class EditUserModel implements IEditUserModel {
    id?: string;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;
    operations?: string[] | undefined;

    constructor(data?: IEditUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.confirmEmailAddress = _data["confirmEmailAddress"];
            this.password = _data["password"];
            this.confirmationPassword = _data["confirmationPassword"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
        }
    }

    static fromJS(data: any): EditUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["confirmEmailAddress"] = this.confirmEmailAddress;
        data["password"] = this.password;
        data["confirmationPassword"] = this.confirmationPassword;
        data["taxIdNumber"] = this.taxIdNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        return data;
    }

    clone(): EditUserModel {
        const json = this.toJSON();
        let result = new EditUserModel();
        result.init(json);
        return result;
    }
}

export interface IEditUserModel {
    id?: string;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;
    operations?: string[] | undefined;
}

export class ExcutePaypalPaymentModel implements IExcutePaypalPaymentModel {
    payerID?: string | undefined;
    paymentId?: string | undefined;
    token?: string | undefined;

    constructor(data?: IExcutePaypalPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerID = _data["payerID"];
            this.paymentId = _data["paymentId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ExcutePaypalPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExcutePaypalPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerID"] = this.payerID;
        data["paymentId"] = this.paymentId;
        data["token"] = this.token;
        return data;
    }

    clone(): ExcutePaypalPaymentModel {
        const json = this.toJSON();
        let result = new ExcutePaypalPaymentModel();
        result.init(json);
        return result;
    }
}

export interface IExcutePaypalPaymentModel {
    payerID?: string | undefined;
    paymentId?: string | undefined;
    token?: string | undefined;
}

export class ExecutePaypalResponse implements IExecutePaypalResponse {
    paymentStatus?: PaymentStatus;
    message?: string | undefined;
    readonly isSuccessful?: boolean;
    orderId?: string;
    paymentId?: string | undefined;
    failureMessage?: string | undefined;
    baseUrl?: string | undefined;

    constructor(data?: IExecutePaypalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentStatus = _data["paymentStatus"];
            this.message = _data["message"];
            (<any>this).isSuccessful = _data["isSuccessful"];
            this.orderId = _data["orderId"];
            this.paymentId = _data["paymentId"];
            this.failureMessage = _data["failureMessage"];
            this.baseUrl = _data["baseUrl"];
        }
    }

    static fromJS(data: any): ExecutePaypalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutePaypalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentStatus"] = this.paymentStatus;
        data["message"] = this.message;
        data["isSuccessful"] = this.isSuccessful;
        data["orderId"] = this.orderId;
        data["paymentId"] = this.paymentId;
        data["failureMessage"] = this.failureMessage;
        data["baseUrl"] = this.baseUrl;
        return data;
    }

    clone(): ExecutePaypalResponse {
        const json = this.toJSON();
        let result = new ExecutePaypalResponse();
        result.init(json);
        return result;
    }
}

export interface IExecutePaypalResponse {
    paymentStatus?: PaymentStatus;
    message?: string | undefined;
    isSuccessful?: boolean;
    orderId?: string;
    paymentId?: string | undefined;
    failureMessage?: string | undefined;
    baseUrl?: string | undefined;
}

export class ExportPledgesResponse implements IExportPledgesResponse {
    success?: boolean;
    exported?: Stream;
    readonly fileName?: string | undefined;
    extension?: string | undefined;
    readonly mimeType?: string | undefined;

    constructor(data?: IExportPledgesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.exported = data.exported && !(<any>data.exported).toJSON ? new Stream(data.exported) : <Stream>this.exported;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.exported = _data["exported"] ? Stream.fromJS(_data["exported"]) : <any>undefined;
            (<any>this).fileName = _data["fileName"];
            this.extension = _data["extension"];
            (<any>this).mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): ExportPledgesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPledgesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["exported"] = this.exported ? this.exported.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        return data;
    }

    clone(): ExportPledgesResponse {
        const json = this.toJSON();
        let result = new ExportPledgesResponse();
        result.init(json);
        return result;
    }
}

export interface IExportPledgesResponse {
    success?: boolean;
    exported?: IStream;
    fileName?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
}

export class Filter implements IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: Filter[] | undefined;
    ignore?: boolean | undefined;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.groupFilters) {
                this.groupFilters = [];
                for (let i = 0; i < data.groupFilters.length; i++) {
                    let item = data.groupFilters[i];
                    this.groupFilters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.filterType = _data["filterType"];
            this.value = _data["value"];
            this.joinType = _data["joinType"];
            if (Array.isArray(_data["groupFilters"])) {
                this.groupFilters = [] as any;
                for (let item of _data["groupFilters"])
                    this.groupFilters!.push(Filter.fromJS(item));
            }
            this.ignore = _data["ignore"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["filterType"] = this.filterType;
        data["value"] = this.value;
        data["joinType"] = this.joinType;
        if (Array.isArray(this.groupFilters)) {
            data["groupFilters"] = [];
            for (let item of this.groupFilters)
                data["groupFilters"].push(item.toJSON());
        }
        data["ignore"] = this.ignore;
        return data;
    }

    clone(): Filter {
        const json = this.toJSON();
        let result = new Filter();
        result.init(json);
        return result;
    }
}

export interface IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: IFilter[] | undefined;
    ignore?: boolean | undefined;
}

export enum FilterType {
    Contains = "Contains",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqualTo = "GreaterThanOrEqualTo",
    LessThan = "LessThan",
    LessThanOrEqualTo = "LessThanOrEqualTo",
    Equal = "Equal",
    NotEqual = "NotEqual",
    Group = "Group",
}

export class FinalizeCartResponse implements IFinalizeCartResponse {
    receiptNumber?: string | undefined;

    constructor(data?: IFinalizeCartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptNumber = _data["receiptNumber"];
        }
    }

    static fromJS(data: any): FinalizeCartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FinalizeCartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptNumber"] = this.receiptNumber;
        return data;
    }

    clone(): FinalizeCartResponse {
        const json = this.toJSON();
        let result = new FinalizeCartResponse();
        result.init(json);
        return result;
    }
}

export interface IFinalizeCartResponse {
    receiptNumber?: string | undefined;
}

export class FullCartItemModel implements IFullCartItemModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    amountRequested?: number | undefined;
    amountRecieved?: number | undefined;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    timeToFunding?: string | undefined;
    companyId?: string | undefined;
    companyName?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    projectDashboardFileUrl?: string | undefined;
    levelOfImpact?: string | undefined;
    status?: ProjectStatus;
    amount?: number;

    constructor(data?: IFullCartItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.amountRequested = _data["amountRequested"];
            this.amountRecieved = _data["amountRecieved"];
            this.typeOfFunding = _data["typeOfFunding"];
            this.fundingPurpose = _data["fundingPurpose"];
            this.timeToFunding = _data["timeToFunding"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.thumbnailFileUrl = _data["thumbnailFileUrl"];
            this.projectDashboardFileUrl = _data["projectDashboardFileUrl"];
            this.levelOfImpact = _data["levelOfImpact"];
            this.status = _data["status"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): FullCartItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new FullCartItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["amountRequested"] = this.amountRequested;
        data["amountRecieved"] = this.amountRecieved;
        data["typeOfFunding"] = this.typeOfFunding;
        data["fundingPurpose"] = this.fundingPurpose;
        data["timeToFunding"] = this.timeToFunding;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["thumbnailFileUrl"] = this.thumbnailFileUrl;
        data["projectDashboardFileUrl"] = this.projectDashboardFileUrl;
        data["levelOfImpact"] = this.levelOfImpact;
        data["status"] = this.status;
        data["amount"] = this.amount;
        return data;
    }

    clone(): FullCartItemModel {
        const json = this.toJSON();
        let result = new FullCartItemModel();
        result.init(json);
        return result;
    }
}

export interface IFullCartItemModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    amountRequested?: number | undefined;
    amountRecieved?: number | undefined;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    timeToFunding?: string | undefined;
    companyId?: string | undefined;
    companyName?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    projectDashboardFileUrl?: string | undefined;
    levelOfImpact?: string | undefined;
    status?: ProjectStatus;
    amount?: number;
}

export enum FundingPurpose {
    Seed = "Seed",
    Early = "Early",
    Growth = "Growth",
}

export enum FundingType {
    SocialInvestment = "SocialInvestment",
    ImpactInvestment = "ImpactInvestment",
}

export class FygaroPaymentAPIModel implements IFygaroPaymentAPIModel {
    reference?: string | undefined;
    customReference?: string | undefined;
    createdAt?: number;
    jwt?: string | undefined;

    constructor(data?: IFygaroPaymentAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.customReference = _data["customReference"];
            this.createdAt = _data["createdAt"];
            this.jwt = _data["jwt"];
        }
    }

    static fromJS(data: any): FygaroPaymentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new FygaroPaymentAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["customReference"] = this.customReference;
        data["createdAt"] = this.createdAt;
        data["jwt"] = this.jwt;
        return data;
    }

    clone(): FygaroPaymentAPIModel {
        const json = this.toJSON();
        let result = new FygaroPaymentAPIModel();
        result.init(json);
        return result;
    }
}

export interface IFygaroPaymentAPIModel {
    reference?: string | undefined;
    customReference?: string | undefined;
    createdAt?: number;
    jwt?: string | undefined;
}

export class GetAllAuditHeaderByFilterModel implements IGetAllAuditHeaderByFilterModel {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllAuditHeaderByFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAuditHeaderByFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAuditHeaderByFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllAuditHeaderByFilterModel {
        const json = this.toJSON();
        let result = new GetAllAuditHeaderByFilterModel();
        result.init(json);
        return result;
    }
}

export interface IGetAllAuditHeaderByFilterModel {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllAuditHeaderByFilterQueryResponse implements IGetAllAuditHeaderByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: AuditHeader[] | undefined;
    count?: number;

    constructor(data?: IGetAllAuditHeaderByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new AuditHeader(item) : <AuditHeader>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AuditHeader.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllAuditHeaderByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAuditHeaderByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetAllAuditHeaderByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllAuditHeaderByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllAuditHeaderByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IAuditHeader[] | undefined;
    count?: number;
}

export class GetAllNewsByFilterQueryRequest implements IGetAllNewsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllNewsByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllNewsByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNewsByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllNewsByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllNewsByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllNewsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllNewsByFilterQueryResponse implements IGetAllNewsByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: NewsListModel[] | undefined;
    count?: number;

    constructor(data?: IGetAllNewsByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new NewsListModel(item) : <NewsListModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(NewsListModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllNewsByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNewsByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetAllNewsByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllNewsByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllNewsByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: INewsListModel[] | undefined;
    count?: number;
}

export class GetAllRolesByFilterModel implements IGetAllRolesByFilterModel {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllRolesByFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllRolesByFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRolesByFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllRolesByFilterModel {
        const json = this.toJSON();
        let result = new GetAllRolesByFilterModel();
        result.init(json);
        return result;
    }
}

export interface IGetAllRolesByFilterModel {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllRolesByFilterQueryResponse implements IGetAllRolesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: Role[] | undefined;
    count?: number;

    constructor(data?: IGetAllRolesByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Role(item) : <Role>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Role.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllRolesByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRolesByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetAllRolesByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllRolesByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllRolesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IRole[] | undefined;
    count?: number;
}

export class GetAllUsersByFilterModel implements IGetAllUsersByFilterModel {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllUsersByFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllUsersByFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersByFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllUsersByFilterModel {
        const json = this.toJSON();
        let result = new GetAllUsersByFilterModel();
        result.init(json);
        return result;
    }
}

export interface IGetAllUsersByFilterModel {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllUsersByFilterQueryResponse implements IGetAllUsersByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SlimUser[] | undefined;
    count?: number;

    constructor(data?: IGetAllUsersByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimUser(item) : <SlimUser>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimUser.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllUsersByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetAllUsersByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllUsersByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllUsersByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISlimUser[] | undefined;
    count?: number;
}

export class GetAuditByIdModel implements IGetAuditByIdModel {
    id?: string;

    constructor(data?: IGetAuditByIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAuditByIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditByIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): GetAuditByIdModel {
        const json = this.toJSON();
        let result = new GetAuditByIdModel();
        result.init(json);
        return result;
    }
}

export interface IGetAuditByIdModel {
    id?: string;
}

export class GetAuditByIdQueryResponse implements IGetAuditByIdQueryResponse {
    header?: AuditHeader;

    constructor(data?: IGetAuditByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.header = data.header && !(<any>data.header).toJSON ? new AuditHeader(data.header) : <AuditHeader>this.header;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? AuditHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAuditByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAuditByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetAuditByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAuditByIdQueryResponse {
    header?: IAuditHeader;
}

export class GetBannerImageCommandResponse implements IGetBannerImageCommandResponse {
    images?: HomePageImage;

    constructor(data?: IGetBannerImageCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.images = data.images && !(<any>data.images).toJSON ? new HomePageImage(data.images) : <HomePageImage>this.images;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.images = _data["images"] ? HomePageImage.fromJS(_data["images"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBannerImageCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBannerImageCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["images"] = this.images ? this.images.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetBannerImageCommandResponse {
        const json = this.toJSON();
        let result = new GetBannerImageCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetBannerImageCommandResponse {
    images?: IHomePageImage;
}

export class GetBasicCartQueryResponse implements IGetBasicCartQueryResponse {
    cart?: CartModel;

    constructor(data?: IGetBasicCartQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new CartModel(data.cart) : <CartModel>this.cart;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? CartModel.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBasicCartQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBasicCartQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetBasicCartQueryResponse {
        const json = this.toJSON();
        let result = new GetBasicCartQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetBasicCartQueryResponse {
    cart?: ICartModel;
}

export class GetCompanyByIdForEntrepreneurResponse implements IGetCompanyByIdForEntrepreneurResponse {
    companyDetails?: CompanyDetailsModel;

    constructor(data?: IGetCompanyByIdForEntrepreneurResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.companyDetails = data.companyDetails && !(<any>data.companyDetails).toJSON ? new CompanyDetailsModel(data.companyDetails) : <CompanyDetailsModel>this.companyDetails;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetails = _data["companyDetails"] ? CompanyDetailsModel.fromJS(_data["companyDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyByIdForEntrepreneurResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyByIdForEntrepreneurResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetails"] = this.companyDetails ? this.companyDetails.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCompanyByIdForEntrepreneurResponse {
        const json = this.toJSON();
        let result = new GetCompanyByIdForEntrepreneurResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCompanyByIdForEntrepreneurResponse {
    companyDetails?: ICompanyDetailsModel;
}

export class GetDonationsByFilterForCompanyQueryRequest implements IGetDonationsByFilterForCompanyQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    userId?: string;

    constructor(data?: IGetDonationsByFilterForCompanyQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetDonationsByFilterForCompanyQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationsByFilterForCompanyQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        data["userId"] = this.userId;
        return data;
    }

    clone(): GetDonationsByFilterForCompanyQueryRequest {
        const json = this.toJSON();
        let result = new GetDonationsByFilterForCompanyQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetDonationsByFilterForCompanyQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    userId?: string;
}

export class GetDonationsByFilterForCompanyQueryResponse implements IGetDonationsByFilterForCompanyQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SimpleOrderListItem[] | undefined;
    count?: number;

    constructor(data?: IGetDonationsByFilterForCompanyQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SimpleOrderListItem(item) : <SimpleOrderListItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SimpleOrderListItem.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetDonationsByFilterForCompanyQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationsByFilterForCompanyQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetDonationsByFilterForCompanyQueryResponse {
        const json = this.toJSON();
        let result = new GetDonationsByFilterForCompanyQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonationsByFilterForCompanyQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISimpleOrderListItem[] | undefined;
    count?: number;
}

export class GetDonationsByFilterForInvestorQueryRequest implements IGetDonationsByFilterForInvestorQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    userId?: string;

    constructor(data?: IGetDonationsByFilterForInvestorQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetDonationsByFilterForInvestorQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationsByFilterForInvestorQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        data["userId"] = this.userId;
        return data;
    }

    clone(): GetDonationsByFilterForInvestorQueryRequest {
        const json = this.toJSON();
        let result = new GetDonationsByFilterForInvestorQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetDonationsByFilterForInvestorQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    userId?: string;
}

export class GetDonationsByFilterForInvestorQueryResponse implements IGetDonationsByFilterForInvestorQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SimpleOrderListItem[] | undefined;
    count?: number;

    constructor(data?: IGetDonationsByFilterForInvestorQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SimpleOrderListItem(item) : <SimpleOrderListItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SimpleOrderListItem.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetDonationsByFilterForInvestorQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationsByFilterForInvestorQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetDonationsByFilterForInvestorQueryResponse {
        const json = this.toJSON();
        let result = new GetDonationsByFilterForInvestorQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonationsByFilterForInvestorQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISimpleOrderListItem[] | undefined;
    count?: number;
}

export class GetDonationsByFilterQueryRequest implements IGetDonationsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetDonationsByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDonationsByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationsByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDonationsByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetDonationsByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetDonationsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetDonationsByFilterQueryResponse implements IGetDonationsByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SimpleOrderListItem[] | undefined;
    count?: number;

    constructor(data?: IGetDonationsByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SimpleOrderListItem(item) : <SimpleOrderListItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SimpleOrderListItem.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetDonationsByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationsByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetDonationsByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetDonationsByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonationsByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISimpleOrderListItem[] | undefined;
    count?: number;
}

export class GetFileByIdQueryResponse implements IGetFileByIdQueryResponse {
    file?: MemoryStream;

    constructor(data?: IGetFileByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.file = data.file && !(<any>data.file).toJSON ? new MemoryStream(data.file) : <MemoryStream>this.file;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? MemoryStream.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFileByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetFileByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetFileByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFileByIdQueryResponse {
    file?: IMemoryStream;
}

export class GetFullCartQueryResponse implements IGetFullCartQueryResponse {
    id?: string;
    cart?: FullCartItemModel[] | undefined;

    constructor(data?: IGetFullCartQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.cart) {
                this.cart = [];
                for (let i = 0; i < data.cart.length; i++) {
                    let item = data.cart[i];
                    this.cart[i] = item && !(<any>item).toJSON ? new FullCartItemModel(item) : <FullCartItemModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["cart"])) {
                this.cart = [] as any;
                for (let item of _data["cart"])
                    this.cart!.push(FullCartItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFullCartQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFullCartQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.cart)) {
            data["cart"] = [];
            for (let item of this.cart)
                data["cart"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetFullCartQueryResponse {
        const json = this.toJSON();
        let result = new GetFullCartQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFullCartQueryResponse {
    id?: string;
    cart?: IFullCartItemModel[] | undefined;
}

export class GetMyCompanyProfileQueryResponse implements IGetMyCompanyProfileQueryResponse {
    id?: string;
    userId?: string;
    taxIdNumber?: string | undefined;
    name?: string | undefined;
    address?: Address;
    phoneNumber?: string | undefined;
    articlesOfIncorporationUrl?: string | undefined;
    proofOfTaxComplianceUrl?: string | undefined;
    bankInfo?: BankInfo;
    articlesOfIncorporationFileName?: string | undefined;
    proofOfTaxComplianceFileName?: string | undefined;

    constructor(data?: IGetMyCompanyProfileQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.bankInfo = data.bankInfo && !(<any>data.bankInfo).toJSON ? new BankInfo(data.bankInfo) : <BankInfo>this.bankInfo;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.articlesOfIncorporationUrl = _data["articlesOfIncorporationUrl"];
            this.proofOfTaxComplianceUrl = _data["proofOfTaxComplianceUrl"];
            this.bankInfo = _data["bankInfo"] ? BankInfo.fromJS(_data["bankInfo"]) : <any>undefined;
            this.articlesOfIncorporationFileName = _data["articlesOfIncorporationFileName"];
            this.proofOfTaxComplianceFileName = _data["proofOfTaxComplianceFileName"];
        }
    }

    static fromJS(data: any): GetMyCompanyProfileQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyCompanyProfileQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["taxIdNumber"] = this.taxIdNumber;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["articlesOfIncorporationUrl"] = this.articlesOfIncorporationUrl;
        data["proofOfTaxComplianceUrl"] = this.proofOfTaxComplianceUrl;
        data["bankInfo"] = this.bankInfo ? this.bankInfo.toJSON() : <any>undefined;
        data["articlesOfIncorporationFileName"] = this.articlesOfIncorporationFileName;
        data["proofOfTaxComplianceFileName"] = this.proofOfTaxComplianceFileName;
        return data;
    }

    clone(): GetMyCompanyProfileQueryResponse {
        const json = this.toJSON();
        let result = new GetMyCompanyProfileQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMyCompanyProfileQueryResponse {
    id?: string;
    userId?: string;
    taxIdNumber?: string | undefined;
    name?: string | undefined;
    address?: IAddress;
    phoneNumber?: string | undefined;
    articlesOfIncorporationUrl?: string | undefined;
    proofOfTaxComplianceUrl?: string | undefined;
    bankInfo?: IBankInfo;
    articlesOfIncorporationFileName?: string | undefined;
    proofOfTaxComplianceFileName?: string | undefined;
}

export class GetMyProjectsByFilterQueryRequest implements IGetMyProjectsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    userId?: string | undefined;

    constructor(data?: IGetMyProjectsByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetMyProjectsByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyProjectsByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        data["userId"] = this.userId;
        return data;
    }

    clone(): GetMyProjectsByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetMyProjectsByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetMyProjectsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    userId?: string | undefined;
}

export class GetMyProjectsByFilterQueryResponse implements IGetMyProjectsByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: ProjectDetailsModel[] | undefined;
    count?: number;

    constructor(data?: IGetMyProjectsByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new ProjectDetailsModel(item) : <ProjectDetailsModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProjectDetailsModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetMyProjectsByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyProjectsByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetMyProjectsByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetMyProjectsByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMyProjectsByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IProjectDetailsModel[] | undefined;
    count?: number;
}

export class GetNewsByIdQueryRequest implements IGetNewsByIdQueryRequest {
    id?: string | undefined;

    constructor(data?: IGetNewsByIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetNewsByIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsByIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): GetNewsByIdQueryRequest {
        const json = this.toJSON();
        let result = new GetNewsByIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetNewsByIdQueryRequest {
    id?: string | undefined;
}

export class GetNewsByIdQueryResponse implements IGetNewsByIdQueryResponse {
    news?: News;

    constructor(data?: IGetNewsByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.news = data.news && !(<any>data.news).toJSON ? new News(data.news) : <News>this.news;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.news = _data["news"] ? News.fromJS(_data["news"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNewsByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["news"] = this.news ? this.news.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetNewsByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetNewsByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetNewsByIdQueryResponse {
    news?: INews;
}

export class GetNumberOfCartItemsResponse implements IGetNumberOfCartItemsResponse {
    numberOFCartItems?: number;

    constructor(data?: IGetNumberOfCartItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOFCartItems = _data["numberOFCartItems"];
        }
    }

    static fromJS(data: any): GetNumberOfCartItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNumberOfCartItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOFCartItems"] = this.numberOFCartItems;
        return data;
    }

    clone(): GetNumberOfCartItemsResponse {
        const json = this.toJSON();
        let result = new GetNumberOfCartItemsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetNumberOfCartItemsResponse {
    numberOFCartItems?: number;
}

export class GetOperationsListCommandResponse implements IGetOperationsListCommandResponse {
    readonly operations?: string[] | undefined;

    constructor(data?: IGetOperationsListCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                (<any>this).operations = [] as any;
                for (let item of _data["operations"])
                    (<any>this).operations!.push(item);
            }
        }
    }

    static fromJS(data: any): GetOperationsListCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperationsListCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        return data;
    }

    clone(): GetOperationsListCommandResponse {
        const json = this.toJSON();
        let result = new GetOperationsListCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetOperationsListCommandResponse {
    operations?: string[] | undefined;
}

export class GetOrderReceiptForInvestorQueryRequest implements IGetOrderReceiptForInvestorQueryRequest {
    id?: string | undefined;

    constructor(data?: IGetOrderReceiptForInvestorQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetOrderReceiptForInvestorQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderReceiptForInvestorQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): GetOrderReceiptForInvestorQueryRequest {
        const json = this.toJSON();
        let result = new GetOrderReceiptForInvestorQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetOrderReceiptForInvestorQueryRequest {
    id?: string | undefined;
}

export class GetPaymentConfigurationQueryResponse implements IGetPaymentConfigurationQueryResponse {
    paypalEnvironment?: string | undefined;
    paypalBeginUrl?: string | undefined;
    paypalCancelUrl?: string | undefined;
    paypalExecuteUrl?: string | undefined;

    constructor(data?: IGetPaymentConfigurationQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paypalEnvironment = _data["paypalEnvironment"];
            this.paypalBeginUrl = _data["paypalBeginUrl"];
            this.paypalCancelUrl = _data["paypalCancelUrl"];
            this.paypalExecuteUrl = _data["paypalExecuteUrl"];
        }
    }

    static fromJS(data: any): GetPaymentConfigurationQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentConfigurationQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paypalEnvironment"] = this.paypalEnvironment;
        data["paypalBeginUrl"] = this.paypalBeginUrl;
        data["paypalCancelUrl"] = this.paypalCancelUrl;
        data["paypalExecuteUrl"] = this.paypalExecuteUrl;
        return data;
    }

    clone(): GetPaymentConfigurationQueryResponse {
        const json = this.toJSON();
        let result = new GetPaymentConfigurationQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentConfigurationQueryResponse {
    paypalEnvironment?: string | undefined;
    paypalBeginUrl?: string | undefined;
    paypalCancelUrl?: string | undefined;
    paypalExecuteUrl?: string | undefined;
}

export class GetPaymentDetailsQueryResponse implements IGetPaymentDetailsQueryResponse {
    id?: string;
    receiptNo?: string | undefined;
    invoiceNumber?: string | undefined;
    transactionId?: string | undefined;
    user?: PaymentUser;
    currency?: string | undefined;
    donations?: SimpleOrderListItem[] | undefined;
    total?: number;
    date?: string | undefined;
    type?: PaymentType;
    paymentTypeName?: string | undefined;
    authCode?: string | undefined;
    cardType?: string | undefined;
    cardNumber?: string | undefined;
    status?: PaymentStatus;

    constructor(data?: IGetPaymentDetailsQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new PaymentUser(data.user) : <PaymentUser>this.user;
            if (data.donations) {
                this.donations = [];
                for (let i = 0; i < data.donations.length; i++) {
                    let item = data.donations[i];
                    this.donations[i] = item && !(<any>item).toJSON ? new SimpleOrderListItem(item) : <SimpleOrderListItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receiptNo = _data["receiptNo"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.transactionId = _data["transactionId"];
            this.user = _data["user"] ? PaymentUser.fromJS(_data["user"]) : <any>undefined;
            this.currency = _data["currency"];
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(SimpleOrderListItem.fromJS(item));
            }
            this.total = _data["total"];
            this.date = _data["date"];
            this.type = _data["type"];
            this.paymentTypeName = _data["paymentTypeName"];
            this.authCode = _data["authCode"];
            this.cardType = _data["cardType"];
            this.cardNumber = _data["cardNumber"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetPaymentDetailsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentDetailsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receiptNo"] = this.receiptNo;
        data["invoiceNumber"] = this.invoiceNumber;
        data["transactionId"] = this.transactionId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["date"] = this.date;
        data["type"] = this.type;
        data["paymentTypeName"] = this.paymentTypeName;
        data["authCode"] = this.authCode;
        data["cardType"] = this.cardType;
        data["cardNumber"] = this.cardNumber;
        data["status"] = this.status;
        return data;
    }

    clone(): GetPaymentDetailsQueryResponse {
        const json = this.toJSON();
        let result = new GetPaymentDetailsQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentDetailsQueryResponse {
    id?: string;
    receiptNo?: string | undefined;
    invoiceNumber?: string | undefined;
    transactionId?: string | undefined;
    user?: IPaymentUser;
    currency?: string | undefined;
    donations?: ISimpleOrderListItem[] | undefined;
    total?: number;
    date?: string | undefined;
    type?: PaymentType;
    paymentTypeName?: string | undefined;
    authCode?: string | undefined;
    cardType?: string | undefined;
    cardNumber?: string | undefined;
    status?: PaymentStatus;
}

export class GetPaymentsByFilterForInvestorQueryRequest implements IGetPaymentsByFilterForInvestorQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetPaymentsByFilterForInvestorQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPaymentsByFilterForInvestorQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsByFilterForInvestorQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPaymentsByFilterForInvestorQueryRequest {
        const json = this.toJSON();
        let result = new GetPaymentsByFilterForInvestorQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentsByFilterForInvestorQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetPaymentsByFilterForInvestorQueryResponse implements IGetPaymentsByFilterForInvestorQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: PaymentListItem[] | undefined;
    count?: number;

    constructor(data?: IGetPaymentsByFilterForInvestorQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new PaymentListItem(item) : <PaymentListItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PaymentListItem.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetPaymentsByFilterForInvestorQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsByFilterForInvestorQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetPaymentsByFilterForInvestorQueryResponse {
        const json = this.toJSON();
        let result = new GetPaymentsByFilterForInvestorQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentsByFilterForInvestorQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IPaymentListItem[] | undefined;
    count?: number;
}

export class GetPaymentsByFilterQueryRequest implements IGetPaymentsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetPaymentsByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPaymentsByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPaymentsByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetPaymentsByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetPaymentsByFilterQueryResponse implements IGetPaymentsByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: PaymentListItem[] | undefined;
    count?: number;

    constructor(data?: IGetPaymentsByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new PaymentListItem(item) : <PaymentListItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PaymentListItem.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetPaymentsByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetPaymentsByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetPaymentsByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentsByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IPaymentListItem[] | undefined;
    count?: number;
}

export class GetPledgesByFilterQueryRequest implements IGetPledgesByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetPledgesByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPledgesByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPledgesByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPledgesByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetPledgesByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPledgesByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetPledgesByFilterQueryResponse implements IGetPledgesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: PledgeListModel[] | undefined;
    count?: number;

    constructor(data?: IGetPledgesByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new PledgeListModel(item) : <PledgeListModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PledgeListModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetPledgesByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPledgesByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetPledgesByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetPledgesByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPledgesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IPledgeListModel[] | undefined;
    count?: number;
}

export class GetProjectByIdForAdminQueryResponse implements IGetProjectByIdForAdminQueryResponse {
    project?: ProjectFullDetailsModel;

    constructor(data?: IGetProjectByIdForAdminQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectFullDetailsModel(data.project) : <ProjectFullDetailsModel>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectFullDetailsModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectByIdForAdminQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectByIdForAdminQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetProjectByIdForAdminQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectByIdForAdminQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectByIdForAdminQueryResponse {
    project?: IProjectFullDetailsModel;
}

export class GetProjectByIdForEntrepreneurQueryResponse implements IGetProjectByIdForEntrepreneurQueryResponse {
    project?: ProjectFullDetailsModel;

    constructor(data?: IGetProjectByIdForEntrepreneurQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectFullDetailsModel(data.project) : <ProjectFullDetailsModel>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectFullDetailsModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectByIdForEntrepreneurQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectByIdForEntrepreneurQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetProjectByIdForEntrepreneurQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectByIdForEntrepreneurQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectByIdForEntrepreneurQueryResponse {
    project?: IProjectFullDetailsModel;
}

export class GetProjectByIdForPublicQueryResponse implements IGetProjectByIdForPublicQueryResponse {
    project?: ProjectFullDetailsModel;

    constructor(data?: IGetProjectByIdForPublicQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectFullDetailsModel(data.project) : <ProjectFullDetailsModel>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectFullDetailsModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectByIdForPublicQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectByIdForPublicQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetProjectByIdForPublicQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectByIdForPublicQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectByIdForPublicQueryResponse {
    project?: IProjectFullDetailsModel;
}

export class GetProjectDetailByIdQueryRequest implements IGetProjectDetailByIdQueryRequest {
    id?: string | undefined;

    constructor(data?: IGetProjectDetailByIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetProjectDetailByIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectDetailByIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): GetProjectDetailByIdQueryRequest {
        const json = this.toJSON();
        let result = new GetProjectDetailByIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetProjectDetailByIdQueryRequest {
    id?: string | undefined;
}

export class GetProjectDetailByIdQueryResponse implements IGetProjectDetailByIdQueryResponse {
    project?: ProjectDetailsModel;

    constructor(data?: IGetProjectDetailByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectDetailsModel(data.project) : <ProjectDetailsModel>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectDetailsModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectDetailByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectDetailByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetProjectDetailByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectDetailByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectDetailByIdQueryResponse {
    project?: IProjectDetailsModel;
}

export class GetProjectHistoryListByFilterQueryRequest implements IGetProjectHistoryListByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    id?: string | undefined;

    constructor(data?: IGetProjectHistoryListByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetProjectHistoryListByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectHistoryListByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): GetProjectHistoryListByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetProjectHistoryListByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetProjectHistoryListByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    id?: string | undefined;
}

export class GetProjectHistoryListByFilterQueryResponse implements IGetProjectHistoryListByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: ProjectHistory[] | undefined;
    count?: number;

    constructor(data?: IGetProjectHistoryListByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new ProjectHistory(item) : <ProjectHistory>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProjectHistory.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetProjectHistoryListByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectHistoryListByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetProjectHistoryListByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectHistoryListByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectHistoryListByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IProjectHistory[] | undefined;
    count?: number;
}

export class GetProjectListByFilterForPublicRequest implements IGetProjectListByFilterForPublicRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetProjectListByFilterForPublicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectListByFilterForPublicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListByFilterForPublicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProjectListByFilterForPublicRequest {
        const json = this.toJSON();
        let result = new GetProjectListByFilterForPublicRequest();
        result.init(json);
        return result;
    }
}

export interface IGetProjectListByFilterForPublicRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetProjectListByFilterForPublicResponse implements IGetProjectListByFilterForPublicResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: ProjectListModel[] | undefined;
    count?: number;

    constructor(data?: IGetProjectListByFilterForPublicResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new ProjectListModel(item) : <ProjectListModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProjectListModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetProjectListByFilterForPublicResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListByFilterForPublicResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetProjectListByFilterForPublicResponse {
        const json = this.toJSON();
        let result = new GetProjectListByFilterForPublicResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectListByFilterForPublicResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IProjectListModel[] | undefined;
    count?: number;
}

export class GetProjectTrackerInfoQueryRequest implements IGetProjectTrackerInfoQueryRequest {

    constructor(data?: IGetProjectTrackerInfoQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetProjectTrackerInfoQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectTrackerInfoQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): GetProjectTrackerInfoQueryRequest {
        const json = this.toJSON();
        let result = new GetProjectTrackerInfoQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetProjectTrackerInfoQueryRequest {
}

export class GetProjectTrackerInfoQueryResponse implements IGetProjectTrackerInfoQueryResponse {
    numberOfProjects?: number;
    numberOfFundedProjects?: number;
    totalDonations?: number;

    constructor(data?: IGetProjectTrackerInfoQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfProjects = _data["numberOfProjects"];
            this.numberOfFundedProjects = _data["numberOfFundedProjects"];
            this.totalDonations = _data["totalDonations"];
        }
    }

    static fromJS(data: any): GetProjectTrackerInfoQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectTrackerInfoQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfProjects"] = this.numberOfProjects;
        data["numberOfFundedProjects"] = this.numberOfFundedProjects;
        data["totalDonations"] = this.totalDonations;
        return data;
    }

    clone(): GetProjectTrackerInfoQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectTrackerInfoQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectTrackerInfoQueryResponse {
    numberOfProjects?: number;
    numberOfFundedProjects?: number;
    totalDonations?: number;
}

export class GetProjectUpdateDetailsByProjectIdQueryRequest implements IGetProjectUpdateDetailsByProjectIdQueryRequest {
    projectId?: string | undefined;

    constructor(data?: IGetProjectUpdateDetailsByProjectIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetProjectUpdateDetailsByProjectIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectUpdateDetailsByProjectIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): GetProjectUpdateDetailsByProjectIdQueryRequest {
        const json = this.toJSON();
        let result = new GetProjectUpdateDetailsByProjectIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetProjectUpdateDetailsByProjectIdQueryRequest {
    projectId?: string | undefined;
}

export class GetProjectUpdateDetailsByProjectIdQueryResponse implements IGetProjectUpdateDetailsByProjectIdQueryResponse {
    projectUpdate?: ProjectUpdate;

    constructor(data?: IGetProjectUpdateDetailsByProjectIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.projectUpdate = data.projectUpdate && !(<any>data.projectUpdate).toJSON ? new ProjectUpdate(data.projectUpdate) : <ProjectUpdate>this.projectUpdate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectUpdate = _data["projectUpdate"] ? ProjectUpdate.fromJS(_data["projectUpdate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectUpdateDetailsByProjectIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectUpdateDetailsByProjectIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectUpdate"] = this.projectUpdate ? this.projectUpdate.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetProjectUpdateDetailsByProjectIdQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectUpdateDetailsByProjectIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectUpdateDetailsByProjectIdQueryResponse {
    projectUpdate?: IProjectUpdate;
}

export class GetProjectsByFilterForAdminQueryRequest implements IGetProjectsByFilterForAdminQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetProjectsByFilterForAdminQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsByFilterForAdminQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsByFilterForAdminQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProjectsByFilterForAdminQueryRequest {
        const json = this.toJSON();
        let result = new GetProjectsByFilterForAdminQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetProjectsByFilterForAdminQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetProjectsByFilterForAdminQueryResponse implements IGetProjectsByFilterForAdminQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: ProjectListModel[] | undefined;
    count?: number;

    constructor(data?: IGetProjectsByFilterForAdminQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new ProjectListModel(item) : <ProjectListModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProjectListModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetProjectsByFilterForAdminQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsByFilterForAdminQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetProjectsByFilterForAdminQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectsByFilterForAdminQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectsByFilterForAdminQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IProjectListModel[] | undefined;
    count?: number;
}

export class GetProjectsForCompanyQueryRequest implements IGetProjectsForCompanyQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    userId?: string | undefined;

    constructor(data?: IGetProjectsForCompanyQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetProjectsForCompanyQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsForCompanyQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        data["userId"] = this.userId;
        return data;
    }

    clone(): GetProjectsForCompanyQueryRequest {
        const json = this.toJSON();
        let result = new GetProjectsForCompanyQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetProjectsForCompanyQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    userId?: string | undefined;
}

export class GetProjectsForCompanyQueryResponse implements IGetProjectsForCompanyQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: ProjectListModel[] | undefined;
    count?: number;

    constructor(data?: IGetProjectsForCompanyQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new ProjectListModel(item) : <ProjectListModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProjectListModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetProjectsForCompanyQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsForCompanyQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetProjectsForCompanyQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectsForCompanyQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectsForCompanyQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IProjectListModel[] | undefined;
    count?: number;
}

export class GetProjectsForInvestorQueryResponse implements IGetProjectsForInvestorQueryResponse {
    projects?: ProjectDetailsModel[] | undefined;

    constructor(data?: IGetProjectsForInvestorQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projects) {
                this.projects = [];
                for (let i = 0; i < data.projects.length; i++) {
                    let item = data.projects[i];
                    this.projects[i] = item && !(<any>item).toJSON ? new ProjectDetailsModel(item) : <ProjectDetailsModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDetailsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsForInvestorQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsForInvestorQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProjectsForInvestorQueryResponse {
        const json = this.toJSON();
        let result = new GetProjectsForInvestorQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProjectsForInvestorQueryResponse {
    projects?: IProjectDetailsModel[] | undefined;
}

export class GetReferenceListQueryRequest implements IGetReferenceListQueryRequest {
    names?: string[] | undefined;

    constructor(data?: IGetReferenceListQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
        }
    }

    static fromJS(data: any): GetReferenceListQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferenceListQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        return data;
    }

    clone(): GetReferenceListQueryRequest {
        const json = this.toJSON();
        let result = new GetReferenceListQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetReferenceListQueryRequest {
    names?: string[] | undefined;
}

export class GetReferenceListQueryResponse implements IGetReferenceListQueryResponse {
    results?: ReferenceList[] | undefined;

    constructor(data?: IGetReferenceListQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new ReferenceList(item) : <ReferenceList>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReferenceList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetReferenceListQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferenceListQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetReferenceListQueryResponse {
        const json = this.toJSON();
        let result = new GetReferenceListQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetReferenceListQueryResponse {
    results?: IReferenceList[] | undefined;
}

export class GetRoleByIdModel implements IGetRoleByIdModel {
    roleId?: string;

    constructor(data?: IGetRoleByIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): GetRoleByIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleByIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): GetRoleByIdModel {
        const json = this.toJSON();
        let result = new GetRoleByIdModel();
        result.init(json);
        return result;
    }
}

export interface IGetRoleByIdModel {
    roleId?: string;
}

export class GetRoleByIdQueryResponse implements IGetRoleByIdQueryResponse {
    role?: RoleDetailsModel;

    constructor(data?: IGetRoleByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.role = data.role && !(<any>data.role).toJSON ? new RoleDetailsModel(data.role) : <RoleDetailsModel>this.role;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleDetailsModel.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRoleByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetRoleByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetRoleByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetRoleByIdQueryResponse {
    role?: IRoleDetailsModel;
}

export class GetRolesCommandResponse implements IGetRolesCommandResponse {
    readonly roles?: Role[] | undefined;

    constructor(data?: IGetRolesCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.roles) {
                this.roles = [];
                for (let i = 0; i < data.roles.length; i++) {
                    let item = data.roles[i];
                    this.roles[i] = item && !(<any>item).toJSON ? new Role(item) : <Role>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                (<any>this).roles = [] as any;
                for (let item of _data["roles"])
                    (<any>this).roles!.push(Role.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRolesCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetRolesCommandResponse {
        const json = this.toJSON();
        let result = new GetRolesCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetRolesCommandResponse {
    roles?: IRole[] | undefined;
}

export class GetRolesModel implements IGetRolesModel {

    constructor(data?: IGetRolesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRolesModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): GetRolesModel {
        const json = this.toJSON();
        let result = new GetRolesModel();
        result.init(json);
        return result;
    }
}

export interface IGetRolesModel {
}

export class GetUserByIdModel implements IGetUserByIdModel {
    id?: string;

    constructor(data?: IGetUserByIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetUserByIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserByIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): GetUserByIdModel {
        const json = this.toJSON();
        let result = new GetUserByIdModel();
        result.init(json);
        return result;
    }
}

export interface IGetUserByIdModel {
    id?: string;
}

export class GetUserByIdQueryResponse implements IGetUserByIdQueryResponse {
    user?: User;
    claims?: UserClaim[] | undefined;
    roles?: string[] | undefined;
    userProfile?: UserProfile;

    constructor(data?: IGetUserByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
            if (data.claims) {
                this.claims = [];
                for (let i = 0; i < data.claims.length; i++) {
                    let item = data.claims[i];
                    this.claims[i] = item && !(<any>item).toJSON ? new UserClaim(item) : <UserClaim>item;
                }
            }
            this.userProfile = data.userProfile && !(<any>data.userProfile).toJSON ? new UserProfile(data.userProfile) : <UserProfile>this.userProfile;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.userProfile = _data["userProfile"] ? UserProfile.fromJS(_data["userProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetUserByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetUserByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserByIdQueryResponse {
    user?: IUser;
    claims?: IUserClaim[] | undefined;
    roles?: string[] | undefined;
    userProfile?: IUserProfile;
}

export class GetUserProfileByIdQueryResponse implements IGetUserProfileByIdQueryResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    idType?: IDType;
    idNumber?: string | undefined;
    taxIdNumber?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    address?: Address;
    isEntrepreneur?: boolean;
    isInvestor?: boolean;
    readonly companyName?: string | undefined;

    constructor(data?: IGetUserProfileByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.isEntrepreneur = _data["isEntrepreneur"];
            this.isInvestor = _data["isInvestor"];
            (<any>this).companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): GetUserProfileByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["taxIdNumber"] = this.taxIdNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["isEntrepreneur"] = this.isEntrepreneur;
        data["isInvestor"] = this.isInvestor;
        data["companyName"] = this.companyName;
        return data;
    }

    clone(): GetUserProfileByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetUserProfileByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserProfileByIdQueryResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    idType?: IDType;
    idNumber?: string | undefined;
    taxIdNumber?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    address?: IAddress;
    isEntrepreneur?: boolean;
    isInvestor?: boolean;
    companyName?: string | undefined;
}

export class HomePageImage implements IHomePageImage {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    mainImageFileId?: string | undefined;
    mainImageFileName?: string | undefined;
    topLeftImageFileId?: string | undefined;
    topLeftImageFileName?: string | undefined;
    topRightImageFileId?: string | undefined;
    topRightImageFileName?: string | undefined;
    bottomLeftImageFileId?: string | undefined;
    bottomLeftImageFileName?: string | undefined;
    bottomRightImageFileId?: string | undefined;
    bottomRightImageFileName?: string | undefined;

    constructor(data?: IHomePageImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.mainImageFileId = _data["mainImageFileId"];
            this.mainImageFileName = _data["mainImageFileName"];
            this.topLeftImageFileId = _data["topLeftImageFileId"];
            this.topLeftImageFileName = _data["topLeftImageFileName"];
            this.topRightImageFileId = _data["topRightImageFileId"];
            this.topRightImageFileName = _data["topRightImageFileName"];
            this.bottomLeftImageFileId = _data["bottomLeftImageFileId"];
            this.bottomLeftImageFileName = _data["bottomLeftImageFileName"];
            this.bottomRightImageFileId = _data["bottomRightImageFileId"];
            this.bottomRightImageFileName = _data["bottomRightImageFileName"];
        }
    }

    static fromJS(data: any): HomePageImage {
        data = typeof data === 'object' ? data : {};
        let result = new HomePageImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["mainImageFileId"] = this.mainImageFileId;
        data["mainImageFileName"] = this.mainImageFileName;
        data["topLeftImageFileId"] = this.topLeftImageFileId;
        data["topLeftImageFileName"] = this.topLeftImageFileName;
        data["topRightImageFileId"] = this.topRightImageFileId;
        data["topRightImageFileName"] = this.topRightImageFileName;
        data["bottomLeftImageFileId"] = this.bottomLeftImageFileId;
        data["bottomLeftImageFileName"] = this.bottomLeftImageFileName;
        data["bottomRightImageFileId"] = this.bottomRightImageFileId;
        data["bottomRightImageFileName"] = this.bottomRightImageFileName;
        return data;
    }

    clone(): HomePageImage {
        const json = this.toJSON();
        let result = new HomePageImage();
        result.init(json);
        return result;
    }
}

export interface IHomePageImage {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    mainImageFileId?: string | undefined;
    mainImageFileName?: string | undefined;
    topLeftImageFileId?: string | undefined;
    topLeftImageFileName?: string | undefined;
    topRightImageFileId?: string | undefined;
    topRightImageFileName?: string | undefined;
    bottomLeftImageFileId?: string | undefined;
    bottomLeftImageFileName?: string | undefined;
    bottomRightImageFileId?: string | undefined;
    bottomRightImageFileName?: string | undefined;
}

export enum IDType {
    DriversLicense = "DriversLicense",
    Passport = "Passport",
    NationalID = "NationalID",
}

export class IdentityError implements IIdentityError {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code?: string | undefined;
    description?: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded?: boolean;
    readonly errors?: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.errors) {
                this.errors = [];
                for (let i = 0; i < data.errors.length; i++) {
                    let item = data.errors[i];
                    this.errors[i] = item && !(<any>item).toJSON ? new IdentityError(item) : <IdentityError>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded?: boolean;
    errors?: IIdentityError[] | undefined;
}

export class Investor implements IInvestor {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    fisrtNameCompanyName?: string | undefined;
    lastName?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string;
    address?: Address;
    addressId?: string;
    user?: User;
    userId?: string;
    isEntrepreneur?: boolean;
    readonly fullName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IInvestor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.fisrtNameCompanyName = _data["fisrtNameCompanyName"];
            this.lastName = _data["lastName"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.addressId = _data["addressId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.isEntrepreneur = _data["isEntrepreneur"];
            (<any>this).fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): Investor {
        data = typeof data === 'object' ? data : {};
        let result = new Investor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["fisrtNameCompanyName"] = this.fisrtNameCompanyName;
        data["lastName"] = this.lastName;
        data["taxIdNumber"] = this.taxIdNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["isEntrepreneur"] = this.isEntrepreneur;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): Investor {
        const json = this.toJSON();
        let result = new Investor();
        result.init(json);
        return result;
    }
}

export interface IInvestor {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    fisrtNameCompanyName?: string | undefined;
    lastName?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string;
    address?: IAddress;
    addressId?: string;
    user?: IUser;
    userId?: string;
    isEntrepreneur?: boolean;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
}

export enum InvestorType {
    Individual = "Individual",
    Company = "Company",
}

export class IsCardRegisteredResponse implements IIsCardRegisteredResponse {
    registeredStatus?: boolean;

    constructor(data?: IIsCardRegisteredResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registeredStatus = _data["registeredStatus"];
        }
    }

    static fromJS(data: any): IsCardRegisteredResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsCardRegisteredResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredStatus"] = this.registeredStatus;
        return data;
    }

    clone(): IsCardRegisteredResponse {
        const json = this.toJSON();
        let result = new IsCardRegisteredResponse();
        result.init(json);
        return result;
    }
}

export interface IIsCardRegisteredResponse {
    registeredStatus?: boolean;
}

export class Item implements IItem {
    id?: string | undefined;
    amount?: number | undefined;
    projectName?: string | undefined;
    companyName?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    readonly isSpecialProject?: boolean;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.projectName = _data["projectName"];
            this.companyName = _data["companyName"];
            this.thumbnailFileUrl = _data["thumbnailFileUrl"];
            (<any>this).isSpecialProject = _data["isSpecialProject"];
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["thumbnailFileUrl"] = this.thumbnailFileUrl;
        data["isSpecialProject"] = this.isSpecialProject;
        return data;
    }

    clone(): Item {
        const json = this.toJSON();
        let result = new Item();
        result.init(json);
        return result;
    }
}

export interface IItem {
    id?: string | undefined;
    amount?: number | undefined;
    projectName?: string | undefined;
    companyName?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    isSpecialProject?: boolean;
}

export enum JoinType {
    And = "and",
    Or = "or",
}

export class LoginCommandRequest implements ILoginCommandRequest {
    ipAddress?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    rememberMe?: boolean;
    fromAdmin?: boolean;

    constructor(data?: ILoginCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ipAddress = _data["ipAddress"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.rememberMe = _data["rememberMe"];
            this.fromAdmin = _data["fromAdmin"];
        }
    }

    static fromJS(data: any): LoginCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipAddress"] = this.ipAddress;
        data["username"] = this.username;
        data["password"] = this.password;
        data["rememberMe"] = this.rememberMe;
        data["fromAdmin"] = this.fromAdmin;
        return data;
    }

    clone(): LoginCommandRequest {
        const json = this.toJSON();
        let result = new LoginCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandRequest {
    ipAddress?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    rememberMe?: boolean;
    fromAdmin?: boolean;
}

export class LoginCommandResponse implements ILoginCommandResponse {
    userName?: string | undefined;
    fullName?: string | undefined;
    loggedIn?: boolean;
    accessToken?: string | undefined;
    accessTokenExpiresIn?: number;
    refreshToken?: string | undefined;
    user?: SlimUser;

    constructor(data?: ILoginCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.loggedIn = _data["loggedIn"];
            this.accessToken = _data["accessToken"];
            this.accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            this.refreshToken = _data["refreshToken"];
            this.user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["loggedIn"] = this.loggedIn;
        data["accessToken"] = this.accessToken;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["refreshToken"] = this.refreshToken;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): LoginCommandResponse {
        const json = this.toJSON();
        let result = new LoginCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandResponse {
    userName?: string | undefined;
    fullName?: string | undefined;
    loggedIn?: boolean;
    accessToken?: string | undefined;
    accessTokenExpiresIn?: number;
    refreshToken?: string | undefined;
    user?: ISlimUser;
}

export class MakeUnverifiedCreditCardPaymentCommandResponse implements IMakeUnverifiedCreditCardPaymentCommandResponse {
    paymentStatus?: PaymentStatus;
    htmlData?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    invoiceNumber?: string | undefined;
    paddedCardNumber?: string | undefined;

    constructor(data?: IMakeUnverifiedCreditCardPaymentCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentStatus = _data["paymentStatus"];
            this.htmlData = _data["htmlData"];
            this.errorMessage = _data["errorMessage"];
            this.orderId = _data["orderId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.paddedCardNumber = _data["paddedCardNumber"];
        }
    }

    static fromJS(data: any): MakeUnverifiedCreditCardPaymentCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MakeUnverifiedCreditCardPaymentCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentStatus"] = this.paymentStatus;
        data["htmlData"] = this.htmlData;
        data["errorMessage"] = this.errorMessage;
        data["orderId"] = this.orderId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["paddedCardNumber"] = this.paddedCardNumber;
        return data;
    }

    clone(): MakeUnverifiedCreditCardPaymentCommandResponse {
        const json = this.toJSON();
        let result = new MakeUnverifiedCreditCardPaymentCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IMakeUnverifiedCreditCardPaymentCommandResponse {
    paymentStatus?: PaymentStatus;
    htmlData?: string | undefined;
    errorMessage?: string | undefined;
    orderId?: string;
    invoiceNumber?: string | undefined;
    paddedCardNumber?: string | undefined;
}

export class MemoryStream implements IMemoryStream {
    readonly canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
    readonly canRead?: boolean;
    readonly canSeek?: boolean;
    readonly canWrite?: boolean;
    capacity?: number;
    readonly length?: number;
    position?: number;

    constructor(data?: IMemoryStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canTimeout = _data["canTimeout"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canWrite = _data["canWrite"];
            this.capacity = _data["capacity"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): MemoryStream {
        data = typeof data === 'object' ? data : {};
        let result = new MemoryStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canWrite"] = this.canWrite;
        data["capacity"] = this.capacity;
        data["length"] = this.length;
        data["position"] = this.position;
        return data;
    }

    clone(): MemoryStream {
        const json = this.toJSON();
        let result = new MemoryStream();
        result.init(json);
        return result;
    }
}

export interface IMemoryStream {
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
    canRead?: boolean;
    canSeek?: boolean;
    canWrite?: boolean;
    capacity?: number;
    length?: number;
    position?: number;
}

export class News implements INews {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    mainImageLink?: string | undefined;
    overview?: string | undefined;
    link?: string | undefined;
    publishDate?: string | undefined;
    status?: NewsStatus;
    newsDataFileId?: string | undefined;
    newsDataFile?: DataFile;
    newsApprovals?: NewsApproval[] | undefined;

    constructor(data?: INews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.newsDataFile = data.newsDataFile && !(<any>data.newsDataFile).toJSON ? new DataFile(data.newsDataFile) : <DataFile>this.newsDataFile;
            if (data.newsApprovals) {
                this.newsApprovals = [];
                for (let i = 0; i < data.newsApprovals.length; i++) {
                    let item = data.newsApprovals[i];
                    this.newsApprovals[i] = item && !(<any>item).toJSON ? new NewsApproval(item) : <NewsApproval>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.mainImageLink = _data["mainImageLink"];
            this.overview = _data["overview"];
            this.link = _data["link"];
            this.publishDate = _data["publishDate"];
            this.status = _data["status"];
            this.newsDataFileId = _data["newsDataFileId"];
            this.newsDataFile = _data["newsDataFile"] ? DataFile.fromJS(_data["newsDataFile"]) : <any>undefined;
            if (Array.isArray(_data["newsApprovals"])) {
                this.newsApprovals = [] as any;
                for (let item of _data["newsApprovals"])
                    this.newsApprovals!.push(NewsApproval.fromJS(item));
            }
        }
    }

    static fromJS(data: any): News {
        data = typeof data === 'object' ? data : {};
        let result = new News();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["name"] = this.name;
        data["title"] = this.title;
        data["description"] = this.description;
        data["mainImageLink"] = this.mainImageLink;
        data["overview"] = this.overview;
        data["link"] = this.link;
        data["publishDate"] = this.publishDate;
        data["status"] = this.status;
        data["newsDataFileId"] = this.newsDataFileId;
        data["newsDataFile"] = this.newsDataFile ? this.newsDataFile.toJSON() : <any>undefined;
        if (Array.isArray(this.newsApprovals)) {
            data["newsApprovals"] = [];
            for (let item of this.newsApprovals)
                data["newsApprovals"].push(item.toJSON());
        }
        return data;
    }

    clone(): News {
        const json = this.toJSON();
        let result = new News();
        result.init(json);
        return result;
    }
}

export interface INews {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    mainImageLink?: string | undefined;
    overview?: string | undefined;
    link?: string | undefined;
    publishDate?: string | undefined;
    status?: NewsStatus;
    newsDataFileId?: string | undefined;
    newsDataFile?: IDataFile;
    newsApprovals?: INewsApproval[] | undefined;
}

export class NewsApproval implements INewsApproval {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    reason?: string | undefined;
    status?: NewsApprovalStatus;

    constructor(data?: INewsApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.reason = _data["reason"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): NewsApproval {
        data = typeof data === 'object' ? data : {};
        let result = new NewsApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["reason"] = this.reason;
        data["status"] = this.status;
        return data;
    }

    clone(): NewsApproval {
        const json = this.toJSON();
        let result = new NewsApproval();
        result.init(json);
        return result;
    }
}

export interface INewsApproval {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    reason?: string | undefined;
    status?: NewsApprovalStatus;
}

export enum NewsApprovalStatus {
    Rejected = "Rejected",
    Approved = "Approved",
}

export class NewsListModel implements INewsListModel {
    id?: string;
    name?: string | undefined;
    title?: string | undefined;
    overview?: string | undefined;
    link?: string | undefined;
    publishDate?: string | undefined;
    mainImageLink?: string | undefined;
    status?: NewsStatus;
    newsDataFile?: DataFile;
    createdBy?: string | undefined;
    creationDate?: string | undefined;

    constructor(data?: INewsListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.newsDataFile = data.newsDataFile && !(<any>data.newsDataFile).toJSON ? new DataFile(data.newsDataFile) : <DataFile>this.newsDataFile;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.overview = _data["overview"];
            this.link = _data["link"];
            this.publishDate = _data["publishDate"];
            this.mainImageLink = _data["mainImageLink"];
            this.status = _data["status"];
            this.newsDataFile = _data["newsDataFile"] ? DataFile.fromJS(_data["newsDataFile"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
        }
    }

    static fromJS(data: any): NewsListModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewsListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title;
        data["overview"] = this.overview;
        data["link"] = this.link;
        data["publishDate"] = this.publishDate;
        data["mainImageLink"] = this.mainImageLink;
        data["status"] = this.status;
        data["newsDataFile"] = this.newsDataFile ? this.newsDataFile.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        return data;
    }

    clone(): NewsListModel {
        const json = this.toJSON();
        let result = new NewsListModel();
        result.init(json);
        return result;
    }
}

export interface INewsListModel {
    id?: string;
    name?: string | undefined;
    title?: string | undefined;
    overview?: string | undefined;
    link?: string | undefined;
    publishDate?: string | undefined;
    mainImageLink?: string | undefined;
    status?: NewsStatus;
    newsDataFile?: IDataFile;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
}

export enum NewsStatus {
    Draft = "Draft",
    PendingApproval = "PendingApproval",
    Rejected = "Rejected",
    Approved = "Approved",
    Published = "Published",
    Archived = "Archived",
}

export class Order implements IOrder {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    userId?: string | undefined;
    currency?: string | undefined;
    total?: number;
    paymentDate?: string | undefined;
    itemCount?: number;
    cartId?: string | undefined;
    receiptNumber?: string | undefined;
    paymentStatus?: PaymentStatus;
    paymentType?: PaymentType;
    billingInfoId?: string;
    transactionId?: string | undefined;
    authCode?: string | undefined;
    paymentMethodId?: string | undefined;
    invoiceNumber?: string | undefined;
    cart?: Cart;
    user?: User;
    billingInfo?: BillingInfo;
    paymentMethod?: PaymentMethod;
    orderItems?: OrderItem[] | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new Cart(data.cart) : <Cart>this.cart;
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
            this.billingInfo = data.billingInfo && !(<any>data.billingInfo).toJSON ? new BillingInfo(data.billingInfo) : <BillingInfo>this.billingInfo;
            this.paymentMethod = data.paymentMethod && !(<any>data.paymentMethod).toJSON ? new PaymentMethod(data.paymentMethod) : <PaymentMethod>this.paymentMethod;
            if (data.orderItems) {
                this.orderItems = [];
                for (let i = 0; i < data.orderItems.length; i++) {
                    let item = data.orderItems[i];
                    this.orderItems[i] = item && !(<any>item).toJSON ? new OrderItem(item) : <OrderItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.userId = _data["userId"];
            this.currency = _data["currency"];
            this.total = _data["total"];
            this.paymentDate = _data["paymentDate"];
            this.itemCount = _data["itemCount"];
            this.cartId = _data["cartId"];
            this.receiptNumber = _data["receiptNumber"];
            this.paymentStatus = _data["paymentStatus"];
            this.paymentType = _data["paymentType"];
            this.billingInfoId = _data["billingInfoId"];
            this.transactionId = _data["transactionId"];
            this.authCode = _data["authCode"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.cart = _data["cart"] ? Cart.fromJS(_data["cart"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.billingInfo = _data["billingInfo"] ? BillingInfo.fromJS(_data["billingInfo"]) : <any>undefined;
            this.paymentMethod = _data["paymentMethod"] ? PaymentMethod.fromJS(_data["paymentMethod"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["userId"] = this.userId;
        data["currency"] = this.currency;
        data["total"] = this.total;
        data["paymentDate"] = this.paymentDate;
        data["itemCount"] = this.itemCount;
        data["cartId"] = this.cartId;
        data["receiptNumber"] = this.receiptNumber;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentType"] = this.paymentType;
        data["billingInfoId"] = this.billingInfoId;
        data["transactionId"] = this.transactionId;
        data["authCode"] = this.authCode;
        data["paymentMethodId"] = this.paymentMethodId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : <any>undefined;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    userId?: string | undefined;
    currency?: string | undefined;
    total?: number;
    paymentDate?: string | undefined;
    itemCount?: number;
    cartId?: string | undefined;
    receiptNumber?: string | undefined;
    paymentStatus?: PaymentStatus;
    paymentType?: PaymentType;
    billingInfoId?: string;
    transactionId?: string | undefined;
    authCode?: string | undefined;
    paymentMethodId?: string | undefined;
    invoiceNumber?: string | undefined;
    cart?: ICart;
    user?: IUser;
    billingInfo?: IBillingInfo;
    paymentMethod?: IPaymentMethod;
    orderItems?: IOrderItem[] | undefined;
}

export class OrderBy implements IOrderBy {
    field?: string | undefined;
    ascending?: boolean;

    constructor(data?: IOrderBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.ascending = _data["ascending"];
        }
    }

    static fromJS(data: any): OrderBy {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["ascending"] = this.ascending;
        return data;
    }

    clone(): OrderBy {
        const json = this.toJSON();
        let result = new OrderBy();
        result.init(json);
        return result;
    }
}

export interface IOrderBy {
    field?: string | undefined;
    ascending?: boolean;
}

export class OrderItem implements IOrderItem {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    projectId?: string | undefined;
    orderId?: string | undefined;
    amount?: number | undefined;
    description?: string | undefined;
    sku?: string | undefined;
    localAmount?: number | undefined;
    order?: Order;
    project?: Project;

    constructor(data?: IOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.order = data.order && !(<any>data.order).toJSON ? new Order(data.order) : <Order>this.order;
            this.project = data.project && !(<any>data.project).toJSON ? new Project(data.project) : <Project>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.projectId = _data["projectId"];
            this.orderId = _data["orderId"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.localAmount = _data["localAmount"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["projectId"] = this.projectId;
        data["orderId"] = this.orderId;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["localAmount"] = this.localAmount;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderItem {
        const json = this.toJSON();
        let result = new OrderItem();
        result.init(json);
        return result;
    }
}

export interface IOrderItem {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    projectId?: string | undefined;
    orderId?: string | undefined;
    amount?: number | undefined;
    description?: string | undefined;
    sku?: string | undefined;
    localAmount?: number | undefined;
    order?: IOrder;
    project?: IProject;
}

export class PaymentConfigRequest implements IPaymentConfigRequest {

    constructor(data?: IPaymentConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PaymentConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): PaymentConfigRequest {
        const json = this.toJSON();
        let result = new PaymentConfigRequest();
        result.init(json);
        return result;
    }
}

export interface IPaymentConfigRequest {
}

export class PaymentDetailModel implements IPaymentDetailModel {
    projectId?: string | undefined;
    paymentAmount?: number;

    constructor(data?: IPaymentDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): PaymentDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }

    clone(): PaymentDetailModel {
        const json = this.toJSON();
        let result = new PaymentDetailModel();
        result.init(json);
        return result;
    }
}

export interface IPaymentDetailModel {
    projectId?: string | undefined;
    paymentAmount?: number;
}

export class PaymentListItem implements IPaymentListItem {
    id?: string;
    cartId?: string;
    userName?: string | undefined;
    currency?: string | undefined;
    total?: number;
    itemCount?: number;
    donations?: SimpleOrderListItem[] | undefined;
    date?: string;
    type?: PaymentType;
    status?: PaymentStatus;
    invoiceId?: string | undefined;
    paymentReceiptUrl?: string | undefined;

    constructor(data?: IPaymentListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.donations) {
                this.donations = [];
                for (let i = 0; i < data.donations.length; i++) {
                    let item = data.donations[i];
                    this.donations[i] = item && !(<any>item).toJSON ? new SimpleOrderListItem(item) : <SimpleOrderListItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cartId = _data["cartId"];
            this.userName = _data["userName"];
            this.currency = _data["currency"];
            this.total = _data["total"];
            this.itemCount = _data["itemCount"];
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(SimpleOrderListItem.fromJS(item));
            }
            this.date = _data["date"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.invoiceId = _data["invoiceId"];
            this.paymentReceiptUrl = _data["paymentReceiptUrl"];
        }
    }

    static fromJS(data: any): PaymentListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cartId"] = this.cartId;
        data["userName"] = this.userName;
        data["currency"] = this.currency;
        data["total"] = this.total;
        data["itemCount"] = this.itemCount;
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        data["date"] = this.date;
        data["type"] = this.type;
        data["status"] = this.status;
        data["invoiceId"] = this.invoiceId;
        data["paymentReceiptUrl"] = this.paymentReceiptUrl;
        return data;
    }

    clone(): PaymentListItem {
        const json = this.toJSON();
        let result = new PaymentListItem();
        result.init(json);
        return result;
    }
}

export interface IPaymentListItem {
    id?: string;
    cartId?: string;
    userName?: string | undefined;
    currency?: string | undefined;
    total?: number;
    itemCount?: number;
    donations?: ISimpleOrderListItem[] | undefined;
    date?: string;
    type?: PaymentType;
    status?: PaymentStatus;
    invoiceId?: string | undefined;
    paymentReceiptUrl?: string | undefined;
}

export class PaymentMethod implements IPaymentMethod {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    orderId?: string;
    cardNumber?: string | undefined;
    cardType?: string | undefined;
    payerId?: string | undefined;
    paymentInfo?: string | undefined;
    order?: Order;

    constructor(data?: IPaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.order = data.order && !(<any>data.order).toJSON ? new Order(data.order) : <Order>this.order;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.orderId = _data["orderId"];
            this.cardNumber = _data["cardNumber"];
            this.cardType = _data["cardType"];
            this.payerId = _data["payerId"];
            this.paymentInfo = _data["paymentInfo"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["orderId"] = this.orderId;
        data["cardNumber"] = this.cardNumber;
        data["cardType"] = this.cardType;
        data["payerId"] = this.payerId;
        data["paymentInfo"] = this.paymentInfo;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }

    clone(): PaymentMethod {
        const json = this.toJSON();
        let result = new PaymentMethod();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethod {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    orderId?: string;
    cardNumber?: string | undefined;
    cardType?: string | undefined;
    payerId?: string | undefined;
    paymentInfo?: string | undefined;
    order?: IOrder;
}

export enum PaymentStatus {
    Pending = "Pending",
    VerificationRequested = "VerificationRequested",
    AwaitingAuthentication = "AwaitingAuthentication",
    Successful = "Successful",
    Failed = "Failed",
    Reversed = "Reversed",
    Canceled = "Canceled",
}

export enum PaymentType {
    CreditCard = "CreditCard",
    Paypal = "Paypal",
    Fygaro = "Fygaro",
}

export class PaymentUser implements IPaymentUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: Address;

    constructor(data?: IPaymentUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentUser {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }

    clone(): PaymentUser {
        const json = this.toJSON();
        let result = new PaymentUser();
        result.init(json);
        return result;
    }
}

export interface IPaymentUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: IAddress;
}

export class Pledge implements IPledge {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    status?: PledgeStatus;
    userId?: string | undefined;
    amountReceived?: number | undefined;
    totalPledge?: number;
    currency?: string | undefined;
    user?: User;
    pledgeItems?: PledgeItem[] | undefined;
    readonly fullName?: string | undefined;

    constructor(data?: IPledge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
            if (data.pledgeItems) {
                this.pledgeItems = [];
                for (let i = 0; i < data.pledgeItems.length; i++) {
                    let item = data.pledgeItems[i];
                    this.pledgeItems[i] = item && !(<any>item).toJSON ? new PledgeItem(item) : <PledgeItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.amountReceived = _data["amountReceived"];
            this.totalPledge = _data["totalPledge"];
            this.currency = _data["currency"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["pledgeItems"])) {
                this.pledgeItems = [] as any;
                for (let item of _data["pledgeItems"])
                    this.pledgeItems!.push(PledgeItem.fromJS(item));
            }
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): Pledge {
        data = typeof data === 'object' ? data : {};
        let result = new Pledge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["amountReceived"] = this.amountReceived;
        data["totalPledge"] = this.totalPledge;
        data["currency"] = this.currency;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.pledgeItems)) {
            data["pledgeItems"] = [];
            for (let item of this.pledgeItems)
                data["pledgeItems"].push(item.toJSON());
        }
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): Pledge {
        const json = this.toJSON();
        let result = new Pledge();
        result.init(json);
        return result;
    }
}

export interface IPledge {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    status?: PledgeStatus;
    userId?: string | undefined;
    amountReceived?: number | undefined;
    totalPledge?: number;
    currency?: string | undefined;
    user?: IUser;
    pledgeItems?: IPledgeItem[] | undefined;
    fullName?: string | undefined;
}

export class PledgeItem implements IPledgeItem {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    projectId?: string | undefined;
    pledgeId?: string | undefined;
    amount?: number | undefined;
    amountReceived?: number | undefined;
    pledge?: Pledge;
    project?: Project;

    constructor(data?: IPledgeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.pledge = data.pledge && !(<any>data.pledge).toJSON ? new Pledge(data.pledge) : <Pledge>this.pledge;
            this.project = data.project && !(<any>data.project).toJSON ? new Project(data.project) : <Project>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.projectId = _data["projectId"];
            this.pledgeId = _data["pledgeId"];
            this.amount = _data["amount"];
            this.amountReceived = _data["amountReceived"];
            this.pledge = _data["pledge"] ? Pledge.fromJS(_data["pledge"]) : <any>undefined;
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PledgeItem {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["projectId"] = this.projectId;
        data["pledgeId"] = this.pledgeId;
        data["amount"] = this.amount;
        data["amountReceived"] = this.amountReceived;
        data["pledge"] = this.pledge ? this.pledge.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): PledgeItem {
        const json = this.toJSON();
        let result = new PledgeItem();
        result.init(json);
        return result;
    }
}

export interface IPledgeItem {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    projectId?: string | undefined;
    pledgeId?: string | undefined;
    amount?: number | undefined;
    amountReceived?: number | undefined;
    pledge?: IPledge;
    project?: IProject;
}

export class PledgeListModel implements IPledgeListModel {
    id?: string;
    pledgersName?: string | undefined;
    companyName?: string | undefined;
    projects?: string[] | undefined;
    totalPledge?: number;
    amountReceived?: number | undefined;
    currency?: string | undefined;
    userName?: string | undefined;
    status?: PledgeStatus;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    pledgeDate?: string | undefined;

    constructor(data?: IPledgeListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pledgersName = _data["pledgersName"];
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(item);
            }
            this.totalPledge = _data["totalPledge"];
            this.amountReceived = _data["amountReceived"];
            this.currency = _data["currency"];
            this.userName = _data["userName"];
            this.status = _data["status"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.pledgeDate = _data["pledgeDate"];
        }
    }

    static fromJS(data: any): PledgeListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pledgersName"] = this.pledgersName;
        data["companyName"] = this.companyName;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item);
        }
        data["totalPledge"] = this.totalPledge;
        data["amountReceived"] = this.amountReceived;
        data["currency"] = this.currency;
        data["userName"] = this.userName;
        data["status"] = this.status;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["pledgeDate"] = this.pledgeDate;
        return data;
    }

    clone(): PledgeListModel {
        const json = this.toJSON();
        let result = new PledgeListModel();
        result.init(json);
        return result;
    }
}

export interface IPledgeListModel {
    id?: string;
    pledgersName?: string | undefined;
    companyName?: string | undefined;
    projects?: string[] | undefined;
    totalPledge?: number;
    amountReceived?: number | undefined;
    currency?: string | undefined;
    userName?: string | undefined;
    status?: PledgeStatus;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    pledgeDate?: string | undefined;
}

export class PledgeModel implements IPledgeModel {
    investorType?: InvestorType;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number;
    projectId?: string | undefined;
    currency?: string | undefined;

    constructor(data?: IPledgeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorType = _data["investorType"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.amount = _data["amount"];
            this.projectId = _data["projectId"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): PledgeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorType"] = this.investorType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["amount"] = this.amount;
        data["projectId"] = this.projectId;
        data["currency"] = this.currency;
        return data;
    }

    clone(): PledgeModel {
        const json = this.toJSON();
        let result = new PledgeModel();
        result.init(json);
        return result;
    }
}

export interface IPledgeModel {
    investorType?: InvestorType;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number;
    projectId?: string | undefined;
    currency?: string | undefined;
}

export enum PledgeStatus {
    Unfulfilled = "Unfulfilled",
    Fulfilled = "Fulfilled",
    Rejected = "Rejected",
    Reversed = "Reversed",
}

export class Project implements IProject {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    thumbnailId?: string | undefined;
    projectDashboardId?: string | undefined;
    description?: string | undefined;
    videoUrl?: string | undefined;
    amountRequested?: number;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    projectDocumentId?: string | undefined;
    levelOfImpact?: string | undefined;
    timeToFunding?: string | undefined;
    lastSubmittedDate?: string | undefined;
    companyId?: string | undefined;
    amountRecieved?: number | undefined;
    status?: ProjectStatus;
    subTitle?: string | undefined;
    donations?: number | undefined;
    category?: ProjectCategory;
    displayOrder?: number | undefined;
    projectApprovals?: ProjectApproval[] | undefined;
    company?: Company;
    projectDashboard?: DataFile;
    projectDocument?: DataFile;
    thumbnail?: DataFile;
    cartItems?: CartItem[] | undefined;
    privateComments?: Comment[] | undefined;
    orderItems?: OrderItem[] | undefined;
    pledgeItems?: PledgeItem[] | undefined;
    projectHistories?: ProjectHistory[] | undefined;
    projectDocuments?: ProjectDocument[] | undefined;
    projectUpdates?: ProjectUpdate[] | undefined;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projectApprovals) {
                this.projectApprovals = [];
                for (let i = 0; i < data.projectApprovals.length; i++) {
                    let item = data.projectApprovals[i];
                    this.projectApprovals[i] = item && !(<any>item).toJSON ? new ProjectApproval(item) : <ProjectApproval>item;
                }
            }
            this.company = data.company && !(<any>data.company).toJSON ? new Company(data.company) : <Company>this.company;
            this.projectDashboard = data.projectDashboard && !(<any>data.projectDashboard).toJSON ? new DataFile(data.projectDashboard) : <DataFile>this.projectDashboard;
            this.projectDocument = data.projectDocument && !(<any>data.projectDocument).toJSON ? new DataFile(data.projectDocument) : <DataFile>this.projectDocument;
            this.thumbnail = data.thumbnail && !(<any>data.thumbnail).toJSON ? new DataFile(data.thumbnail) : <DataFile>this.thumbnail;
            if (data.cartItems) {
                this.cartItems = [];
                for (let i = 0; i < data.cartItems.length; i++) {
                    let item = data.cartItems[i];
                    this.cartItems[i] = item && !(<any>item).toJSON ? new CartItem(item) : <CartItem>item;
                }
            }
            if (data.privateComments) {
                this.privateComments = [];
                for (let i = 0; i < data.privateComments.length; i++) {
                    let item = data.privateComments[i];
                    this.privateComments[i] = item && !(<any>item).toJSON ? new Comment(item) : <Comment>item;
                }
            }
            if (data.orderItems) {
                this.orderItems = [];
                for (let i = 0; i < data.orderItems.length; i++) {
                    let item = data.orderItems[i];
                    this.orderItems[i] = item && !(<any>item).toJSON ? new OrderItem(item) : <OrderItem>item;
                }
            }
            if (data.pledgeItems) {
                this.pledgeItems = [];
                for (let i = 0; i < data.pledgeItems.length; i++) {
                    let item = data.pledgeItems[i];
                    this.pledgeItems[i] = item && !(<any>item).toJSON ? new PledgeItem(item) : <PledgeItem>item;
                }
            }
            if (data.projectHistories) {
                this.projectHistories = [];
                for (let i = 0; i < data.projectHistories.length; i++) {
                    let item = data.projectHistories[i];
                    this.projectHistories[i] = item && !(<any>item).toJSON ? new ProjectHistory(item) : <ProjectHistory>item;
                }
            }
            if (data.projectDocuments) {
                this.projectDocuments = [];
                for (let i = 0; i < data.projectDocuments.length; i++) {
                    let item = data.projectDocuments[i];
                    this.projectDocuments[i] = item && !(<any>item).toJSON ? new ProjectDocument(item) : <ProjectDocument>item;
                }
            }
            if (data.projectUpdates) {
                this.projectUpdates = [];
                for (let i = 0; i < data.projectUpdates.length; i++) {
                    let item = data.projectUpdates[i];
                    this.projectUpdates[i] = item && !(<any>item).toJSON ? new ProjectUpdate(item) : <ProjectUpdate>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.name = _data["name"];
            this.thumbnailId = _data["thumbnailId"];
            this.projectDashboardId = _data["projectDashboardId"];
            this.description = _data["description"];
            this.videoUrl = _data["videoUrl"];
            this.amountRequested = _data["amountRequested"];
            this.typeOfFunding = _data["typeOfFunding"];
            this.fundingPurpose = _data["fundingPurpose"];
            this.projectDocumentId = _data["projectDocumentId"];
            this.levelOfImpact = _data["levelOfImpact"];
            this.timeToFunding = _data["timeToFunding"];
            this.lastSubmittedDate = _data["lastSubmittedDate"];
            this.companyId = _data["companyId"];
            this.amountRecieved = _data["amountRecieved"];
            this.status = _data["status"];
            this.subTitle = _data["subTitle"];
            this.donations = _data["donations"];
            this.category = _data["category"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["projectApprovals"])) {
                this.projectApprovals = [] as any;
                for (let item of _data["projectApprovals"])
                    this.projectApprovals!.push(ProjectApproval.fromJS(item));
            }
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.projectDashboard = _data["projectDashboard"] ? DataFile.fromJS(_data["projectDashboard"]) : <any>undefined;
            this.projectDocument = _data["projectDocument"] ? DataFile.fromJS(_data["projectDocument"]) : <any>undefined;
            this.thumbnail = _data["thumbnail"] ? DataFile.fromJS(_data["thumbnail"]) : <any>undefined;
            if (Array.isArray(_data["cartItems"])) {
                this.cartItems = [] as any;
                for (let item of _data["cartItems"])
                    this.cartItems!.push(CartItem.fromJS(item));
            }
            if (Array.isArray(_data["privateComments"])) {
                this.privateComments = [] as any;
                for (let item of _data["privateComments"])
                    this.privateComments!.push(Comment.fromJS(item));
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItem.fromJS(item));
            }
            if (Array.isArray(_data["pledgeItems"])) {
                this.pledgeItems = [] as any;
                for (let item of _data["pledgeItems"])
                    this.pledgeItems!.push(PledgeItem.fromJS(item));
            }
            if (Array.isArray(_data["projectHistories"])) {
                this.projectHistories = [] as any;
                for (let item of _data["projectHistories"])
                    this.projectHistories!.push(ProjectHistory.fromJS(item));
            }
            if (Array.isArray(_data["projectDocuments"])) {
                this.projectDocuments = [] as any;
                for (let item of _data["projectDocuments"])
                    this.projectDocuments!.push(ProjectDocument.fromJS(item));
            }
            if (Array.isArray(_data["projectUpdates"])) {
                this.projectUpdates = [] as any;
                for (let item of _data["projectUpdates"])
                    this.projectUpdates!.push(ProjectUpdate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["name"] = this.name;
        data["thumbnailId"] = this.thumbnailId;
        data["projectDashboardId"] = this.projectDashboardId;
        data["description"] = this.description;
        data["videoUrl"] = this.videoUrl;
        data["amountRequested"] = this.amountRequested;
        data["typeOfFunding"] = this.typeOfFunding;
        data["fundingPurpose"] = this.fundingPurpose;
        data["projectDocumentId"] = this.projectDocumentId;
        data["levelOfImpact"] = this.levelOfImpact;
        data["timeToFunding"] = this.timeToFunding;
        data["lastSubmittedDate"] = this.lastSubmittedDate;
        data["companyId"] = this.companyId;
        data["amountRecieved"] = this.amountRecieved;
        data["status"] = this.status;
        data["subTitle"] = this.subTitle;
        data["donations"] = this.donations;
        data["category"] = this.category;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.projectApprovals)) {
            data["projectApprovals"] = [];
            for (let item of this.projectApprovals)
                data["projectApprovals"].push(item.toJSON());
        }
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["projectDashboard"] = this.projectDashboard ? this.projectDashboard.toJSON() : <any>undefined;
        data["projectDocument"] = this.projectDocument ? this.projectDocument.toJSON() : <any>undefined;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        if (Array.isArray(this.cartItems)) {
            data["cartItems"] = [];
            for (let item of this.cartItems)
                data["cartItems"].push(item.toJSON());
        }
        if (Array.isArray(this.privateComments)) {
            data["privateComments"] = [];
            for (let item of this.privateComments)
                data["privateComments"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.pledgeItems)) {
            data["pledgeItems"] = [];
            for (let item of this.pledgeItems)
                data["pledgeItems"].push(item.toJSON());
        }
        if (Array.isArray(this.projectHistories)) {
            data["projectHistories"] = [];
            for (let item of this.projectHistories)
                data["projectHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.projectDocuments)) {
            data["projectDocuments"] = [];
            for (let item of this.projectDocuments)
                data["projectDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.projectUpdates)) {
            data["projectUpdates"] = [];
            for (let item of this.projectUpdates)
                data["projectUpdates"].push(item.toJSON());
        }
        return data;
    }

    clone(): Project {
        const json = this.toJSON();
        let result = new Project();
        result.init(json);
        return result;
    }
}

export interface IProject {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    name?: string | undefined;
    thumbnailId?: string | undefined;
    projectDashboardId?: string | undefined;
    description?: string | undefined;
    videoUrl?: string | undefined;
    amountRequested?: number;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    projectDocumentId?: string | undefined;
    levelOfImpact?: string | undefined;
    timeToFunding?: string | undefined;
    lastSubmittedDate?: string | undefined;
    companyId?: string | undefined;
    amountRecieved?: number | undefined;
    status?: ProjectStatus;
    subTitle?: string | undefined;
    donations?: number | undefined;
    category?: ProjectCategory;
    displayOrder?: number | undefined;
    projectApprovals?: IProjectApproval[] | undefined;
    company?: ICompany;
    projectDashboard?: IDataFile;
    projectDocument?: IDataFile;
    thumbnail?: IDataFile;
    cartItems?: ICartItem[] | undefined;
    privateComments?: IComment[] | undefined;
    orderItems?: IOrderItem[] | undefined;
    pledgeItems?: IPledgeItem[] | undefined;
    projectHistories?: IProjectHistory[] | undefined;
    projectDocuments?: IProjectDocument[] | undefined;
    projectUpdates?: IProjectUpdate[] | undefined;
}

export class ProjectApproval implements IProjectApproval {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    reason?: string | undefined;
    status?: ProjectApprovalStatus;
    projectId?: string;
    project?: Project;

    constructor(data?: IProjectApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new Project(data.project) : <Project>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.reason = _data["reason"];
            this.status = _data["status"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectApproval {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["reason"] = this.reason;
        data["status"] = this.status;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProjectApproval {
        const json = this.toJSON();
        let result = new ProjectApproval();
        result.init(json);
        return result;
    }
}

export interface IProjectApproval {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    reason?: string | undefined;
    status?: ProjectApprovalStatus;
    projectId?: string;
    project?: IProject;
}

export enum ProjectApprovalStatus {
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum ProjectCategory {
    HealthAndWellness = "HealthAndWellness",
    Education = "Education",
    CitizensSecuritySafety = "CitizensSecuritySafety",
    Culture = "Culture",
    HousingSolutions = "HousingSolutions",
    RenewableEnergySolutions = "RenewableEnergySolutions",
    UrbanRenewal = "UrbanRenewal",
    ClimateChange = "ClimateChange",
}

export class ProjectDetailsModel implements IProjectDetailsModel {
    id?: string | undefined;
    name?: string | undefined;
    subTitle?: string | undefined;
    category?: ProjectCategory;
    description?: string | undefined;
    videoUrl?: string | undefined;
    amountRequested?: number | undefined;
    amountReceived?: number | undefined;
    donations?: number | undefined;
    status?: ProjectStatus;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    lastSubmittedDate?: string | undefined;
    timeToFunding?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    projectDashboardFileUrl?: string | undefined;
    projectDocumentFileUrl?: string | undefined;
    projectDocuments?: ProjectDocument[] | undefined;
    projectApprovals?: ProjectApproval[] | undefined;
    projectUpdates?: ProjectUpdate[] | undefined;

    constructor(data?: IProjectDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projectDocuments) {
                this.projectDocuments = [];
                for (let i = 0; i < data.projectDocuments.length; i++) {
                    let item = data.projectDocuments[i];
                    this.projectDocuments[i] = item && !(<any>item).toJSON ? new ProjectDocument(item) : <ProjectDocument>item;
                }
            }
            if (data.projectApprovals) {
                this.projectApprovals = [];
                for (let i = 0; i < data.projectApprovals.length; i++) {
                    let item = data.projectApprovals[i];
                    this.projectApprovals[i] = item && !(<any>item).toJSON ? new ProjectApproval(item) : <ProjectApproval>item;
                }
            }
            if (data.projectUpdates) {
                this.projectUpdates = [];
                for (let i = 0; i < data.projectUpdates.length; i++) {
                    let item = data.projectUpdates[i];
                    this.projectUpdates[i] = item && !(<any>item).toJSON ? new ProjectUpdate(item) : <ProjectUpdate>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subTitle = _data["subTitle"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.videoUrl = _data["videoUrl"];
            this.amountRequested = _data["amountRequested"];
            this.amountReceived = _data["amountReceived"];
            this.donations = _data["donations"];
            this.status = _data["status"];
            this.typeOfFunding = _data["typeOfFunding"];
            this.fundingPurpose = _data["fundingPurpose"];
            this.lastSubmittedDate = _data["lastSubmittedDate"];
            this.timeToFunding = _data["timeToFunding"];
            this.thumbnailFileUrl = _data["thumbnailFileUrl"];
            this.projectDashboardFileUrl = _data["projectDashboardFileUrl"];
            this.projectDocumentFileUrl = _data["projectDocumentFileUrl"];
            if (Array.isArray(_data["projectDocuments"])) {
                this.projectDocuments = [] as any;
                for (let item of _data["projectDocuments"])
                    this.projectDocuments!.push(ProjectDocument.fromJS(item));
            }
            if (Array.isArray(_data["projectApprovals"])) {
                this.projectApprovals = [] as any;
                for (let item of _data["projectApprovals"])
                    this.projectApprovals!.push(ProjectApproval.fromJS(item));
            }
            if (Array.isArray(_data["projectUpdates"])) {
                this.projectUpdates = [] as any;
                for (let item of _data["projectUpdates"])
                    this.projectUpdates!.push(ProjectUpdate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subTitle"] = this.subTitle;
        data["category"] = this.category;
        data["description"] = this.description;
        data["videoUrl"] = this.videoUrl;
        data["amountRequested"] = this.amountRequested;
        data["amountReceived"] = this.amountReceived;
        data["donations"] = this.donations;
        data["status"] = this.status;
        data["typeOfFunding"] = this.typeOfFunding;
        data["fundingPurpose"] = this.fundingPurpose;
        data["lastSubmittedDate"] = this.lastSubmittedDate;
        data["timeToFunding"] = this.timeToFunding;
        data["thumbnailFileUrl"] = this.thumbnailFileUrl;
        data["projectDashboardFileUrl"] = this.projectDashboardFileUrl;
        data["projectDocumentFileUrl"] = this.projectDocumentFileUrl;
        if (Array.isArray(this.projectDocuments)) {
            data["projectDocuments"] = [];
            for (let item of this.projectDocuments)
                data["projectDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.projectApprovals)) {
            data["projectApprovals"] = [];
            for (let item of this.projectApprovals)
                data["projectApprovals"].push(item.toJSON());
        }
        if (Array.isArray(this.projectUpdates)) {
            data["projectUpdates"] = [];
            for (let item of this.projectUpdates)
                data["projectUpdates"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProjectDetailsModel {
        const json = this.toJSON();
        let result = new ProjectDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IProjectDetailsModel {
    id?: string | undefined;
    name?: string | undefined;
    subTitle?: string | undefined;
    category?: ProjectCategory;
    description?: string | undefined;
    videoUrl?: string | undefined;
    amountRequested?: number | undefined;
    amountReceived?: number | undefined;
    donations?: number | undefined;
    status?: ProjectStatus;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    lastSubmittedDate?: string | undefined;
    timeToFunding?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    projectDashboardFileUrl?: string | undefined;
    projectDocumentFileUrl?: string | undefined;
    projectDocuments?: IProjectDocument[] | undefined;
    projectApprovals?: IProjectApproval[] | undefined;
    projectUpdates?: IProjectUpdate[] | undefined;
}

export class ProjectDocument implements IProjectDocument {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    projectId?: string | undefined;
    project?: Project;
    documentId?: string | undefined;
    document?: DataFile;
    videoUrl?: string | undefined;
    description?: string | undefined;
    projectUpdateId?: string | undefined;
    toBeRemoved?: boolean | undefined;

    constructor(data?: IProjectDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new Project(data.project) : <Project>this.project;
            this.document = data.document && !(<any>data.document).toJSON ? new DataFile(data.document) : <DataFile>this.document;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? DataFile.fromJS(_data["document"]) : <any>undefined;
            this.videoUrl = _data["videoUrl"];
            this.description = _data["description"];
            this.projectUpdateId = _data["projectUpdateId"];
            this.toBeRemoved = _data["toBeRemoved"];
        }
    }

    static fromJS(data: any): ProjectDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["videoUrl"] = this.videoUrl;
        data["description"] = this.description;
        data["projectUpdateId"] = this.projectUpdateId;
        data["toBeRemoved"] = this.toBeRemoved;
        return data;
    }

    clone(): ProjectDocument {
        const json = this.toJSON();
        let result = new ProjectDocument();
        result.init(json);
        return result;
    }
}

export interface IProjectDocument {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    projectId?: string | undefined;
    project?: IProject;
    documentId?: string | undefined;
    document?: IDataFile;
    videoUrl?: string | undefined;
    description?: string | undefined;
    projectUpdateId?: string | undefined;
    toBeRemoved?: boolean | undefined;
}

export class ProjectExistForUserQueryResponse implements IProjectExistForUserQueryResponse {
    exists?: boolean;

    constructor(data?: IProjectExistForUserQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
        }
    }

    static fromJS(data: any): ProjectExistForUserQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectExistForUserQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        return data;
    }

    clone(): ProjectExistForUserQueryResponse {
        const json = this.toJSON();
        let result = new ProjectExistForUserQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IProjectExistForUserQueryResponse {
    exists?: boolean;
}

export class ProjectExistsForUserDTO implements IProjectExistsForUserDTO {
    id?: string | undefined;
    name?: string | undefined;
    projectId?: string | undefined;

    constructor(data?: IProjectExistsForUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProjectExistsForUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectExistsForUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): ProjectExistsForUserDTO {
        const json = this.toJSON();
        let result = new ProjectExistsForUserDTO();
        result.init(json);
        return result;
    }
}

export interface IProjectExistsForUserDTO {
    id?: string | undefined;
    name?: string | undefined;
    projectId?: string | undefined;
}

export class ProjectFullDetailsModel implements IProjectFullDetailsModel {
    id?: string | undefined;
    name?: string | undefined;
    subTitle?: string | undefined;
    category?: ProjectCategory;
    description?: string | undefined;
    videoUrl?: string | undefined;
    amountRequested?: number | undefined;
    amountReceived?: number | undefined;
    donations?: number | undefined;
    status?: ProjectStatus;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    lastSubmittedDate?: string | undefined;
    timeToFunding?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    projectDashboardFileUrl?: string | undefined;
    projectDocumentFileUrl?: string | undefined;
    projectDocuments?: ProjectDocument[] | undefined;
    projectApprovals?: ProjectApproval[] | undefined;
    projectUpdates?: ProjectUpdate[] | undefined;
    company?: SmallCompanyModel;
    editedProjectUpdateStatus?: ProjectUpdateStatus;

    constructor(data?: IProjectFullDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projectDocuments) {
                this.projectDocuments = [];
                for (let i = 0; i < data.projectDocuments.length; i++) {
                    let item = data.projectDocuments[i];
                    this.projectDocuments[i] = item && !(<any>item).toJSON ? new ProjectDocument(item) : <ProjectDocument>item;
                }
            }
            if (data.projectApprovals) {
                this.projectApprovals = [];
                for (let i = 0; i < data.projectApprovals.length; i++) {
                    let item = data.projectApprovals[i];
                    this.projectApprovals[i] = item && !(<any>item).toJSON ? new ProjectApproval(item) : <ProjectApproval>item;
                }
            }
            if (data.projectUpdates) {
                this.projectUpdates = [];
                for (let i = 0; i < data.projectUpdates.length; i++) {
                    let item = data.projectUpdates[i];
                    this.projectUpdates[i] = item && !(<any>item).toJSON ? new ProjectUpdate(item) : <ProjectUpdate>item;
                }
            }
            this.company = data.company && !(<any>data.company).toJSON ? new SmallCompanyModel(data.company) : <SmallCompanyModel>this.company;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subTitle = _data["subTitle"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.videoUrl = _data["videoUrl"];
            this.amountRequested = _data["amountRequested"];
            this.amountReceived = _data["amountReceived"];
            this.donations = _data["donations"];
            this.status = _data["status"];
            this.typeOfFunding = _data["typeOfFunding"];
            this.fundingPurpose = _data["fundingPurpose"];
            this.lastSubmittedDate = _data["lastSubmittedDate"];
            this.timeToFunding = _data["timeToFunding"];
            this.thumbnailFileUrl = _data["thumbnailFileUrl"];
            this.projectDashboardFileUrl = _data["projectDashboardFileUrl"];
            this.projectDocumentFileUrl = _data["projectDocumentFileUrl"];
            if (Array.isArray(_data["projectDocuments"])) {
                this.projectDocuments = [] as any;
                for (let item of _data["projectDocuments"])
                    this.projectDocuments!.push(ProjectDocument.fromJS(item));
            }
            if (Array.isArray(_data["projectApprovals"])) {
                this.projectApprovals = [] as any;
                for (let item of _data["projectApprovals"])
                    this.projectApprovals!.push(ProjectApproval.fromJS(item));
            }
            if (Array.isArray(_data["projectUpdates"])) {
                this.projectUpdates = [] as any;
                for (let item of _data["projectUpdates"])
                    this.projectUpdates!.push(ProjectUpdate.fromJS(item));
            }
            this.company = _data["company"] ? SmallCompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.editedProjectUpdateStatus = _data["editedProjectUpdateStatus"];
        }
    }

    static fromJS(data: any): ProjectFullDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFullDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subTitle"] = this.subTitle;
        data["category"] = this.category;
        data["description"] = this.description;
        data["videoUrl"] = this.videoUrl;
        data["amountRequested"] = this.amountRequested;
        data["amountReceived"] = this.amountReceived;
        data["donations"] = this.donations;
        data["status"] = this.status;
        data["typeOfFunding"] = this.typeOfFunding;
        data["fundingPurpose"] = this.fundingPurpose;
        data["lastSubmittedDate"] = this.lastSubmittedDate;
        data["timeToFunding"] = this.timeToFunding;
        data["thumbnailFileUrl"] = this.thumbnailFileUrl;
        data["projectDashboardFileUrl"] = this.projectDashboardFileUrl;
        data["projectDocumentFileUrl"] = this.projectDocumentFileUrl;
        if (Array.isArray(this.projectDocuments)) {
            data["projectDocuments"] = [];
            for (let item of this.projectDocuments)
                data["projectDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.projectApprovals)) {
            data["projectApprovals"] = [];
            for (let item of this.projectApprovals)
                data["projectApprovals"].push(item.toJSON());
        }
        if (Array.isArray(this.projectUpdates)) {
            data["projectUpdates"] = [];
            for (let item of this.projectUpdates)
                data["projectUpdates"].push(item.toJSON());
        }
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["editedProjectUpdateStatus"] = this.editedProjectUpdateStatus;
        return data;
    }

    clone(): ProjectFullDetailsModel {
        const json = this.toJSON();
        let result = new ProjectFullDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IProjectFullDetailsModel {
    id?: string | undefined;
    name?: string | undefined;
    subTitle?: string | undefined;
    category?: ProjectCategory;
    description?: string | undefined;
    videoUrl?: string | undefined;
    amountRequested?: number | undefined;
    amountReceived?: number | undefined;
    donations?: number | undefined;
    status?: ProjectStatus;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    lastSubmittedDate?: string | undefined;
    timeToFunding?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    projectDashboardFileUrl?: string | undefined;
    projectDocumentFileUrl?: string | undefined;
    projectDocuments?: IProjectDocument[] | undefined;
    projectApprovals?: IProjectApproval[] | undefined;
    projectUpdates?: IProjectUpdate[] | undefined;
    company?: ISmallCompanyModel;
    editedProjectUpdateStatus?: ProjectUpdateStatus;
}

export class ProjectHistory implements IProjectHistory {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    message?: string | undefined;
    historyType?: ProjectHistoryType;
    author?: string | undefined;
    projectId?: string;
    project?: Project;

    constructor(data?: IProjectHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new Project(data.project) : <Project>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.message = _data["message"];
            this.historyType = _data["historyType"];
            this.author = _data["author"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["message"] = this.message;
        data["historyType"] = this.historyType;
        data["author"] = this.author;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProjectHistory {
        const json = this.toJSON();
        let result = new ProjectHistory();
        result.init(json);
        return result;
    }
}

export interface IProjectHistory {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    message?: string | undefined;
    historyType?: ProjectHistoryType;
    author?: string | undefined;
    projectId?: string;
    project?: IProject;
}

export enum ProjectHistoryType {
    UpdateStatus = "UpdateStatus",
}

export class ProjectListModel implements IProjectListModel {
    id?: string;
    name?: string | undefined;
    subTitle?: string | undefined;
    amountRequested?: number | undefined;
    amountReceived?: number | undefined;
    status?: ProjectStatus;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    timeToFunding?: string | undefined;
    companyName?: string | undefined;
    companyParish?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    projectUrl?: string | undefined;
    displayOrder?: number | undefined;
    readonly isFullyFunded?: boolean;

    constructor(data?: IProjectListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subTitle = _data["subTitle"];
            this.amountRequested = _data["amountRequested"];
            this.amountReceived = _data["amountReceived"];
            this.status = _data["status"];
            this.typeOfFunding = _data["typeOfFunding"];
            this.fundingPurpose = _data["fundingPurpose"];
            this.timeToFunding = _data["timeToFunding"];
            this.companyName = _data["companyName"];
            this.companyParish = _data["companyParish"];
            this.thumbnailFileUrl = _data["thumbnailFileUrl"];
            this.projectUrl = _data["projectUrl"];
            this.displayOrder = _data["displayOrder"];
            (<any>this).isFullyFunded = _data["isFullyFunded"];
        }
    }

    static fromJS(data: any): ProjectListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subTitle"] = this.subTitle;
        data["amountRequested"] = this.amountRequested;
        data["amountReceived"] = this.amountReceived;
        data["status"] = this.status;
        data["typeOfFunding"] = this.typeOfFunding;
        data["fundingPurpose"] = this.fundingPurpose;
        data["timeToFunding"] = this.timeToFunding;
        data["companyName"] = this.companyName;
        data["companyParish"] = this.companyParish;
        data["thumbnailFileUrl"] = this.thumbnailFileUrl;
        data["projectUrl"] = this.projectUrl;
        data["displayOrder"] = this.displayOrder;
        data["isFullyFunded"] = this.isFullyFunded;
        return data;
    }

    clone(): ProjectListModel {
        const json = this.toJSON();
        let result = new ProjectListModel();
        result.init(json);
        return result;
    }
}

export interface IProjectListModel {
    id?: string;
    name?: string | undefined;
    subTitle?: string | undefined;
    amountRequested?: number | undefined;
    amountReceived?: number | undefined;
    status?: ProjectStatus;
    typeOfFunding?: FundingType;
    fundingPurpose?: FundingPurpose;
    timeToFunding?: string | undefined;
    companyName?: string | undefined;
    companyParish?: string | undefined;
    thumbnailFileUrl?: string | undefined;
    projectUrl?: string | undefined;
    displayOrder?: number | undefined;
    isFullyFunded?: boolean;
}

export enum ProjectStatus {
    Draft = "Draft",
    Submitted = "Submitted",
    UnderReview = "UnderReview",
    Rejected = "Rejected",
    FirstApproved = "FirstApproved",
    Finalized = "Finalized",
    Revision = "Revision",
    Completed = "Completed",
}

export class ProjectUpdate implements IProjectUpdate {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    lastSubmittedDate?: string | undefined;
    reason?: string | undefined;
    status?: ProjectUpdateStatus;
    projectId?: string;
    project?: Project;
    projectDocuments?: ProjectDocument[] | undefined;
    projectUpdateApprovals?: ProjectUpdateApproval[] | undefined;
    name?: string | undefined;
    subTitle?: string | undefined;
    category?: ProjectCategory;
    timeToFunding?: string | undefined;
    description?: string | undefined;
    fundingPurpose?: FundingPurpose;
    typeOfFunding?: FundingType;
    amountRequested?: number | undefined;
    videoUrl?: string | undefined;
    thumbnailDataFileId?: string | undefined;
    projectDashboardDataFileId?: string | undefined;
    projectDocumentDataFileId?: string | undefined;
    thumbnailDataFile?: DataFile;
    dashboardDataFile?: DataFile;
    projectDocumentDataFile?: DataFile;
    thumbnailFileUrl?: string | undefined;
    projectDashboardFileUrl?: string | undefined;
    projectDocumentFileUrl?: string | undefined;

    constructor(data?: IProjectUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new Project(data.project) : <Project>this.project;
            if (data.projectDocuments) {
                this.projectDocuments = [];
                for (let i = 0; i < data.projectDocuments.length; i++) {
                    let item = data.projectDocuments[i];
                    this.projectDocuments[i] = item && !(<any>item).toJSON ? new ProjectDocument(item) : <ProjectDocument>item;
                }
            }
            if (data.projectUpdateApprovals) {
                this.projectUpdateApprovals = [];
                for (let i = 0; i < data.projectUpdateApprovals.length; i++) {
                    let item = data.projectUpdateApprovals[i];
                    this.projectUpdateApprovals[i] = item && !(<any>item).toJSON ? new ProjectUpdateApproval(item) : <ProjectUpdateApproval>item;
                }
            }
            this.thumbnailDataFile = data.thumbnailDataFile && !(<any>data.thumbnailDataFile).toJSON ? new DataFile(data.thumbnailDataFile) : <DataFile>this.thumbnailDataFile;
            this.dashboardDataFile = data.dashboardDataFile && !(<any>data.dashboardDataFile).toJSON ? new DataFile(data.dashboardDataFile) : <DataFile>this.dashboardDataFile;
            this.projectDocumentDataFile = data.projectDocumentDataFile && !(<any>data.projectDocumentDataFile).toJSON ? new DataFile(data.projectDocumentDataFile) : <DataFile>this.projectDocumentDataFile;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.lastSubmittedDate = _data["lastSubmittedDate"];
            this.reason = _data["reason"];
            this.status = _data["status"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["projectDocuments"])) {
                this.projectDocuments = [] as any;
                for (let item of _data["projectDocuments"])
                    this.projectDocuments!.push(ProjectDocument.fromJS(item));
            }
            if (Array.isArray(_data["projectUpdateApprovals"])) {
                this.projectUpdateApprovals = [] as any;
                for (let item of _data["projectUpdateApprovals"])
                    this.projectUpdateApprovals!.push(ProjectUpdateApproval.fromJS(item));
            }
            this.name = _data["name"];
            this.subTitle = _data["subTitle"];
            this.category = _data["category"];
            this.timeToFunding = _data["timeToFunding"];
            this.description = _data["description"];
            this.fundingPurpose = _data["fundingPurpose"];
            this.typeOfFunding = _data["typeOfFunding"];
            this.amountRequested = _data["amountRequested"];
            this.videoUrl = _data["videoUrl"];
            this.thumbnailDataFileId = _data["thumbnailDataFileId"];
            this.projectDashboardDataFileId = _data["projectDashboardDataFileId"];
            this.projectDocumentDataFileId = _data["projectDocumentDataFileId"];
            this.thumbnailDataFile = _data["thumbnailDataFile"] ? DataFile.fromJS(_data["thumbnailDataFile"]) : <any>undefined;
            this.dashboardDataFile = _data["dashboardDataFile"] ? DataFile.fromJS(_data["dashboardDataFile"]) : <any>undefined;
            this.projectDocumentDataFile = _data["projectDocumentDataFile"] ? DataFile.fromJS(_data["projectDocumentDataFile"]) : <any>undefined;
            this.thumbnailFileUrl = _data["thumbnailFileUrl"];
            this.projectDashboardFileUrl = _data["projectDashboardFileUrl"];
            this.projectDocumentFileUrl = _data["projectDocumentFileUrl"];
        }
    }

    static fromJS(data: any): ProjectUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["lastSubmittedDate"] = this.lastSubmittedDate;
        data["reason"] = this.reason;
        data["status"] = this.status;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.projectDocuments)) {
            data["projectDocuments"] = [];
            for (let item of this.projectDocuments)
                data["projectDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.projectUpdateApprovals)) {
            data["projectUpdateApprovals"] = [];
            for (let item of this.projectUpdateApprovals)
                data["projectUpdateApprovals"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["subTitle"] = this.subTitle;
        data["category"] = this.category;
        data["timeToFunding"] = this.timeToFunding;
        data["description"] = this.description;
        data["fundingPurpose"] = this.fundingPurpose;
        data["typeOfFunding"] = this.typeOfFunding;
        data["amountRequested"] = this.amountRequested;
        data["videoUrl"] = this.videoUrl;
        data["thumbnailDataFileId"] = this.thumbnailDataFileId;
        data["projectDashboardDataFileId"] = this.projectDashboardDataFileId;
        data["projectDocumentDataFileId"] = this.projectDocumentDataFileId;
        data["thumbnailDataFile"] = this.thumbnailDataFile ? this.thumbnailDataFile.toJSON() : <any>undefined;
        data["dashboardDataFile"] = this.dashboardDataFile ? this.dashboardDataFile.toJSON() : <any>undefined;
        data["projectDocumentDataFile"] = this.projectDocumentDataFile ? this.projectDocumentDataFile.toJSON() : <any>undefined;
        data["thumbnailFileUrl"] = this.thumbnailFileUrl;
        data["projectDashboardFileUrl"] = this.projectDashboardFileUrl;
        data["projectDocumentFileUrl"] = this.projectDocumentFileUrl;
        return data;
    }

    clone(): ProjectUpdate {
        const json = this.toJSON();
        let result = new ProjectUpdate();
        result.init(json);
        return result;
    }
}

export interface IProjectUpdate {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    lastSubmittedDate?: string | undefined;
    reason?: string | undefined;
    status?: ProjectUpdateStatus;
    projectId?: string;
    project?: IProject;
    projectDocuments?: IProjectDocument[] | undefined;
    projectUpdateApprovals?: IProjectUpdateApproval[] | undefined;
    name?: string | undefined;
    subTitle?: string | undefined;
    category?: ProjectCategory;
    timeToFunding?: string | undefined;
    description?: string | undefined;
    fundingPurpose?: FundingPurpose;
    typeOfFunding?: FundingType;
    amountRequested?: number | undefined;
    videoUrl?: string | undefined;
    thumbnailDataFileId?: string | undefined;
    projectDashboardDataFileId?: string | undefined;
    projectDocumentDataFileId?: string | undefined;
    thumbnailDataFile?: IDataFile;
    dashboardDataFile?: IDataFile;
    projectDocumentDataFile?: IDataFile;
    thumbnailFileUrl?: string | undefined;
    projectDashboardFileUrl?: string | undefined;
    projectDocumentFileUrl?: string | undefined;
}

export class ProjectUpdateApproval implements IProjectUpdateApproval {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    reason?: string | undefined;
    status?: ProjectUpdateApprovalStatus;
    projectUpdateId?: string;
    projectUpdate?: ProjectUpdate;

    constructor(data?: IProjectUpdateApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.projectUpdate = data.projectUpdate && !(<any>data.projectUpdate).toJSON ? new ProjectUpdate(data.projectUpdate) : <ProjectUpdate>this.projectUpdate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.reason = _data["reason"];
            this.status = _data["status"];
            this.projectUpdateId = _data["projectUpdateId"];
            this.projectUpdate = _data["projectUpdate"] ? ProjectUpdate.fromJS(_data["projectUpdate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectUpdateApproval {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUpdateApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["reason"] = this.reason;
        data["status"] = this.status;
        data["projectUpdateId"] = this.projectUpdateId;
        data["projectUpdate"] = this.projectUpdate ? this.projectUpdate.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProjectUpdateApproval {
        const json = this.toJSON();
        let result = new ProjectUpdateApproval();
        result.init(json);
        return result;
    }
}

export interface IProjectUpdateApproval {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    reason?: string | undefined;
    status?: ProjectUpdateApprovalStatus;
    projectUpdateId?: string;
    projectUpdate?: IProjectUpdate;
}

export enum ProjectUpdateApprovalStatus {
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum ProjectUpdateStatus {
    Draft = "Draft",
    Submitted = "Submitted",
    Rejected = "Rejected",
    FirstApproved = "FirstApproved",
    Accepted = "Accepted",
}

export class RecaptchaModel implements IRecaptchaModel {
    token?: string | undefined;

    constructor(data?: IRecaptchaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RecaptchaModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecaptchaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }

    clone(): RecaptchaModel {
        const json = this.toJSON();
        let result = new RecaptchaModel();
        result.init(json);
        return result;
    }
}

export interface IRecaptchaModel {
    token?: string | undefined;
}

export class ReceiptModel implements IReceiptModel {
    fileName?: string | undefined;
    fileBase64String?: string | undefined;

    constructor(data?: IReceiptModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileBase64String = _data["fileBase64String"];
        }
    }

    static fromJS(data: any): ReceiptModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileBase64String"] = this.fileBase64String;
        return data;
    }

    clone(): ReceiptModel {
        const json = this.toJSON();
        let result = new ReceiptModel();
        result.init(json);
        return result;
    }
}

export interface IReceiptModel {
    fileName?: string | undefined;
    fileBase64String?: string | undefined;
}

export class ReferenceItem implements IReferenceItem {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IReferenceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ReferenceItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): ReferenceItem {
        const json = this.toJSON();
        let result = new ReferenceItem();
        result.init(json);
        return result;
    }
}

export interface IReferenceItem {
    name?: string | undefined;
    value?: string | undefined;
}

export class ReferenceList implements IReferenceList {
    name?: string | undefined;
    items?: ReferenceItem[] | undefined;

    constructor(data?: IReferenceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new ReferenceItem(item) : <ReferenceItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReferenceItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReferenceList {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReferenceList {
        const json = this.toJSON();
        let result = new ReferenceList();
        result.init(json);
        return result;
    }
}

export interface IReferenceList {
    name?: string | undefined;
    items?: IReferenceItem[] | undefined;
}

export class RefreshToken implements IRefreshToken {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    token?: string | undefined;
    expires?: string;
    remoteIpAddress?: string | undefined;
    readonly active?: boolean;
    userId?: string | undefined;
    user?: User;

    constructor(data?: IRefreshToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.token = _data["token"];
            this.expires = _data["expires"];
            this.remoteIpAddress = _data["remoteIpAddress"];
            (<any>this).active = _data["active"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshToken {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["token"] = this.token;
        data["expires"] = this.expires;
        data["remoteIpAddress"] = this.remoteIpAddress;
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): RefreshToken {
        const json = this.toJSON();
        let result = new RefreshToken();
        result.init(json);
        return result;
    }
}

export interface IRefreshToken {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    token?: string | undefined;
    expires?: string;
    remoteIpAddress?: string | undefined;
    active?: boolean;
    userId?: string | undefined;
    user?: IUser;
}

export class RefreshTokenCommandResponse implements IRefreshTokenCommandResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    expiresIn?: number;

    constructor(data?: IRefreshTokenCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.expiresIn = _data["expiresIn"];
        }
    }

    static fromJS(data: any): RefreshTokenCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["expiresIn"] = this.expiresIn;
        return data;
    }

    clone(): RefreshTokenCommandResponse {
        const json = this.toJSON();
        let result = new RefreshTokenCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRefreshTokenCommandResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    expiresIn?: number;
}

export class RefreshTokenDto implements IRefreshTokenDto {
    username?: string | undefined;
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }

    clone(): RefreshTokenDto {
        const json = this.toJSON();
        let result = new RefreshTokenDto();
        result.init(json);
        return result;
    }
}

export interface IRefreshTokenDto {
    username?: string | undefined;
    token?: string | undefined;
    refreshToken?: string | undefined;
}

export class RegisterCardResponse implements IRegisterCardResponse {
    registeredStatus?: boolean;

    constructor(data?: IRegisterCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registeredStatus = _data["registeredStatus"];
        }
    }

    static fromJS(data: any): RegisterCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredStatus"] = this.registeredStatus;
        return data;
    }

    clone(): RegisterCardResponse {
        const json = this.toJSON();
        let result = new RegisterCardResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterCardResponse {
    registeredStatus?: boolean;
}

export class RegisterCompanyCommandResponse implements IRegisterCompanyCommandResponse {
    newUser?: SlimUser;
    company?: Company;

    constructor(data?: IRegisterCompanyCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new SlimUser(data.newUser) : <SlimUser>this.newUser;
            this.company = data.company && !(<any>data.company).toJSON ? new Company(data.company) : <Company>this.company;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newUser = _data["newUser"] ? SlimUser.fromJS(_data["newUser"]) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterCompanyCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCompanyCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }

    clone(): RegisterCompanyCommandResponse {
        const json = this.toJSON();
        let result = new RegisterCompanyCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterCompanyCommandResponse {
    newUser?: ISlimUser;
    company?: ICompany;
}

export class RegisterInvestorCommandResponse implements IRegisterInvestorCommandResponse {
    newUser?: SlimUser;
    result?: IdentityResult;
    investor?: Investor;

    constructor(data?: IRegisterInvestorCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new SlimUser(data.newUser) : <SlimUser>this.newUser;
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result;
            this.investor = data.investor && !(<any>data.investor).toJSON ? new Investor(data.investor) : <Investor>this.investor;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newUser = _data["newUser"] ? SlimUser.fromJS(_data["newUser"]) : <any>undefined;
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.investor = _data["investor"] ? Investor.fromJS(_data["investor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterInvestorCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInvestorCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["investor"] = this.investor ? this.investor.toJSON() : <any>undefined;
        return data;
    }

    clone(): RegisterInvestorCommandResponse {
        const json = this.toJSON();
        let result = new RegisterInvestorCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterInvestorCommandResponse {
    newUser?: ISlimUser;
    result?: IIdentityResult;
    investor?: IInvestor;
}

export class RegisterInvestorModel implements IRegisterInvestorModel {
    userAccountType?: UserAccountType;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    confirmEmail?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    address?: Address;
    phoneNumber?: string | undefined;

    constructor(data?: IRegisterInvestorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userAccountType = _data["userAccountType"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.confirmEmail = _data["confirmEmail"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): RegisterInvestorModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInvestorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userAccountType"] = this.userAccountType;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["confirmEmail"] = this.confirmEmail;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["taxIdNumber"] = this.taxIdNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): RegisterInvestorModel {
        const json = this.toJSON();
        let result = new RegisterInvestorModel();
        result.init(json);
        return result;
    }
}

export interface IRegisterInvestorModel {
    userAccountType?: UserAccountType;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    confirmEmail?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    address?: IAddress;
    phoneNumber?: string | undefined;
}

export class RegisterInvestorOrEntrepreneurCommandResponse implements IRegisterInvestorOrEntrepreneurCommandResponse {
    newUser?: SlimUser;
    company?: Company;
    readonly message?: string | undefined;

    constructor(data?: IRegisterInvestorOrEntrepreneurCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new SlimUser(data.newUser) : <SlimUser>this.newUser;
            this.company = data.company && !(<any>data.company).toJSON ? new Company(data.company) : <Company>this.company;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newUser = _data["newUser"] ? SlimUser.fromJS(_data["newUser"]) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            (<any>this).message = _data["message"];
        }
    }

    static fromJS(data: any): RegisterInvestorOrEntrepreneurCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInvestorOrEntrepreneurCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }

    clone(): RegisterInvestorOrEntrepreneurCommandResponse {
        const json = this.toJSON();
        let result = new RegisterInvestorOrEntrepreneurCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterInvestorOrEntrepreneurCommandResponse {
    newUser?: ISlimUser;
    company?: ICompany;
    message?: string | undefined;
}

export class RegisterInvestorOrEntrepreneurWebModel implements IRegisterInvestorOrEntrepreneurWebModel {
    accountType?: UserAccountType;
    investorType?: InvestorType;
    answer1?: string | undefined;
    answer2?: string | undefined;
    answer3?: string | undefined;
    businessName?: string | undefined;
    clientType?: ClientType;
    confirmEmailAddress?: string | undefined;
    confirmPassword?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactTelephone?: string | undefined;
    contactTrn?: string | undefined;
    dateOfBirth?: string | undefined;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    idNumber?: string | undefined;
    idType?: IDType;
    lastName?: string | undefined;
    password?: string | undefined;
    question1?: string | undefined;
    question2?: string | undefined;
    question3?: string | undefined;
    telephone?: string | undefined;
    address?: Address;
    companyPhoneNumber?: string | undefined;
    trn?: string | undefined;
    proofOfIncorporationFile?: Stream;
    proofOfIncorporationFileName?: string | undefined;
    proofOfTaxComplianceFile?: Stream;
    proofOfTaxComplianceFileName?: string | undefined;
    proofOfIncorporationFileBase64?: Base64FileModel;
    proofOfTaxComplianceFileBase64?: Base64FileModel;

    constructor(data?: IRegisterInvestorOrEntrepreneurWebModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.proofOfIncorporationFile = data.proofOfIncorporationFile && !(<any>data.proofOfIncorporationFile).toJSON ? new Stream(data.proofOfIncorporationFile) : <Stream>this.proofOfIncorporationFile;
            this.proofOfTaxComplianceFile = data.proofOfTaxComplianceFile && !(<any>data.proofOfTaxComplianceFile).toJSON ? new Stream(data.proofOfTaxComplianceFile) : <Stream>this.proofOfTaxComplianceFile;
            this.proofOfIncorporationFileBase64 = data.proofOfIncorporationFileBase64 && !(<any>data.proofOfIncorporationFileBase64).toJSON ? new Base64FileModel(data.proofOfIncorporationFileBase64) : <Base64FileModel>this.proofOfIncorporationFileBase64;
            this.proofOfTaxComplianceFileBase64 = data.proofOfTaxComplianceFileBase64 && !(<any>data.proofOfTaxComplianceFileBase64).toJSON ? new Base64FileModel(data.proofOfTaxComplianceFileBase64) : <Base64FileModel>this.proofOfTaxComplianceFileBase64;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountType = _data["accountType"];
            this.investorType = _data["investorType"];
            this.answer1 = _data["answer1"];
            this.answer2 = _data["answer2"];
            this.answer3 = _data["answer3"];
            this.businessName = _data["businessName"];
            this.clientType = _data["clientType"];
            this.confirmEmailAddress = _data["confirmEmailAddress"];
            this.confirmPassword = _data["confirmPassword"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactTelephone = _data["contactTelephone"];
            this.contactTrn = _data["contactTrn"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.idNumber = _data["idNumber"];
            this.idType = _data["idType"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
            this.question1 = _data["question1"];
            this.question2 = _data["question2"];
            this.question3 = _data["question3"];
            this.telephone = _data["telephone"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.companyPhoneNumber = _data["companyPhoneNumber"];
            this.trn = _data["trn"];
            this.proofOfIncorporationFile = _data["proofOfIncorporationFile"] ? Stream.fromJS(_data["proofOfIncorporationFile"]) : <any>undefined;
            this.proofOfIncorporationFileName = _data["proofOfIncorporationFileName"];
            this.proofOfTaxComplianceFile = _data["proofOfTaxComplianceFile"] ? Stream.fromJS(_data["proofOfTaxComplianceFile"]) : <any>undefined;
            this.proofOfTaxComplianceFileName = _data["proofOfTaxComplianceFileName"];
            this.proofOfIncorporationFileBase64 = _data["proofOfIncorporationFileBase64"] ? Base64FileModel.fromJS(_data["proofOfIncorporationFileBase64"]) : <any>undefined;
            this.proofOfTaxComplianceFileBase64 = _data["proofOfTaxComplianceFileBase64"] ? Base64FileModel.fromJS(_data["proofOfTaxComplianceFileBase64"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterInvestorOrEntrepreneurWebModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInvestorOrEntrepreneurWebModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountType"] = this.accountType;
        data["investorType"] = this.investorType;
        data["answer1"] = this.answer1;
        data["answer2"] = this.answer2;
        data["answer3"] = this.answer3;
        data["businessName"] = this.businessName;
        data["clientType"] = this.clientType;
        data["confirmEmailAddress"] = this.confirmEmailAddress;
        data["confirmPassword"] = this.confirmPassword;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactTelephone"] = this.contactTelephone;
        data["contactTrn"] = this.contactTrn;
        data["dateOfBirth"] = this.dateOfBirth;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["idNumber"] = this.idNumber;
        data["idType"] = this.idType;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        data["question1"] = this.question1;
        data["question2"] = this.question2;
        data["question3"] = this.question3;
        data["telephone"] = this.telephone;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["companyPhoneNumber"] = this.companyPhoneNumber;
        data["trn"] = this.trn;
        data["proofOfIncorporationFile"] = this.proofOfIncorporationFile ? this.proofOfIncorporationFile.toJSON() : <any>undefined;
        data["proofOfIncorporationFileName"] = this.proofOfIncorporationFileName;
        data["proofOfTaxComplianceFile"] = this.proofOfTaxComplianceFile ? this.proofOfTaxComplianceFile.toJSON() : <any>undefined;
        data["proofOfTaxComplianceFileName"] = this.proofOfTaxComplianceFileName;
        data["proofOfIncorporationFileBase64"] = this.proofOfIncorporationFileBase64 ? this.proofOfIncorporationFileBase64.toJSON() : <any>undefined;
        data["proofOfTaxComplianceFileBase64"] = this.proofOfTaxComplianceFileBase64 ? this.proofOfTaxComplianceFileBase64.toJSON() : <any>undefined;
        return data;
    }

    clone(): RegisterInvestorOrEntrepreneurWebModel {
        const json = this.toJSON();
        let result = new RegisterInvestorOrEntrepreneurWebModel();
        result.init(json);
        return result;
    }
}

export interface IRegisterInvestorOrEntrepreneurWebModel {
    accountType?: UserAccountType;
    investorType?: InvestorType;
    answer1?: string | undefined;
    answer2?: string | undefined;
    answer3?: string | undefined;
    businessName?: string | undefined;
    clientType?: ClientType;
    confirmEmailAddress?: string | undefined;
    confirmPassword?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactTelephone?: string | undefined;
    contactTrn?: string | undefined;
    dateOfBirth?: string | undefined;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    idNumber?: string | undefined;
    idType?: IDType;
    lastName?: string | undefined;
    password?: string | undefined;
    question1?: string | undefined;
    question2?: string | undefined;
    question3?: string | undefined;
    telephone?: string | undefined;
    address?: IAddress;
    companyPhoneNumber?: string | undefined;
    trn?: string | undefined;
    proofOfIncorporationFile?: IStream;
    proofOfIncorporationFileName?: string | undefined;
    proofOfTaxComplianceFile?: IStream;
    proofOfTaxComplianceFileName?: string | undefined;
    proofOfIncorporationFileBase64?: IBase64FileModel;
    proofOfTaxComplianceFileBase64?: IBase64FileModel;
}

export class RegisterUserCommandResponse implements IRegisterUserCommandResponse {
    result?: IdentityResult;
    newUser?: User;

    constructor(data?: IRegisterUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result;
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new User(data.newUser) : <User>this.newUser;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.newUser = _data["newUser"] ? User.fromJS(_data["newUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        return data;
    }

    clone(): RegisterUserCommandResponse {
        const json = this.toJSON();
        let result = new RegisterUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterUserCommandResponse {
    result?: IIdentityResult;
    newUser?: IUser;
}

export class RegistrationModel implements IRegistrationModel {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;

    constructor(data?: IRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.confirmEmailAddress = _data["confirmEmailAddress"];
            this.password = _data["password"];
            this.confirmationPassword = _data["confirmationPassword"];
        }
    }

    static fromJS(data: any): RegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["confirmEmailAddress"] = this.confirmEmailAddress;
        data["password"] = this.password;
        data["confirmationPassword"] = this.confirmationPassword;
        return data;
    }

    clone(): RegistrationModel {
        const json = this.toJSON();
        let result = new RegistrationModel();
        result.init(json);
        return result;
    }
}

export interface IRegistrationModel {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
}

export class RemoveFromCartResponse implements IRemoveFromCartResponse {
    cart?: CartModel;

    constructor(data?: IRemoveFromCartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new CartModel(data.cart) : <CartModel>this.cart;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? CartModel.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoveFromCartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFromCartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data;
    }

    clone(): RemoveFromCartResponse {
        const json = this.toJSON();
        let result = new RemoveFromCartResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveFromCartResponse {
    cart?: ICartModel;
}

export class RequestPasswordResetCommandRequest implements IRequestPasswordResetCommandRequest {
    emailAddress?: string | undefined;

    constructor(data?: IRequestPasswordResetCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): RequestPasswordResetCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): RequestPasswordResetCommandRequest {
        const json = this.toJSON();
        let result = new RequestPasswordResetCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRequestPasswordResetCommandRequest {
    emailAddress?: string | undefined;
}

export class RequireAdditionalDetailsForPaymentResponse implements IRequireAdditionalDetailsForPaymentResponse {
    additionalDetailsRequired?: boolean;

    constructor(data?: IRequireAdditionalDetailsForPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalDetailsRequired = _data["additionalDetailsRequired"];
        }
    }

    static fromJS(data: any): RequireAdditionalDetailsForPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequireAdditionalDetailsForPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalDetailsRequired"] = this.additionalDetailsRequired;
        return data;
    }

    clone(): RequireAdditionalDetailsForPaymentResponse {
        const json = this.toJSON();
        let result = new RequireAdditionalDetailsForPaymentResponse();
        result.init(json);
        return result;
    }
}

export interface IRequireAdditionalDetailsForPaymentResponse {
    additionalDetailsRequired?: boolean;
}

export class ResendMyActivationEmailCommandRequest implements IResendMyActivationEmailCommandRequest {
    emailAddress?: string | undefined;

    constructor(data?: IResendMyActivationEmailCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ResendMyActivationEmailCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendMyActivationEmailCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): ResendMyActivationEmailCommandRequest {
        const json = this.toJSON();
        let result = new ResendMyActivationEmailCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResendMyActivationEmailCommandRequest {
    emailAddress?: string | undefined;
}

export class ResendMyActivationEmailCommandResponse implements IResendMyActivationEmailCommandResponse {

    constructor(data?: IResendMyActivationEmailCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ResendMyActivationEmailCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResendMyActivationEmailCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ResendMyActivationEmailCommandResponse {
        const json = this.toJSON();
        let result = new ResendMyActivationEmailCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IResendMyActivationEmailCommandResponse {
}

export class ResetPasswordCommandRequest implements IResetPasswordCommandRequest {
    emailAddress?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;

    constructor(data?: IResetPasswordCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmationPassword = _data["confirmationPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmationPassword"] = this.confirmationPassword;
        return data;
    }

    clone(): ResetPasswordCommandRequest {
        const json = this.toJSON();
        let result = new ResetPasswordCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordCommandRequest {
    emailAddress?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
}

export class Role implements IRole {
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
    description?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    status?: RoleStatus;
    roleClaims?: RoleClaim[] | undefined;
    userRoles?: UserRole[] | undefined;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.roleClaims) {
                this.roleClaims = [];
                for (let i = 0; i < data.roleClaims.length; i++) {
                    let item = data.roleClaims[i];
                    this.roleClaims[i] = item && !(<any>item).toJSON ? new RoleClaim(item) : <RoleClaim>item;
                }
            }
            if (data.userRoles) {
                this.userRoles = [];
                for (let i = 0; i < data.userRoles.length; i++) {
                    let item = data.userRoles[i];
                    this.userRoles[i] = item && !(<any>item).toJSON ? new UserRole(item) : <UserRole>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.status = _data["status"];
            if (Array.isArray(_data["roleClaims"])) {
                this.roleClaims = [] as any;
                for (let item of _data["roleClaims"])
                    this.roleClaims!.push(RoleClaim.fromJS(item));
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.creationDate = _data["creationDate"];
            this.createdById = _data["createdById"];
            this.modificationDate = _data["modificationDate"];
            this.modifiedById = _data["modifiedById"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["status"] = this.status;
        if (Array.isArray(this.roleClaims)) {
            data["roleClaims"] = [];
            for (let item of this.roleClaims)
                data["roleClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        data["creationDate"] = this.creationDate;
        data["createdById"] = this.createdById;
        data["modificationDate"] = this.modificationDate;
        data["modifiedById"] = this.modifiedById;
        return data;
    }

    clone(): Role {
        const json = this.toJSON();
        let result = new Role();
        result.init(json);
        return result;
    }
}

export interface IRole {
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
    description?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    status?: RoleStatus;
    roleClaims?: IRoleClaim[] | undefined;
    userRoles?: IUserRole[] | undefined;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;
}

export class RoleClaim implements IRoleClaim {
    roleId?: string;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    id?: number;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    role?: Role;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;

    constructor(data?: IRoleClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.role = data.role && !(<any>data.role).toJSON ? new Role(data.role) : <Role>this.role;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
            this.creationDate = _data["creationDate"];
            this.createdById = _data["createdById"];
            this.modificationDate = _data["modificationDate"];
            this.modifiedById = _data["modifiedById"];
        }
    }

    static fromJS(data: any): RoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new RoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["creationDate"] = this.creationDate;
        data["createdById"] = this.createdById;
        data["modificationDate"] = this.modificationDate;
        data["modifiedById"] = this.modifiedById;
        return data;
    }

    clone(): RoleClaim {
        const json = this.toJSON();
        let result = new RoleClaim();
        result.init(json);
        return result;
    }
}

export interface IRoleClaim {
    roleId?: string;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    id?: number;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    role?: IRole;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;
}

export class RoleDetailsModel implements IRoleDetailsModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    operations?: string[] | undefined;
    status?: RoleStatus;

    constructor(data?: IRoleDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RoleDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        data["status"] = this.status;
        return data;
    }

    clone(): RoleDetailsModel {
        const json = this.toJSON();
        let result = new RoleDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IRoleDetailsModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    operations?: string[] | undefined;
    status?: RoleStatus;
}

export enum RoleStatus {
    Disabled = "Disabled",
    Active = "Active",
}

export class SimpleOrderListItem implements ISimpleOrderListItem {
    id?: string;
    userName?: string | undefined;
    createdDate?: string;
    sku?: string | undefined;
    amount?: number;
    currency?: string | undefined;
    paymentType?: PaymentType;
    project?: SimpleOrderProjectItem;
    orderId?: string | undefined;

    constructor(data?: ISimpleOrderListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new SimpleOrderProjectItem(data.project) : <SimpleOrderProjectItem>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.createdDate = _data["createdDate"];
            this.sku = _data["sku"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.paymentType = _data["paymentType"];
            this.project = _data["project"] ? SimpleOrderProjectItem.fromJS(_data["project"]) : <any>undefined;
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): SimpleOrderListItem {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleOrderListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["createdDate"] = this.createdDate;
        data["sku"] = this.sku;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["paymentType"] = this.paymentType;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): SimpleOrderListItem {
        const json = this.toJSON();
        let result = new SimpleOrderListItem();
        result.init(json);
        return result;
    }
}

export interface ISimpleOrderListItem {
    id?: string;
    userName?: string | undefined;
    createdDate?: string;
    sku?: string | undefined;
    amount?: number;
    currency?: string | undefined;
    paymentType?: PaymentType;
    project?: ISimpleOrderProjectItem;
    orderId?: string | undefined;
}

export class SimpleOrderProjectItem implements ISimpleOrderProjectItem {
    id?: string;
    company?: string | undefined;
    title?: string | undefined;

    constructor(data?: ISimpleOrderProjectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): SimpleOrderProjectItem {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleOrderProjectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company;
        data["title"] = this.title;
        return data;
    }

    clone(): SimpleOrderProjectItem {
        const json = this.toJSON();
        let result = new SimpleOrderProjectItem();
        result.init(json);
        return result;
    }
}

export interface ISimpleOrderProjectItem {
    id?: string;
    company?: string | undefined;
    title?: string | undefined;
}

export class SimpleUserProfile implements ISimpleUserProfile {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    idType?: IDType;
    idNumber?: string | undefined;
    taxIdNumber?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    address?: Address;
    isEntrepreneur?: boolean;
    isInvestor?: boolean;
    readonly companyName?: string | undefined;

    constructor(data?: ISimpleUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.isEntrepreneur = _data["isEntrepreneur"];
            this.isInvestor = _data["isInvestor"];
            (<any>this).companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): SimpleUserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleUserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["taxIdNumber"] = this.taxIdNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["isEntrepreneur"] = this.isEntrepreneur;
        data["isInvestor"] = this.isInvestor;
        data["companyName"] = this.companyName;
        return data;
    }

    clone(): SimpleUserProfile {
        const json = this.toJSON();
        let result = new SimpleUserProfile();
        result.init(json);
        return result;
    }
}

export interface ISimpleUserProfile {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    idType?: IDType;
    idNumber?: string | undefined;
    taxIdNumber?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    address?: IAddress;
    isEntrepreneur?: boolean;
    isInvestor?: boolean;
    companyName?: string | undefined;
}

export class SlimUser implements ISlimUser {
    shortId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    sessionId?: string | undefined;
    roles?: string[] | undefined;
    operations?: string[] | undefined;
    id?: string;
    isAdmin?: boolean;
    status?: UserStatus;
    emailAddress?: string | undefined;
    isActivated?: boolean;

    constructor(data?: ISlimUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortId = _data["shortId"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.sessionId = _data["sessionId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
            this.id = _data["id"];
            this.isAdmin = _data["isAdmin"];
            this.status = _data["status"];
            this.emailAddress = _data["emailAddress"];
            this.isActivated = _data["isActivated"];
        }
    }

    static fromJS(data: any): SlimUser {
        data = typeof data === 'object' ? data : {};
        let result = new SlimUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortId"] = this.shortId;
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["sessionId"] = this.sessionId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        data["id"] = this.id;
        data["isAdmin"] = this.isAdmin;
        data["status"] = this.status;
        data["emailAddress"] = this.emailAddress;
        data["isActivated"] = this.isActivated;
        return data;
    }

    clone(): SlimUser {
        const json = this.toJSON();
        let result = new SlimUser();
        result.init(json);
        return result;
    }
}

export interface ISlimUser {
    shortId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    sessionId?: string | undefined;
    roles?: string[] | undefined;
    operations?: string[] | undefined;
    id?: string;
    isAdmin?: boolean;
    status?: UserStatus;
    emailAddress?: string | undefined;
    isActivated?: boolean;
}

export class SmallAddress implements ISmallAddress {
    line1?: string | undefined;
    line2?: string | undefined;
    city?: string | undefined;
    stateParish?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: ISmallAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.city = _data["city"];
            this.stateParish = _data["stateParish"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): SmallAddress {
        data = typeof data === 'object' ? data : {};
        let result = new SmallAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["city"] = this.city;
        data["stateParish"] = this.stateParish;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }

    clone(): SmallAddress {
        const json = this.toJSON();
        let result = new SmallAddress();
        result.init(json);
        return result;
    }
}

export interface ISmallAddress {
    line1?: string | undefined;
    line2?: string | undefined;
    city?: string | undefined;
    stateParish?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
}

export class SmallCompanyModel implements ISmallCompanyModel {
    id?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    address?: SmallAddress;
    articlesOfIncorporationUrl?: string | undefined;
    proofOfTaxComplianceUrl?: string | undefined;
    trn?: string | undefined;
    contactPerson?: string | undefined;
    contactPersonEmail?: string | undefined;
    contactPersonPhone?: string | undefined;

    constructor(data?: ISmallCompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new SmallAddress(data.address) : <SmallAddress>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"] ? SmallAddress.fromJS(_data["address"]) : <any>undefined;
            this.articlesOfIncorporationUrl = _data["articlesOfIncorporationUrl"];
            this.proofOfTaxComplianceUrl = _data["proofOfTaxComplianceUrl"];
            this.trn = _data["trn"];
            this.contactPerson = _data["contactPerson"];
            this.contactPersonEmail = _data["contactPersonEmail"];
            this.contactPersonPhone = _data["contactPersonPhone"];
        }
    }

    static fromJS(data: any): SmallCompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new SmallCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["articlesOfIncorporationUrl"] = this.articlesOfIncorporationUrl;
        data["proofOfTaxComplianceUrl"] = this.proofOfTaxComplianceUrl;
        data["trn"] = this.trn;
        data["contactPerson"] = this.contactPerson;
        data["contactPersonEmail"] = this.contactPersonEmail;
        data["contactPersonPhone"] = this.contactPersonPhone;
        return data;
    }

    clone(): SmallCompanyModel {
        const json = this.toJSON();
        let result = new SmallCompanyModel();
        result.init(json);
        return result;
    }
}

export interface ISmallCompanyModel {
    id?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    address?: ISmallAddress;
    articlesOfIncorporationUrl?: string | undefined;
    proofOfTaxComplianceUrl?: string | undefined;
    trn?: string | undefined;
    contactPerson?: string | undefined;
    contactPersonEmail?: string | undefined;
    contactPersonPhone?: string | undefined;
}

export class Stream implements IStream {
    readonly canRead?: boolean;
    readonly canSeek?: boolean;
    readonly canWrite?: boolean;
    readonly length?: number;
    position?: number;
    readonly canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canWrite = _data["canWrite"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            (<any>this).canTimeout = _data["canTimeout"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canWrite"] = this.canWrite;
        data["length"] = this.length;
        data["position"] = this.position;
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data;
    }

    clone(): Stream {
        const json = this.toJSON();
        let result = new Stream();
        result.init(json);
        return result;
    }
}

export interface IStream {
    canRead?: boolean;
    canSeek?: boolean;
    canWrite?: boolean;
    length?: number;
    position?: number;
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
}

export class SubmitProjectForApprovalCommandRequest implements ISubmitProjectForApprovalCommandRequest {
    id?: string | undefined;

    constructor(data?: ISubmitProjectForApprovalCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubmitProjectForApprovalCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitProjectForApprovalCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): SubmitProjectForApprovalCommandRequest {
        const json = this.toJSON();
        let result = new SubmitProjectForApprovalCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISubmitProjectForApprovalCommandRequest {
    id?: string | undefined;
}

export class SubmitProjectForApprovalCommandResponse implements ISubmitProjectForApprovalCommandResponse {
    project?: ProjectFullDetailsModel;

    constructor(data?: ISubmitProjectForApprovalCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectFullDetailsModel(data.project) : <ProjectFullDetailsModel>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectFullDetailsModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmitProjectForApprovalCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitProjectForApprovalCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubmitProjectForApprovalCommandResponse {
        const json = this.toJSON();
        let result = new SubmitProjectForApprovalCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISubmitProjectForApprovalCommandResponse {
    project?: IProjectFullDetailsModel;
}

export class SubmitProjectUpdateForApprovalCommandRequest implements ISubmitProjectUpdateForApprovalCommandRequest {
    id?: string | undefined;

    constructor(data?: ISubmitProjectUpdateForApprovalCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubmitProjectUpdateForApprovalCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitProjectUpdateForApprovalCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): SubmitProjectUpdateForApprovalCommandRequest {
        const json = this.toJSON();
        let result = new SubmitProjectUpdateForApprovalCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISubmitProjectUpdateForApprovalCommandRequest {
    id?: string | undefined;
}

export class SubmitProjectUpdateForApprovalCommandResponse implements ISubmitProjectUpdateForApprovalCommandResponse {
    projectUpdate?: ProjectUpdate;

    constructor(data?: ISubmitProjectUpdateForApprovalCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.projectUpdate = data.projectUpdate && !(<any>data.projectUpdate).toJSON ? new ProjectUpdate(data.projectUpdate) : <ProjectUpdate>this.projectUpdate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectUpdate = _data["projectUpdate"] ? ProjectUpdate.fromJS(_data["projectUpdate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmitProjectUpdateForApprovalCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitProjectUpdateForApprovalCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectUpdate"] = this.projectUpdate ? this.projectUpdate.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubmitProjectUpdateForApprovalCommandResponse {
        const json = this.toJSON();
        let result = new SubmitProjectUpdateForApprovalCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISubmitProjectUpdateForApprovalCommandResponse {
    projectUpdate?: IProjectUpdate;
}

export class TestPaymentResponse implements ITestPaymentResponse {
    paymentStatus?: PaymentStatus;
    paymentCompleted?: boolean;
    readonly isSuccessful?: boolean;
    acsUrl?: string | undefined;
    payload?: string | undefined;
    termUrl?: string | undefined;
    md?: string | undefined;
    enrolled?: string | undefined;
    paResStatus?: string | undefined;
    errorNo?: string | undefined;
    errorDesc?: string | undefined;
    signatureVerification?: string | undefined;
    eciFlag?: string | undefined;
    xid?: string | undefined;
    cavv?: string | undefined;
    authenticationPath?: string | undefined;
    transactionId?: string | undefined;
    readonly authenticationRequired?: boolean;

    constructor(data?: ITestPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentStatus = _data["paymentStatus"];
            this.paymentCompleted = _data["paymentCompleted"];
            (<any>this).isSuccessful = _data["isSuccessful"];
            this.acsUrl = _data["acsUrl"];
            this.payload = _data["payload"];
            this.termUrl = _data["termUrl"];
            this.md = _data["md"];
            this.enrolled = _data["enrolled"];
            this.paResStatus = _data["paResStatus"];
            this.errorNo = _data["errorNo"];
            this.errorDesc = _data["errorDesc"];
            this.signatureVerification = _data["signatureVerification"];
            this.eciFlag = _data["eciFlag"];
            this.xid = _data["xid"];
            this.cavv = _data["cavv"];
            this.authenticationPath = _data["authenticationPath"];
            this.transactionId = _data["transactionId"];
            (<any>this).authenticationRequired = _data["authenticationRequired"];
        }
    }

    static fromJS(data: any): TestPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TestPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentStatus"] = this.paymentStatus;
        data["paymentCompleted"] = this.paymentCompleted;
        data["isSuccessful"] = this.isSuccessful;
        data["acsUrl"] = this.acsUrl;
        data["payload"] = this.payload;
        data["termUrl"] = this.termUrl;
        data["md"] = this.md;
        data["enrolled"] = this.enrolled;
        data["paResStatus"] = this.paResStatus;
        data["errorNo"] = this.errorNo;
        data["errorDesc"] = this.errorDesc;
        data["signatureVerification"] = this.signatureVerification;
        data["eciFlag"] = this.eciFlag;
        data["xid"] = this.xid;
        data["cavv"] = this.cavv;
        data["authenticationPath"] = this.authenticationPath;
        data["transactionId"] = this.transactionId;
        data["authenticationRequired"] = this.authenticationRequired;
        return data;
    }

    clone(): TestPaymentResponse {
        const json = this.toJSON();
        let result = new TestPaymentResponse();
        result.init(json);
        return result;
    }
}

export interface ITestPaymentResponse {
    paymentStatus?: PaymentStatus;
    paymentCompleted?: boolean;
    isSuccessful?: boolean;
    acsUrl?: string | undefined;
    payload?: string | undefined;
    termUrl?: string | undefined;
    md?: string | undefined;
    enrolled?: string | undefined;
    paResStatus?: string | undefined;
    errorNo?: string | undefined;
    errorDesc?: string | undefined;
    signatureVerification?: string | undefined;
    eciFlag?: string | undefined;
    xid?: string | undefined;
    cavv?: string | undefined;
    authenticationPath?: string | undefined;
    transactionId?: string | undefined;
    authenticationRequired?: boolean;
}

export class Transaction3DS implements ITransaction3DS {
    cavv?: string | undefined;
    eci?: string | undefined;
    xid?: string | undefined;
    transactionId?: string | undefined;
    orderId?: string | undefined;

    constructor(data?: ITransaction3DS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cavv = _data["cavv"];
            this.eci = _data["eci"];
            this.xid = _data["xid"];
            this.transactionId = _data["transactionId"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): Transaction3DS {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction3DS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cavv"] = this.cavv;
        data["eci"] = this.eci;
        data["xid"] = this.xid;
        data["transactionId"] = this.transactionId;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): Transaction3DS {
        const json = this.toJSON();
        let result = new Transaction3DS();
        result.init(json);
        return result;
    }
}

export interface ITransaction3DS {
    cavv?: string | undefined;
    eci?: string | undefined;
    xid?: string | undefined;
    transactionId?: string | undefined;
    orderId?: string | undefined;
}

export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Unit {
        const json = this.toJSON();
        let result = new Unit();
        result.init(json);
        return result;
    }
}

export interface IUnit {
}

export class UpdatePledgeStatusQueryResponse implements IUpdatePledgeStatusQueryResponse {
    success?: boolean;

    constructor(data?: IUpdatePledgeStatusQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UpdatePledgeStatusQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePledgeStatusQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }

    clone(): UpdatePledgeStatusQueryResponse {
        const json = this.toJSON();
        let result = new UpdatePledgeStatusQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdatePledgeStatusQueryResponse {
    success?: boolean;
}

export class UpdateProjectStatusCommandRequest implements IUpdateProjectStatusCommandRequest {
    projectStatus?: ProjectStatus;
    id?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IUpdateProjectStatusCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectStatus = _data["projectStatus"];
            this.id = _data["id"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateProjectStatusCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectStatusCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectStatus"] = this.projectStatus;
        data["id"] = this.id;
        data["comment"] = this.comment;
        return data;
    }

    clone(): UpdateProjectStatusCommandRequest {
        const json = this.toJSON();
        let result = new UpdateProjectStatusCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateProjectStatusCommandRequest {
    projectStatus?: ProjectStatus;
    id?: string | undefined;
    comment?: string | undefined;
}

export class UpdateProjectStatusCommandResponse implements IUpdateProjectStatusCommandResponse {
    project?: ProjectFullDetailsModel;

    constructor(data?: IUpdateProjectStatusCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.project = data.project && !(<any>data.project).toJSON ? new ProjectFullDetailsModel(data.project) : <ProjectFullDetailsModel>this.project;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectFullDetailsModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateProjectStatusCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectStatusCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateProjectStatusCommandResponse {
        const json = this.toJSON();
        let result = new UpdateProjectStatusCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateProjectStatusCommandResponse {
    project?: IProjectFullDetailsModel;
}

export class UpsertProjectUpdateCommandResponse implements IUpsertProjectUpdateCommandResponse {
    projectUpdate?: ProjectUpdate;

    constructor(data?: IUpsertProjectUpdateCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.projectUpdate = data.projectUpdate && !(<any>data.projectUpdate).toJSON ? new ProjectUpdate(data.projectUpdate) : <ProjectUpdate>this.projectUpdate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectUpdate = _data["projectUpdate"] ? ProjectUpdate.fromJS(_data["projectUpdate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpsertProjectUpdateCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProjectUpdateCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectUpdate"] = this.projectUpdate ? this.projectUpdate.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpsertProjectUpdateCommandResponse {
        const json = this.toJSON();
        let result = new UpsertProjectUpdateCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpsertProjectUpdateCommandResponse {
    projectUpdate?: IProjectUpdate;
}

export class UpsertProjectUpdateModel implements IUpsertProjectUpdateModel {
    id?: string | undefined;
    projectId?: string | undefined;
    reason?: string | undefined;
    documents?: DocumentModel[] | undefined;

    constructor(data?: IUpsertProjectUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !(<any>item).toJSON ? new DocumentModel(item) : <DocumentModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.reason = _data["reason"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertProjectUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProjectUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["reason"] = this.reason;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpsertProjectUpdateModel {
        const json = this.toJSON();
        let result = new UpsertProjectUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IUpsertProjectUpdateModel {
    id?: string | undefined;
    projectId?: string | undefined;
    reason?: string | undefined;
    documents?: IDocumentModel[] | undefined;
}

export class User implements IUser {
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    status?: UserStatus;
    cardInfos?: CardInfo[] | undefined;
    carts?: Cart[] | undefined;
    companies?: Company[] | undefined;
    orders?: Order[] | undefined;
    pledges?: Pledge[] | undefined;
    userClaims?: UserClaim[] | undefined;
    userLogins?: UserLogin[] | undefined;
    userProfiles?: UserProfile[] | undefined;
    userRoles?: UserRole[] | undefined;
    userTokens?: UserToken[] | undefined;
    readonly refreshTokens?: RefreshToken[] | undefined;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;
    operations?: Operations[];

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.cardInfos) {
                this.cardInfos = [];
                for (let i = 0; i < data.cardInfos.length; i++) {
                    let item = data.cardInfos[i];
                    this.cardInfos[i] = item && !(<any>item).toJSON ? new CardInfo(item) : <CardInfo>item;
                }
            }
            if (data.carts) {
                this.carts = [];
                for (let i = 0; i < data.carts.length; i++) {
                    let item = data.carts[i];
                    this.carts[i] = item && !(<any>item).toJSON ? new Cart(item) : <Cart>item;
                }
            }
            if (data.companies) {
                this.companies = [];
                for (let i = 0; i < data.companies.length; i++) {
                    let item = data.companies[i];
                    this.companies[i] = item && !(<any>item).toJSON ? new Company(item) : <Company>item;
                }
            }
            if (data.orders) {
                this.orders = [];
                for (let i = 0; i < data.orders.length; i++) {
                    let item = data.orders[i];
                    this.orders[i] = item && !(<any>item).toJSON ? new Order(item) : <Order>item;
                }
            }
            if (data.pledges) {
                this.pledges = [];
                for (let i = 0; i < data.pledges.length; i++) {
                    let item = data.pledges[i];
                    this.pledges[i] = item && !(<any>item).toJSON ? new Pledge(item) : <Pledge>item;
                }
            }
            if (data.userClaims) {
                this.userClaims = [];
                for (let i = 0; i < data.userClaims.length; i++) {
                    let item = data.userClaims[i];
                    this.userClaims[i] = item && !(<any>item).toJSON ? new UserClaim(item) : <UserClaim>item;
                }
            }
            if (data.userLogins) {
                this.userLogins = [];
                for (let i = 0; i < data.userLogins.length; i++) {
                    let item = data.userLogins[i];
                    this.userLogins[i] = item && !(<any>item).toJSON ? new UserLogin(item) : <UserLogin>item;
                }
            }
            if (data.userProfiles) {
                this.userProfiles = [];
                for (let i = 0; i < data.userProfiles.length; i++) {
                    let item = data.userProfiles[i];
                    this.userProfiles[i] = item && !(<any>item).toJSON ? new UserProfile(item) : <UserProfile>item;
                }
            }
            if (data.userRoles) {
                this.userRoles = [];
                for (let i = 0; i < data.userRoles.length; i++) {
                    let item = data.userRoles[i];
                    this.userRoles[i] = item && !(<any>item).toJSON ? new UserRole(item) : <UserRole>item;
                }
            }
            if (data.userTokens) {
                this.userTokens = [];
                for (let i = 0; i < data.userTokens.length; i++) {
                    let item = data.userTokens[i];
                    this.userTokens[i] = item && !(<any>item).toJSON ? new UserToken(item) : <UserToken>item;
                }
            }
            if (data.refreshTokens) {
                this.refreshTokens = [];
                for (let i = 0; i < data.refreshTokens.length; i++) {
                    let item = data.refreshTokens[i];
                    this.refreshTokens[i] = item && !(<any>item).toJSON ? new RefreshToken(item) : <RefreshToken>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.status = _data["status"];
            if (Array.isArray(_data["cardInfos"])) {
                this.cardInfos = [] as any;
                for (let item of _data["cardInfos"])
                    this.cardInfos!.push(CardInfo.fromJS(item));
            }
            if (Array.isArray(_data["carts"])) {
                this.carts = [] as any;
                for (let item of _data["carts"])
                    this.carts!.push(Cart.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["pledges"])) {
                this.pledges = [] as any;
                for (let item of _data["pledges"])
                    this.pledges!.push(Pledge.fromJS(item));
            }
            if (Array.isArray(_data["userClaims"])) {
                this.userClaims = [] as any;
                for (let item of _data["userClaims"])
                    this.userClaims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["userLogins"])) {
                this.userLogins = [] as any;
                for (let item of _data["userLogins"])
                    this.userLogins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["userProfiles"])) {
                this.userProfiles = [] as any;
                for (let item of _data["userProfiles"])
                    this.userProfiles!.push(UserProfile.fromJS(item));
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["userTokens"])) {
                this.userTokens = [] as any;
                for (let item of _data["userTokens"])
                    this.userTokens!.push(UserToken.fromJS(item));
            }
            if (Array.isArray(_data["refreshTokens"])) {
                (<any>this).refreshTokens = [] as any;
                for (let item of _data["refreshTokens"])
                    (<any>this).refreshTokens!.push(RefreshToken.fromJS(item));
            }
            this.creationDate = _data["creationDate"];
            this.createdById = _data["createdById"];
            this.modificationDate = _data["modificationDate"];
            this.modifiedById = _data["modifiedById"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["status"] = this.status;
        if (Array.isArray(this.cardInfos)) {
            data["cardInfos"] = [];
            for (let item of this.cardInfos)
                data["cardInfos"].push(item.toJSON());
        }
        if (Array.isArray(this.carts)) {
            data["carts"] = [];
            for (let item of this.carts)
                data["carts"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.pledges)) {
            data["pledges"] = [];
            for (let item of this.pledges)
                data["pledges"].push(item.toJSON());
        }
        if (Array.isArray(this.userClaims)) {
            data["userClaims"] = [];
            for (let item of this.userClaims)
                data["userClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.userLogins)) {
            data["userLogins"] = [];
            for (let item of this.userLogins)
                data["userLogins"].push(item.toJSON());
        }
        if (Array.isArray(this.userProfiles)) {
            data["userProfiles"] = [];
            for (let item of this.userProfiles)
                data["userProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.userTokens)) {
            data["userTokens"] = [];
            for (let item of this.userTokens)
                data["userTokens"].push(item.toJSON());
        }
        if (Array.isArray(this.refreshTokens)) {
            data["refreshTokens"] = [];
            for (let item of this.refreshTokens)
                data["refreshTokens"].push(item.toJSON());
        }
        data["creationDate"] = this.creationDate;
        data["createdById"] = this.createdById;
        data["modificationDate"] = this.modificationDate;
        data["modifiedById"] = this.modifiedById;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    status?: UserStatus;
    cardInfos?: ICardInfo[] | undefined;
    carts?: ICart[] | undefined;
    companies?: ICompany[] | undefined;
    orders?: IOrder[] | undefined;
    pledges?: IPledge[] | undefined;
    userClaims?: IUserClaim[] | undefined;
    userLogins?: IUserLogin[] | undefined;
    userProfiles?: IUserProfile[] | undefined;
    userRoles?: IUserRole[] | undefined;
    userTokens?: IUserToken[] | undefined;
    refreshTokens?: IRefreshToken[] | undefined;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;
    operations?: Operations[];
}

export enum UserAccountType {
    Entrepreneur = "Entrepreneur",
    SocialInvestor = "SocialInvestor",
}

export class UserClaim implements IUserClaim {
    id?: number;
    userId?: string;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    expirationDate?: string | undefined;
    status?: UserOperationStatus;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    user?: User;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.expirationDate = _data["expirationDate"];
            this.status = _data["status"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.creationDate = _data["creationDate"];
            this.createdById = _data["createdById"];
            this.modificationDate = _data["modificationDate"];
            this.modifiedById = _data["modifiedById"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["expirationDate"] = this.expirationDate;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creationDate"] = this.creationDate;
        data["createdById"] = this.createdById;
        data["modificationDate"] = this.modificationDate;
        data["modifiedById"] = this.modifiedById;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id?: number;
    userId?: string;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    expirationDate?: string | undefined;
    status?: UserOperationStatus;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    user?: IUser;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;
}

export class UserLogin implements IUserLogin {
    loginProvider?: string | undefined;
    providerKey?: string | undefined;
    providerDisplayName?: string | undefined;
    userId?: string;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    user?: User;
    id?: string;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.providerDisplayName = _data["providerDisplayName"];
            this.userId = _data["userId"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.creationDate = _data["creationDate"];
            this.createdById = _data["createdById"];
            this.modificationDate = _data["modificationDate"];
            this.modifiedById = _data["modifiedById"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["providerDisplayName"] = this.providerDisplayName;
        data["userId"] = this.userId;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["creationDate"] = this.creationDate;
        data["createdById"] = this.createdById;
        data["modificationDate"] = this.modificationDate;
        data["modifiedById"] = this.modifiedById;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    loginProvider?: string | undefined;
    providerKey?: string | undefined;
    providerDisplayName?: string | undefined;
    userId?: string;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    user?: IUser;
    id?: string;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;
}

export enum UserOperationStatus {
    Active = "Active",
    Disabled = "Disabled",
    Expired = "Expired",
}

export class UserProfile implements IUserProfile {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    addressId?: string;
    userId?: string;
    isEntrepreneur?: boolean;
    isInvestor?: boolean;
    companyId?: string | undefined;
    phoneNumber?: string | undefined;
    idNumber?: string | undefined;
    idType?: IDType;
    address?: Address;
    company?: Company;
    user?: User;
    readonly fullName?: string | undefined;

    constructor(data?: IUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.company = data.company && !(<any>data.company).toJSON ? new Company(data.company) : <Company>this.company;
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.addressId = _data["addressId"];
            this.userId = _data["userId"];
            this.isEntrepreneur = _data["isEntrepreneur"];
            this.isInvestor = _data["isInvestor"];
            this.companyId = _data["companyId"];
            this.phoneNumber = _data["phoneNumber"];
            this.idNumber = _data["idNumber"];
            this.idType = _data["idType"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["taxIdNumber"] = this.taxIdNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["addressId"] = this.addressId;
        data["userId"] = this.userId;
        data["isEntrepreneur"] = this.isEntrepreneur;
        data["isInvestor"] = this.isInvestor;
        data["companyId"] = this.companyId;
        data["phoneNumber"] = this.phoneNumber;
        data["idNumber"] = this.idNumber;
        data["idType"] = this.idType;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): UserProfile {
        const json = this.toJSON();
        let result = new UserProfile();
        result.init(json);
        return result;
    }
}

export interface IUserProfile {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    taxIdNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    addressId?: string;
    userId?: string;
    isEntrepreneur?: boolean;
    isInvestor?: boolean;
    companyId?: string | undefined;
    phoneNumber?: string | undefined;
    idNumber?: string | undefined;
    idType?: IDType;
    address?: IAddress;
    company?: ICompany;
    user?: IUser;
    fullName?: string | undefined;
}

export class UserRole implements IUserRole {
    userId?: string;
    roleId?: string;
    id?: string;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    role?: Role;
    user?: User;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.role = data.role && !(<any>data.role).toJSON ? new Role(data.role) : <Role>this.role;
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.creationDate = _data["creationDate"];
            this.createdById = _data["createdById"];
            this.modificationDate = _data["modificationDate"];
            this.modifiedById = _data["modifiedById"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creationDate"] = this.creationDate;
        data["createdById"] = this.createdById;
        data["modificationDate"] = this.modificationDate;
        data["modifiedById"] = this.modifiedById;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    userId?: string;
    roleId?: string;
    id?: string;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    role?: IRole;
    user?: IUser;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;
}

export enum UserStatus {
    Active = "Active",
    Disabled = "Disabled",
}

export class UserToken implements IUserToken {
    userId?: string;
    loginProvider?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    user?: User;
    id?: string;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.creationDate = _data["creationDate"];
            this.createdById = _data["createdById"];
            this.modificationDate = _data["modificationDate"];
            this.modifiedById = _data["modifiedById"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["creationDate"] = this.creationDate;
        data["createdById"] = this.createdById;
        data["modificationDate"] = this.modificationDate;
        data["modifiedById"] = this.modifiedById;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    userId?: string;
    loginProvider?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    user?: IUser;
    id?: string;
    creationDate?: string | undefined;
    createdById?: string | undefined;
    modificationDate?: string | undefined;
    modifiedById?: string | undefined;
}

export class ValidateRecaptchaCommandResponse implements IValidateRecaptchaCommandResponse {
    success?: boolean;
    errors?: string | undefined;

    constructor(data?: IValidateRecaptchaCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): ValidateRecaptchaCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateRecaptchaCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errors"] = this.errors;
        return data;
    }

    clone(): ValidateRecaptchaCommandResponse {
        const json = this.toJSON();
        let result = new ValidateRecaptchaCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IValidateRecaptchaCommandResponse {
    success?: boolean;
    errors?: string | undefined;
}

export class VerifyCardResponse implements IVerifyCardResponse {
    verificationSuccessful?: boolean;

    constructor(data?: IVerifyCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationSuccessful = _data["verificationSuccessful"];
        }
    }

    static fromJS(data: any): VerifyCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationSuccessful"] = this.verificationSuccessful;
        return data;
    }

    clone(): VerifyCardResponse {
        const json = this.toJSON();
        let result = new VerifyCardResponse();
        result.init(json);
        return result;
    }
}

export interface IVerifyCardResponse {
    verificationSuccessful?: boolean;
}

export class WeatherForecast implements IWeatherForecast {
    dateFormatted?: string | undefined;
    temperatureC?: number;
    summary?: string | undefined;
    readonly temperatureF?: number;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFormatted = _data["dateFormatted"];
            this.temperatureC = _data["temperatureC"];
            this.summary = _data["summary"];
            (<any>this).temperatureF = _data["temperatureF"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFormatted"] = this.dateFormatted;
        data["temperatureC"] = this.temperatureC;
        data["summary"] = this.summary;
        data["temperatureF"] = this.temperatureF;
        return data;
    }

    clone(): WeatherForecast {
        const json = this.toJSON();
        let result = new WeatherForecast();
        result.init(json);
        return result;
    }
}

export interface IWeatherForecast {
    dateFormatted?: string | undefined;
    temperatureC?: number;
    summary?: string | undefined;
    temperatureF?: number;
}

export class Body implements IBody {
    userName?: string;
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    confirmEmailAddress?: string;
    password?: string;
    confirmationPassword?: string;
    taxIdNumber?: string;
    articlesOfIncorporation?: any;
    proofOfTaxCompliance?: any;
    addressAddressType?: AddressType;
    addressLine1?: string;
    addressLine2?: string;
    addressCity?: string;
    addressStateParish?: string;
    addressPostalCode?: string;
    addressCountry?: string;
    addressCompanies?: Company[];
    addressUserProfiles?: UserProfile[];
    addressId?: string;
    addressCreatedBy?: string;
    addressCreatedById?: string;
    addressCreationDate?: string;
    addressModifiedBy?: string;
    addressModifiedById?: string;
    addressModificationDate?: string;
    phoneNumber?: string;
    companyName?: string;
    bankName?: string;
    bankAccountNumber?: string;
    bankAccountType?: string;
    bankCurrency?: string;
    bankCompanies?: Company[];
    bankId?: string;
    bankCreatedBy?: string;
    bankCreatedById?: string;
    bankCreationDate?: string;
    bankModifiedBy?: string;
    bankModifiedById?: string;
    bankModificationDate?: string;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.addressCompanies) {
                this.addressCompanies = [];
                for (let i = 0; i < data.addressCompanies.length; i++) {
                    let item = data.addressCompanies[i];
                    this.addressCompanies[i] = item && !(<any>item).toJSON ? new Company(item) : <Company>item;
                }
            }
            if (data.addressUserProfiles) {
                this.addressUserProfiles = [];
                for (let i = 0; i < data.addressUserProfiles.length; i++) {
                    let item = data.addressUserProfiles[i];
                    this.addressUserProfiles[i] = item && !(<any>item).toJSON ? new UserProfile(item) : <UserProfile>item;
                }
            }
            if (data.bankCompanies) {
                this.bankCompanies = [];
                for (let i = 0; i < data.bankCompanies.length; i++) {
                    let item = data.bankCompanies[i];
                    this.bankCompanies[i] = item && !(<any>item).toJSON ? new Company(item) : <Company>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.emailAddress = _data["EmailAddress"];
            this.confirmEmailAddress = _data["ConfirmEmailAddress"];
            this.password = _data["Password"];
            this.confirmationPassword = _data["ConfirmationPassword"];
            this.taxIdNumber = _data["TaxIdNumber"];
            this.articlesOfIncorporation = _data["ArticlesOfIncorporation"];
            this.proofOfTaxCompliance = _data["ProofOfTaxCompliance"];
            this.addressAddressType = _data["Address.AddressType"];
            this.addressLine1 = _data["Address.Line1"];
            this.addressLine2 = _data["Address.Line2"];
            this.addressCity = _data["Address.City"];
            this.addressStateParish = _data["Address.StateParish"];
            this.addressPostalCode = _data["Address.PostalCode"];
            this.addressCountry = _data["Address.Country"];
            if (Array.isArray(_data["Address.Companies"])) {
                this.addressCompanies = [] as any;
                for (let item of _data["Address.Companies"])
                    this.addressCompanies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["Address.UserProfiles"])) {
                this.addressUserProfiles = [] as any;
                for (let item of _data["Address.UserProfiles"])
                    this.addressUserProfiles!.push(UserProfile.fromJS(item));
            }
            this.addressId = _data["Address.Id"];
            this.addressCreatedBy = _data["Address.CreatedBy"];
            this.addressCreatedById = _data["Address.CreatedById"];
            this.addressCreationDate = _data["Address.CreationDate"];
            this.addressModifiedBy = _data["Address.ModifiedBy"];
            this.addressModifiedById = _data["Address.ModifiedById"];
            this.addressModificationDate = _data["Address.ModificationDate"];
            this.phoneNumber = _data["PhoneNumber"];
            this.companyName = _data["CompanyName"];
            this.bankName = _data["Bank.Name"];
            this.bankAccountNumber = _data["Bank.AccountNumber"];
            this.bankAccountType = _data["Bank.AccountType"];
            this.bankCurrency = _data["Bank.Currency"];
            if (Array.isArray(_data["Bank.Companies"])) {
                this.bankCompanies = [] as any;
                for (let item of _data["Bank.Companies"])
                    this.bankCompanies!.push(Company.fromJS(item));
            }
            this.bankId = _data["Bank.Id"];
            this.bankCreatedBy = _data["Bank.CreatedBy"];
            this.bankCreatedById = _data["Bank.CreatedById"];
            this.bankCreationDate = _data["Bank.CreationDate"];
            this.bankModifiedBy = _data["Bank.ModifiedBy"];
            this.bankModifiedById = _data["Bank.ModifiedById"];
            this.bankModificationDate = _data["Bank.ModificationDate"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["EmailAddress"] = this.emailAddress;
        data["ConfirmEmailAddress"] = this.confirmEmailAddress;
        data["Password"] = this.password;
        data["ConfirmationPassword"] = this.confirmationPassword;
        data["TaxIdNumber"] = this.taxIdNumber;
        data["ArticlesOfIncorporation"] = this.articlesOfIncorporation;
        data["ProofOfTaxCompliance"] = this.proofOfTaxCompliance;
        data["Address.AddressType"] = this.addressAddressType;
        data["Address.Line1"] = this.addressLine1;
        data["Address.Line2"] = this.addressLine2;
        data["Address.City"] = this.addressCity;
        data["Address.StateParish"] = this.addressStateParish;
        data["Address.PostalCode"] = this.addressPostalCode;
        data["Address.Country"] = this.addressCountry;
        if (Array.isArray(this.addressCompanies)) {
            data["Address.Companies"] = [];
            for (let item of this.addressCompanies)
                data["Address.Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.addressUserProfiles)) {
            data["Address.UserProfiles"] = [];
            for (let item of this.addressUserProfiles)
                data["Address.UserProfiles"].push(item.toJSON());
        }
        data["Address.Id"] = this.addressId;
        data["Address.CreatedBy"] = this.addressCreatedBy;
        data["Address.CreatedById"] = this.addressCreatedById;
        data["Address.CreationDate"] = this.addressCreationDate;
        data["Address.ModifiedBy"] = this.addressModifiedBy;
        data["Address.ModifiedById"] = this.addressModifiedById;
        data["Address.ModificationDate"] = this.addressModificationDate;
        data["PhoneNumber"] = this.phoneNumber;
        data["CompanyName"] = this.companyName;
        data["Bank.Name"] = this.bankName;
        data["Bank.AccountNumber"] = this.bankAccountNumber;
        data["Bank.AccountType"] = this.bankAccountType;
        data["Bank.Currency"] = this.bankCurrency;
        if (Array.isArray(this.bankCompanies)) {
            data["Bank.Companies"] = [];
            for (let item of this.bankCompanies)
                data["Bank.Companies"].push(item.toJSON());
        }
        data["Bank.Id"] = this.bankId;
        data["Bank.CreatedBy"] = this.bankCreatedBy;
        data["Bank.CreatedById"] = this.bankCreatedById;
        data["Bank.CreationDate"] = this.bankCreationDate;
        data["Bank.ModifiedBy"] = this.bankModifiedBy;
        data["Bank.ModifiedById"] = this.bankModifiedById;
        data["Bank.ModificationDate"] = this.bankModificationDate;
        return data;
    }

    clone(): Body {
        const json = this.toJSON();
        let result = new Body();
        result.init(json);
        return result;
    }
}

export interface IBody {
    userName?: string;
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    confirmEmailAddress?: string;
    password?: string;
    confirmationPassword?: string;
    taxIdNumber?: string;
    articlesOfIncorporation?: any;
    proofOfTaxCompliance?: any;
    addressAddressType?: AddressType;
    addressLine1?: string;
    addressLine2?: string;
    addressCity?: string;
    addressStateParish?: string;
    addressPostalCode?: string;
    addressCountry?: string;
    addressCompanies?: ICompany[];
    addressUserProfiles?: IUserProfile[];
    addressId?: string;
    addressCreatedBy?: string;
    addressCreatedById?: string;
    addressCreationDate?: string;
    addressModifiedBy?: string;
    addressModifiedById?: string;
    addressModificationDate?: string;
    phoneNumber?: string;
    companyName?: string;
    bankName?: string;
    bankAccountNumber?: string;
    bankAccountType?: string;
    bankCurrency?: string;
    bankCompanies?: ICompany[];
    bankId?: string;
    bankCreatedBy?: string;
    bankCreatedById?: string;
    bankCreationDate?: string;
    bankModifiedBy?: string;
    bankModifiedById?: string;
    bankModificationDate?: string;
}

export enum Operations {
    Is_Authenticated = "Is Authenticated",
    Login_to_Admin = "Login to Admin",
    Create_users = "Create users",
    Modify_users = "Modify users",
    View_users = "View users",
    Request_user_password_reset = "Request user password reset",
    Deactivate_users = "Deactivate users",
    Activate_users = "Activate users",
    Delete_users = "Delete users",
    View_roles = "View roles",
    Create_user_roles = "Create user roles",
    Modify_user_roles = "Modify user roles",
    Delete_user_roles = "Delete user roles",
    Assign_user_roles = "Assign user roles",
    Assign_Permissions = "Assign Permissions",
    Remove_Permissions = "Remove Permissions",
    Add_Special_User_Operation = "Add Special User Operation",
    Edit_Special_User_Operation = "Edit Special User Operation",
    Remove_Special_User_Operation = "Remove Special User Operation",
    View_all_payments = "View all payments",
    View_all_donations = "View all donations",
    Create_Project = "Create Project",
    Edit_Project = "Edit Project",
    Deactivate_Project = "Deactivate Project",
    Submit_Project = "Submit Project",
    Invite_Project_User = "Invite Project User",
    Remove_Project_User = "Remove Project User",
    Deactivate_Project_User = "Deactivate Project User",
    Activate_Project_User = "Activate Project User",
    Invest_In_Project = "Invest In Project",
    Create_Company = "Create Company",
    Edit_Company = "Edit Company",
    Submit_Company = "Submit Company",
    View_audit = "View audit",
    View_Reports = "View Reports",
    Login_Attempt = "Login Attempt",
    View_Company_Details = "View Company Details",
    View_Project_Details = "View Project Details",
    Approve_Project = "Approve Project",
    Advise_Project = "Advise Project",
    Second_Approve_Project = "Second Approve Project",
    Comment_As_Approver = "Comment As Approver",
    View_Investor_Payment_List = "View Investor Payment List",
    Download_Any_Receipt = "Download Any Receipt",
    Download_Company_Receipt = "Download Company Receipt",
    Create_News = "Create News",
    Edit_News = "Edit News",
    View_News = "View News",
    Approve_News = "Approve News",
    Publish_News = "Publish News",
    Archive_News = "Archive News",
    Edit_Landing_Images = "Edit Landing Images",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}